/*
 * The game's words in Turkish (the key list) and English. Russian, French and German are in
 * lang/; i18n.ts puts them to use.
 */

export const tr = {
  'menu.subtitle': 'Havalimanını kur, işlet, birlikte büyüt.',
  'build.perTile': ' / kare',
  'menu.defaultPlayer': 'Oyuncu',
  'city.istanbul': 'İstanbul',
  'city.london': 'Londra',
  'city.berlin': 'Berlin',
  'city.dubai': 'Dubai',
  'city.rome': 'Roma',
  'city.paris': 'Paris',
  'city.amsterdam': 'Amsterdam',
  'city.vienna': 'Viyana',
  'city.athens': 'Atina',
  'city.madrid': 'Madrid',
  'city.baku': 'Bakü',
  'city.doha': 'Doha',
  'menu.singleSub': 'Kendi havalimanını sıfırdan kur',
  'menu.coop': 'Co-op',
  'menu.coopSub': '2–4 oyuncu, aynı havalimanında',
  'menu.settings': 'Ayarlar',
  'menu.settingsSub': 'Grafik ve dil',
  'menu.gallery': 'Model galerisi',
  'menu.gallerySub': 'Binalar, uçaklar ve hava durumu',
  'menu.academy': 'Akademi',
  'menu.academySub': 'Kılavuz, dersler ve bina tabloları',
  'menu.singleTitle': 'Yeni havalimanı',
  'menu.coopTitle': 'Co-op',
  'menu.settingsTitle': 'Ayarlar',
  'menu.singleLead':
    'Boş bir arazi ve sınırlı bir bütçeyle başla. Kuleyi dik, pisti ve terminali kur; havayollarını ikna et ve havalimanını büyüt.',
  'menu.feature.build': 'Hazır binalar, seviye seviye yükseltme ve arazi satın alma',
  'menu.feature.flights': 'Gerçekçi trafik: pist yönü, rüzgâr, sis, taksi ve turnaround',
  'menu.feature.ops': 'Yolcular, yer hizmeti filosu, bakım ve rötar analizi',
  'menu.feature.weather':
    'Gün döngüsü ve değişen hava: yağmur, sis, kar, buzlanma ve kum fırtınası',
  'menu.start': 'Oyuna başla',
  'menu.coopLead':
    'Arkadaşlarınla aynı havalimanını birlikte yönetin. Biri oda kurar, diğerleri oda koduyla katılır.',
  'menu.host': 'Oda kur',
  'menu.hostSub': 'Kodu arkadaşlarınla paylaş',
  'menu.join': 'Katıl',
  'menu.joinSub': '5 harfli oda kodunu yaz',
  'menu.language': 'Dil',
  'board.departures': 'Kalkışlar',
  'board.onTime': 'Zamanında',
  'board.boarding': 'Biniş',
  'board.gateClosed': 'Kapı kapandı',
  'board.departed': 'Kalktı',
  'menu.name': 'Oyuncu adı',
  'menu.singleplayer': 'Tek oyunculu',
  'menu.hostCoop': 'Co-op oda kur',
  'menu.joinCoop': 'Odaya katıl',
  'menu.roomCode': 'Oda kodu',
  'menu.relayUrl': 'Sunucu adresi',
  'menu.connecting': 'Bağlanıyor…',
  'menu.coopHint': 'Co-op için relay sunucusu gerekir: pnpm relay',
  'settings.graphics': 'Grafik',
  'graphics.high': 'Yüksek',
  'graphics.medium': 'Orta',
  'graphics.low': 'Düşük',
  'hud.day': '{day}. Gün',
  'building.grantSign': 'Teşvik Tabelası',
  'desc.grantSign':
    'Devlet teşvik primi şartı: "Bu Havalimanı Devlet Teşvik Priminden Faydalanmıştır" yazan büyük tabela.',
  'ready.road': 'Terminal karayoluyla otoyola bağlı',
  'req.runway': 'Pist Sv.{level}',
  'reason.requiresGrant': 'Önce devlet teşvik primini kabul et',
  'toast.grantOffered': 'Devlet teşvik primi teklif edildi! Uçuşlar → Teklifler',
  'toast.grantFulfilled': 'Teşvik şartı yerine getirildi: tabela dikildi',
  'toast.grantRepaid': 'Tabela zamanında dikilmedi: teşvik primi geri ödendi',
  'grant.title': 'Devlet Teşvik Primi',
  'grant.program': 'Bölgesel Havalimanları Teşvik Programı',
  'grant.condition':
    'Şart: 3 gün içinde havalimanına "Bu Havalimanı Devlet Teşvik Priminden Faydalanmıştır" yazan büyük bir tabela dikilecek.',
  'grant.clawback': 'Tabela zamanında dikilmezse prim geri alınır.',
  'grant.accept': 'Kabul et',
  'grant.decline': 'Reddet',
  'grant.signDue': 'Teşvik şartı: tabelayı dik',
  'grant.signLeft': 'Kalan süre: {h} saat',
  'grant.placeSign': 'Tabelayı yerleştir',
  'tip.7': 'Yolcular karayoluyla gelir: terminali bir yolla otoyola bağla.',
  'hud.budget': 'Bütçe',
  'hud.todayNet': 'Bugünün net kazancı',
  'hud.speed': 'Oyun hızı',
  'hud.level': 'Sv.{level}',
  'hud.leaveConfirm': 'Emin misin? Ana menüye dön',
  'hud.drawHint': 'sürükle: 4×4 bloklar, yakındaki yola kendiliğinden bağlanır',
  'hud.moveHint': 'Yeni yerine tıkla · R döndür · Esc vazgeç',
  'hud.close': 'Kapat',
  'catalog.title': 'İnşa et',
  'catalog.rotateHint': 'R: döndür · Esc: iptal',
  'ops.subtitle': 'Teklifler, sözleşmeler ve uçuş tablosu',
  'tip.title': 'İpucu:',
  'tip.0': 'Taksi yolunu pistin uzun kenarına ve standın kenarına değecek şekilde çiz.',
  'tip.1':
    'Hafif siste Sv.3 pistin CAT I ILS’i yeter; yoğun siste yalnızca CAT III (Pist Sv.4) çalışır.',
  'tip.2': 'Yer Hizmetleri Üssü taşeron ücretini bitirir ama araç sayısını iyi ayarla.',
  'tip.3': 'Uçuş tablosunda bir satıra tıkla: rötarın nedenini gösterir.',
  'tip.4': 'Hangar arızaları azaltır ve her kalkıştan bakım geliri getirir.',
  'tip.5': 'Memnun havayolları sözleşme bitince yenileme teklif eder.',
  'tip.6': 'Arka rüzgâr 5 knotu geçince kule pistin yönünü kendiliğinden çevirir.',
  'hud.pause': 'Duraklat',
  'hud.room': 'Oda',
  'hud.offline': 'Tek oyunculu',
  'hud.leave': 'Ana menü',
  'hud.ping': '{ms} ms',
  'crews.title': 'İnşaat ekipleri · {busy}/{total} meşgul',
  'crews.none': 'Şu an inşaat yok: bütün ekipler boşta.',
  'crews.show': 'Göster',
  'crews.free': 'Boştaki ekip: {n}',
  'crews.allBusy':
    "Bütün ekipler meşgul: biri bitince yeni inşaat başlar. İnşaat Ofisi'nin her seviyesi bir ekip daha getirir.",
  'full.title': 'Tam Sürüm',
  'full.unlock': 'Tam Sürüm ile aç',
  'full.reason.building': "Bu bina Tam Sürüm'de",
  'full.reason.upgrade': "Bu seviye Tam Sürüm'de",
  'full.reason.tower': "Kulenin 3. seviyesi ve ötesi Tam Sürüm'de",
  'full.reason.junction': "Bağlantı yolu Tam Sürüm'de",
  'full.reason.map': "Geniş harita Tam Sürüm'de",
  'full.reason.coop': "Co-op odası kurmak Tam Sürüm'de (katılmak ücretsiz)",
  'full.lead':
    'Oyunun kule {level}. seviyeye kadarki kısmı ücretsiz. Tam Sürüm, havalimanını büyütmeye devam etmek için her şeyi açar:',
  'full.opens.tower': 'Kule 3, 4 ve 5. seviye ile açtıkları',
  'full.opens.aircraft': 'Geniş gövde, jumbo ve dev kargo uçakları',
  'full.opens.city': 'Havalimanı şehri: AVM, iş merkezi, restoranlar',
  'full.opens.military': 'Askeri bölge, savaş uçakları, üçüncü pist ve terminal',
  'full.opens.map': 'Geniş harita (384×384)',
  'full.opens.coop': 'Arkadaşlarınla co-op odası kurmak',
  'full.once':
    'Tek seferlik satın alma: reklam yok, abonelik yok. Aynı Google hesabıyla diğer Android cihazlarında da geçerli.',
  'full.buy': 'Satın al',
  'full.buyPrice': 'Satın al · {price}',
  'full.restore': 'Satın almayı geri yükle',
  'full.later': 'Şimdi değil',
  'full.thanks': 'Teşekkürler! Tam Sürüm açıldı.',
  'full.cancelled': 'Satın alma tamamlanmadı.',
  'full.pending': 'Ödeme bekleniyor: tamamlanınca Tam Sürüm kendiliğinden açılır.',
  'full.nothingToRestore': 'Bu Google hesabında Tam Sürüm satın alması bulunamadı.',
  'hud.crews': 'İnşaat ekipleri',
  'hud.tower': 'Kule',
  'hud.controls':
    'WASD kaydır · Q/E döndür · Tekerlek yakınlaştır · R binayı çevir · Space duraklat · Esc iptal',
  'hint.start': 'İlk adım: İnşa menüsünden bir Kontrol Kulesi yerleştir.',
  'hint.next':
    'Kule hazır! Şimdi terminal, pist ve stand yerleştir; taksi yolu ve sarı çizgiyle bağla.',
  'tool.select': 'Seç',
  'tool.land': 'Arazi',
  'tool.build': 'İnşa',
  'tool.road': 'Karayolu',
  'tool.taxiway': 'Taksi yolu',
  'tool.bulldoze': 'Buldozer',
  'tool.junction': 'Kavşak',
  'tool.toll': 'Gişe',
  'tool.service': 'Servis yolu',
  'news.specialLivery': 'Özel boyalı uçaklar',
  'news.specialLivery.text':
    'Gelen uçakların yaklaşık otuzda biri havayolunun yıldönümü boyasıyla gelir: altın, retro turuncu, kraliyet moru ya da camgöbeği. Uçağa tıklayınca uçuş kartında görünür.',
  'news.vipCarpet': 'VIP’lere kırmızı halı',
  'news.vipCarpet.text':
    'VIP yolcunun uçağı standa yanaşınca ön kapısından altın direkli bir kırmızı halı serilir ve halının ucunda siyah bir makam aracı bekler.',
  'news.vip': 'VIP yolcular',
  'news.vip.text':
    'Kule Sv.2 olunca zaman zaman ünlü biri panodaki bir uçuşa bilet alır: bir bakan, bir rock yıldızı, bir iş insanı ya da koca bir futbol takımı. Haber bir saat önceden gelir; uçuş zamanında ve herkes binmiş olarak kalkarsa teşekkür ödemesi alırsın, havalimanı da övgüyle anılır. Rötar ya da iptal ise kötü manşet demek. Uçuş kartında VIP damgası olur.',
  'news.dailyGoals': 'Günlük görevler',
  'news.dailyGoals.text':
    'Her sabah havalimanına göre üç görev gelir: bugün şu kadar kalkış, yolcu, gelir ya da kargo; gün boyu dakiklik ya da hiç iptal olmaması. Görevler dünkü rakamların biraz üstündedir ve havalimanınla birlikte büyür; tamamlayınca ödül anında hesabına geçer. Hedefler panelinde ilerlemeyi görebilirsin.',
  'news.helicopters': 'Helikopter pisti ve özel helikopterler',
  'news.helicopters.text':
    'Yeni bina: helikopter pisti (kule Sv.1). Yola bağlayınca helikopter işletmecileri (Boğaz Helikopter, Anadolu Heli VIP, SkyTaxi Rotor) günde birkaç seferlik sözleşmeler teklif eder. Helikopterler pist ve taksi yolu kullanmadan doğrudan pistine iner, birkaç dakika bekler, yolcularını alıp dikine kalkar; yolcular arabayla doğrudan piste gelir. Bir helikoptere tıklayınca uçuş kartı açılır.',
  'news.flightCard': 'Uçağa tıkla: uçuş kartı',
  'news.flightCard.text':
    'Bir uçağa tıklayınca uçuşu kâğıt üstünde açılır: havayolunun renklerinde uçağın çizimi, durumu, park yeri, geliş ve kalkış saati, yolcular ya da kargo, yer hizmetlerinin ilerlemesi. Kart oyunu kapatmaz; uçak kalkıp gidince kendiliğinden kaybolur. Kamerayla izlemek için karttaki düğmeyi kullan.',
  'news.standsEasier': 'Körüklü standlar daha kolay',
  'news.standsEasier.text':
    'Terminali yerleştirirken körüklü standların gelebileceği dört yer zeminde görünür; terminali ona göre çevirebilirsin. Körüklü stand kendi servis yoluyla gelir: en yakın yola kısa bir servis yolu kendiliğinden döşenir, sen yalnızca taksi yolunu bağlarsın. Kullanılan bir park yeri ya da pist artık yıkılamaz; uçak gittikten sonra yıkılır.',
  'news.smoother': 'Daha akıcı ve sağlam',
  'news.smoother.text':
    'Bir görüntü katmanı hata verse bile oyun artık donmaz; ekran kartı bağlantısı koparsa oyun kendini yeniden başlatıp kaldığı yerden sürer. Yoğun havalimanlarında uçak çiziminden gelen ani takılmalar azaldı. Yol çizerken şerit fareyi kare kare değil kesintisiz izler. Yağmur daha seyrek ve daha kısa; havalimanı tabelası artık yalnızca ana girişte.',
  'news.worldRanking': 'Dünya sıralaması: dünya puanı',
  'news.worldRanking.text':
    'Genel sıralama artık sunucunun hesapladığı dünya puanına göre: başarım puanın, en değerli havalimanın ve en iyi puanın toplanır. Herkes tüm başarımları ve 5★ alsa da sıralama kilitlenmez; sırayı havalimanının değeri belirler. Listenin aşağısındaysan hemen üstündeki ve altındaki oyuncuları da görürsün; dünya sıran profilinde yazar.',
  'news.winterOps': 'Kışın pistler: kar küreme ekibi',
  'news.winterOps.text':
    'Kış artık gerçek: kar ara ara yağıyor (hafif, orta, yoğun), yer önce lekelenip sonra bembeyaz oluyor ve kış boyunca erimiyor. Her kış bir kar fırtınası geliyor, meteoroloji 6 saat önceden uyarıyor. Yoğun karda ekipler yetişemezse pist kapanıyor; uyarı bandındaki ya da pistin üstündeki düğmeyle kar küreme ekibini sen gönderiyorsun: araçlar üsten çıkıyor, pisti kademeli dizilişte iki turda küreyip karı kenarlara savuruyor ve dönüyor.',
  'news.achievements': 'Rozetli başarımlar',
  'news.achievements.text':
    'Bir başarım açılınca rozeti ışıltıyla ekrana gelip birkaç saniyede kayboluyor. 11 yeni başarım var: özel jet, hava üssü, metro, körüklü köprüler, simge terminal ve yeni Altyapı grubu. Profilinde rütbe amblemin ve en iyi rozetlerinin vitrini duruyor.',
  'news.art': 'Reklam panoları, tabelalar ve ufuk',
  'news.art.text':
    'Otoyol boyunca iki yüzlü reklam panoları dikildi: geceleri lambalarıyla aydınlanıyor, arazisini satın alınca kalkıyor. Terminal girişinde LED yazı dönüyor, kaldırımda ışıklı totemler, binalarda yön tabelaları var; afişler oyunun dilinde. Uzakta, pusun içinde tepeler ve bir şehir görünüyor, geceleri şehrin ışıkları yanıyor. Havayollarının simgeleri rozetlerde ve uçak kuyruklarında; sosyal akışta yolcuların yüzleri var.',
  'news.weather': 'Şimşek, kar ve kış',
  'news.weather.text':
    'Fırtınada dallanan yıldırımlar çakıyor ve geceyi bir anlığına aydınlatıyor; gök gürültüsü uzaklığa göre gecikmeli geliyor. Yağmurlu gecelerde bulutlar uzaktan çakıyor. Kışın kar yumuşak tanelerle yağıyor; çimler, yollar ve ağaç tepeleri beyazlıyor, soğuk gecelerde çimde kırağı oluyor. Yeni mevsim gelince haber verilir. Fotoğraf modunda havayı (fırtına, kar, karlı kış) seçip deneyebilirsin.',
  'news.lanes': 'Şeritlerinde giden trafik',
  'news.lanes.text':
    'Arabalar ve yer araçları boyalı şeritlerde gidiyor, sola dönmeden önce iç şeride geçiyor, kaldırıma binayı sağına alarak yanaşıp sıraya giriyor; yolun ortasında U dönüşü yok. Yer araçları stanta yolun doğru tarafından giriyor ve birbirine yol veriyor.',
  'news.captain': 'Kaptan ve yeni öğretici',
  'news.captain.text':
    'Kaptan seni karşılıyor ve temel dersleri büyük, resimli bir kartta adım adım anlatıyor.',
  'toast.season0': 'İlkbahar geldi 🌱 Ağaçlar yeşeriyor, talep normale dönüyor.',
  'toast.season1': 'Yaz geldi ☀️ Tatil sezonu: uçaklar dolu, sıcak günlerde fırtına çıkabilir.',
  'toast.season2': 'Sonbahar geldi 🍂 Yapraklar sararıyor, talep biraz düşüyor.',
  'toast.season3': 'Kış geldi ❄️ Kar ve buzlanma bekleniyor: buz çözme ve kar küreme hazır olsun.',
  'photo.weather': 'Hava',
  'photo.weather.game': 'Oyundaki',
  'photo.weather.clear': 'Açık',
  'photo.weather.rain': 'Yağmur',
  'photo.weather.storm': 'Fırtına',
  'photo.weather.snow': 'Kar',
  'photo.weather.winter': 'Karlı kış',
  'photo.weather.dust': 'Kum fırtınası',
  'toast.desertSeason0':
    'İlkbahar geldi 🌱 Çölde ılık günler: rüzgârlı öğleden sonralar kum fırtınası getirebilir.',
  'toast.desertSeason1':
    'Yaz geldi 🔥 Kavurucu sıcak: öğleden sonraları 40°C’yi aşar, kum fırtınalarına hazır ol.',
  'toast.desertSeason2': 'Sonbahar geldi 🍂 Sıcak dinmeye başlıyor, talep biraz düşüyor.',
  'toast.desertSeason3': 'Kış geldi 🌙 Ilık günler, soğuk geceler: çölde kar yağmaz, buz tutmaz.',
  'toast.alpineSeason0': 'İlkbahar geldi 🌱 Karlar eriyor; vadide sabah sisi sık görülür.',
  'toast.alpineSeason1':
    'Yaz geldi ☀️ Serin dağ yazı: uçaklar dolu, öğleden sonra fırtına çıkabilir.',
  'toast.alpineSeason2': 'Sonbahar geldi 🍂 Huşlar sararıyor, ilk kar zirvelere düşüyor.',
  'toast.alpineSeason3':
    'Kış geldi ❄️ Sert dağ kışı: bol kar, buzlanma ve kar fırtınası. Kar ekiplerini ve buz çözmeyi büyüt.',
  'news.graphics': 'Yumuşak ışık ve akıllı ölçekleme',
  'news.graphics.text':
    'Işıklar yumuşadı: gece projektörleri apronu artık beyaza patlatmıyor, beton ve beyaz boyalar gerçek renklerine indi, gökyüzü dolgu ışığı arttı, gölge kenarları yumuşadı, bina duvarları zemine doğru koyulaşıyor ve panel derzleri var. Yeni ayar: Akıllı ölçekleme (DLSS / FSR 2 gibi, her ekran kartında): sahne daha düşük çözünürlükte çizilip önceki karelerle keskin tam görüntüye kurulur; sahne artık bir kez çizildiği için Yüksek ayarda kare süresi yaklaşık %20 kısaldı.',
  'news.contactStands': 'Körüklü standlar ve metro',
  'news.contactStands.text':
    'Yeni bina: körüklü stand. Terminale yaslanır; uzun apron yüzüne 2, iki ucuna birer tane sığar, yerleştirirken en yakın boş yere kendiliğinden oturur. Yolcular körükle iner biner, otobüs gerekmez. Stand Sv.2 artık köprü değil: yakıt hidrant çukurları ve kendi ekipmanıyla yer hizmetleri %25 hızlı. Terminal olanaklarına metro istasyonu geldi (terminal Sv.3): yolcuların %20si metroyla gelir, yol yükü düşer; terminalin önünde metro girişi belirir.',
  'news.motorwayLink': 'Otoyol ayrıldı, kavşak kendiliğinden',
  'news.motorwayLink.text':
    'Köprülü otoyol artık karayolunun biraz güneyinden geçiyor; havalimanının bağlandığı yol altta, normal karayolu olarak kalıyor. Havalimanını karayoluna ilk bağladığında oradan otoyola bir bağlantı yolu ve iniş-çıkış rampaları kendiliğinden yapılır; ikinci bir giriş yeni rampa getirmez. Köprünün ve rampaların altına bina ya da taksi yolu yapılamaz, karayolu geçebilir.',
  'news.viaduct': 'Köprülü otoyol',
  'news.viaduct.text':
    'Otoyol artık iki tünel arasında ayaklar üstünde 8 şeritli bir viyadük; transit trafik yukarıda kesintisiz akar. Havalimanı kavşağında her iki yöne iniş ve çıkış rampaları var. Havalimanına sapan araçlar uçuşlardan gelir: yaklaşık 10 yolcuya bir araç; uçuş yoksa kimse sapmaz. Yoğun trafikte işlemci yükü yarıdan fazla azaldı.',
  'hud.serviceHint':
    'sürükle: 2 şeritli servis yolu; yer hizmetleri, itfaiye ve havalimanı araçları kullanır (daha hızlı), sivil trafik giremez; taksi yolunu ya da karayolunu keserse altından tünelle geçer',
  'news.serviceRoads': 'Servis yolları',
  'news.serviceRoads.text':
    'Yeni araç (9): servis yolu. Yer hizmeti araçları, yakıt, ikram, itfaiye ve havalimanı araçları servis yolunu tercih eder ve orada daha hızlıdır; sivil trafik ve yolcu araçları giremez. Stantlar ve yer hizmeti üsleri servis yoluyla da bağlanabilir. Yol fırçası artık bina ile yol arasındaki bir karelik boşluğu da doldurur.',
  'hud.junctionHint': 'bir kavşağa tıkla: trafik ışığı, akıllı ışık ya da bağlantı yolu',
  'hud.tollHint':
    'bir karayoluna tıkla: gişe yolun tüm genişliğini kaplar; terminale giden yoldaysa her yolcu 0,50 $ öder; gişeye tıklamak kaldırır',
  'junction.title': 'Kavşak',
  'junction.kind.0': 'Öncelikli kavşak',
  'junction.kind.1': 'Trafik ışıkları',
  'junction.kind.2': 'Akıllı trafik ışıkları',
  'junction.kind.3': 'Bağlantı yolu',
  'junction.desc.0':
    'İlk gelen geçer; otoyolu kesip dönenler boşluk bekler, uzun bekleyene yol verilir. Az trafikte yeter.',
  'junction.desc.1':
    'Yönler sırayla yeşil yanar: dönenler otoyol trafiğini beklemeden geçer. Kapasite neredeyse iki katı.',
  'junction.desc.2':
    'Sensörlü ışıklar: yeşili kuyruğun olduğu yöne verir, boş yöne yakmaz. Yoğun saatlerde fark yaratır.',
  'junction.desc.3':
    'Havalimanı trafiği otoyoldan kendi şeridiyle ayrılır: kimse kimseyi beklemez, otoyol yoğunluğundan etkilenmez. Büyük havalimanlarının girişi.',
  'junction.ways':
    'Otoyoldan terminale giden giriş sayısı: {n}. Her giriş kendi kapasitesini ekler.',
  'junction.fix.title': 'Girişi rahatlatmanın yolları',
  'junction.fix.slip':
    'Bu otoyol kavşağını bağlantı yoluna çevir (kule Sv.{n}): havalimanı trafiği kendi şeridiyle ayrılır, otoyolun yoğun saatinden etkilenmez.',
  'junction.fix.second':
    'Otoyoldan terminale ikinci (ya da üçüncü) bir yol çek: her giriş ayrı bir kapasite, trafik bölünür.',
  'junction.fix.transit':
    'Otobüs istasyonu, tren istasyonu ya da metro kur ve terminale bağla: yolcuların bir kısmı yola hiç çıkmaz.',
  'junction.fix.inner':
    'Bu kavşak içeride: darboğazsa ışık koy ya da trafiği bölen ikinci bir yol aç.',
  'junction.cars': '{n} araç/dk',
  'junction.here': 'Bu kavşak',
  'junction.queue': 'Şu an ışıkta/çizgide bekleyen: {n} araç',
  'junction.motorway': 'Otoyoldan geçen: {n} araç/dk',
  'junction.rush': 'yoğun saat',
  'junction.now': 'şimdi {n}',
  'junction.share': 'Havalimanına kalan kapasite: {n} araç/dk',
  'junction.loadNote':
    'Yük: kalkışa yetişmek için gelen yolcuların araçlarının, girişin en dar kavşağındaki kapasiteye ({n} araç/dk) oranı. Otoyoldan geçenler kapasiteyi azaltır ama yüke sayılmaz.',
  'junction.current': 'Şu an',
  'junction.build': 'Kur · {cost}',
  'junction.revert': 'Bu düzene dön (ücretsiz)',
  'junction.tower': 'Kule seviyesi {n} gerekli',
  'junction.road': 'Havalimanı girişi',
  'junction.load': 'Giriş yükü: %{n}',
  'junction.waiting': '{n} yolcu trafikte bekliyor',
  'junction.flowing': 'Trafik akıyor',
  'junction.bottleneck': 'Terminale giden yolun en dar kavşağı bu.',
  'junction.elsewhere': 'Terminale giden yolun darboğazı başka bir kavşak.',
  'junction.none': 'Burada kavşak yok: iki yolun kesiştiği yere tıkla.',
  'toast.roadJam':
    'Havalimanı girişi tıkandı: {n} yolcu trafikte. Kavşak aracıyla (8) kavşağa tıkla: ışık, bağlantı yolu, ikinci bir giriş ya da toplu taşıma.',
  'news.roadJunctions': 'Kavşaklar ve trafik ışıkları',
  'news.roadJunctions.text':
    'Yolcular artık terminale yoldan geliyor: girişteki en dar kavşak dakikada kaç araç geçeceğini belirler; otoyolun sabah ve akşam yoğun saatleri bu kapasiteden pay alır. Tıkanınca yolcular yolda kalır, uçağı kaçırır. Kavşak aracıyla (8) trafik ışığı, akıllı ışık ya da köprülü kavşak kur. Yol aracıyla yolsuz bir binaya tıklayınca yolu tek seferde bağlar; apron araçları da artık birbirini kilitlemez.',
  'building.tower': 'Kontrol Kulesi',
  'building.terminal': 'Terminal',
  'building.runway': 'Pist (eski)',
  'building.mainRunway': 'Pist',
  'desc.mainRunway':
    'Uçakların indiği ve kalktığı pist; seviye atladıkça büyür, ikinci bir pist ancak kapasite için gerekir. Sv.1 dar pist: küçük uçaklar, özel jetler, bölgesel jetler (gündüz). Sv.2 daha geniş: dar gövdeler. Sv.3 pist ışıkları (gece uçuşu) ve CAT I ILS. Sv.4 yaklaşma ışıkları, CAT III ILS (yoğun sis) ve geniş gövdeler. Sv.5 en geniş pist: jumbo ve dev kargo uçakları dahil hepsi; yalnız büyük uçaklara ayrılabilir. Arazisi baştan 64×6; taksi yoluna bağla. Yükseltme sırasında pist kapanır.',
  'building.stand': 'Stand',
  'building.spotterDeck': 'İzleme Terası',
  'desc.spotterDeck':
    'Uçak meraklılarının ve ailelerin kalkışları izlediği teras ve kafe. Gündüz, gördüğü pistten (40 kare içinde) her kalkış ziyaretçi geliri getirir (geniş gövde 2 kat, askeri jet 3 kat) ve havalimanı hakkında konuşulmasını sağlar. Yola bağlı olmalı.',
  'building.helipad': 'Helikopter Pisti',
  'desc.helipad':
    'Özel helikopterler burada iner ve kalkar; yolcuları arabayla doğrudan piste gelir. Yola bağlı olmalı. Helikopter işletmecileri sözleşme teklif etmeye başlar.',
  'building.contactStand': 'Körüklü Stand',
  'desc.contactStand':
    'Terminale yaslanan stand: yolcular körükle (yolcu köprüsü) iner biner, otobüs ve merdiven gerekmez; iniş-biniş çok hızlı, konfor yüksek. Terminalin uzun apron yüzüne 2, iki kısa ucuna birer tane sığar; karayolu tarafına konmaz. Dar gövdeye kadar uçak alır (geniş gövde büyük standa gider). Taksi yoluna ve yer hizmetleri için yola bağla. Kule Sv.2 gerekir.',
  'building.parking': 'Otopark',
  'building.fuelDepot': 'Yakıt Deposu',
  'building.fireStation': 'İtfaiye',
  'building.hangar': 'Hangar',
  'building.groundHandling': 'Yer Hizmetleri Üssü',
  'desc.tower': 'Havalimanının kalbi. Seviyesi, diğer binaların sayısını ve seviyesini belirler.',
  'desc.terminal':
    'Yolcu kapasitesi ve kapı sayısı. Seviye atladıkça büyür; Sv.2 pasaport kontrolüyle dış hat havayollarını getirir.',
  'desc.runway': 'İniş ve kalkış. Sv.2 gece ışıkları ve CAT I ILS, Sv.3 yoğun siste CAT III ILS.',
  'desc.stand':
    'Uçak park yeri, yolcular otobüs ve merdivenle. Sv.2: yakıt hidrant çukurları, sabit yer gücü ve kendi ekipmanı; yer hizmetleri %25 hızlı, iki merdivenle iniş-biniş daha hızlı. Geniş gövde uçaklar sığmaz: büyük stand ister.',
  'desc.parking': 'Karayolu yolcuları ve otopark geliri. Seviyeyle katlanır.',
  'desc.fuelDepot': 'Uçaklara yakıt satışı. Seviye başına bir tank.',
  'desc.fireStation':
    'Yangın ve kurtarma hizmeti. Uçuşlar için zorunlu; geniş gövde uçaklar Sv.2 ister.',
  'desc.hangar':
    'Hat bakımı: arızaları azaltır, onarımı hızlandırır ve her kalkıştan bakım geliri getirir.',
  'desc.groundHandling':
    "Kendi yer hizmeti araçların: merdiven, otobüs, bagaj treni, catering, temizlik ve pushback. Her seviye daha çok araç getirir; Sv.5 ve Sv.6 (kule Sv.5) bir hub filosudur. Kule Sv.4'te 3 üs kurulabilir. Üs yokken taşeron daha yavaş çalışır ve ücret alır.",
  'catalog.requires': 'Kule Sv.{level}',
  'catalog.limitReached': 'Limit doldu',
  'catalog.hours': '{hours} sa',
  'panel.level': 'Seviye {level} / {max}',
  'panel.constructing': 'İnşaat sürüyor',
  'panel.upgrading': 'Sv.{level} yükseltmesi sürüyor',
  'panel.ready': 'Çalışıyor',
  'panel.remaining': '{time} kaldı',
  'panel.next': 'Sonraki seviye',
  'panel.upgrade': 'Yükselt',
  'panel.demolish': 'Yık',
  'panel.move': 'Taşı',
  'panel.moveHint': 'Binayı başka bir yere taşı (harcamasının %10’u kadar).',
  'panel.confirm': 'Emin misin? ({amount} iade)',
  'panel.maxLevel': 'En yüksek seviyede',
  'time.hm': '{h} sa {m} dk',
  'plan.cost': 'Maliyet',
  'hint.service.ok': 'Araç yolu bağlı',
  'hint.service.warn':
    'Yolu bir yere çıkmıyor: otoyola, bir terminale ya da hizmet binasına ulaştır',
  'hint.service.missing': 'Servis yolu ya da karayolu gerekli: sarı kenara çiz',
  'hint.terminal.ok': 'Terminale yakın ({n} kare): yolcular da gelir',
  'hint.terminal.warn':
    'Terminale uzak ({n} kare): yolcular gelmez. Terminalin {limit} kare yakınına kur',
  'hint.terminal.missing':
    'Terminal yok: yalnız şehirden gelenler alışveriş yapar. Terminalin {limit} kare yakınına kurulan yolcu da çeker',
  'hint.road.ok': 'Karayolu bağlı',
  'hint.road.warn': 'Kapıdaki yol otoyola ulaşmıyor',
  'hint.road.missing': 'Karayolu gerekli: sarı kenara yol çiz',
  'hint.road.near': 'En yakın bağlı yol {n} karo {dir}',
  'hint.taxi.ok': 'Taksi yolu piste bağlı',
  'hint.taxi.warn': 'Taksi yolu piste ulaşmıyor',
  'hint.taxi.missing': 'Taksi yolu gerekli: uçaklar sarı kenardan girer',
  'hint.runway.ok': 'Taksi bağlantısı: {n} nokta',
  'hint.runway.warn': 'Taksi bağlantısı yok',
  'hint.runway.missing': 'Uzun kenarlara taksi yolu bağla (sarı noktalar)',
  'compass.n': 'kuzeyde',
  'compass.e': 'doğuda',
  'compass.s': 'güneyde',
  'compass.w': 'batıda',
  'plan.refund': 'İade',
  'reason.invalidCommand': 'Geçersiz komut',
  'reason.outOfBounds': 'Harita dışında',
  'reason.tooLarge': 'Çok uzun',
  'reason.invalidLine': 'Düz bir çizgi çekin',
  'reason.nothingToDo': 'Yapılacak bir şey yok',
  'reason.notJunction': 'Burada bir kavşak yok',
  'reason.underMotorway': 'Otoyol köprüsünün altı: yalnızca yol geçebilir',
  'reason.needsTerminal': 'Körüklü stand bir terminalin apron ya da yan yüzüne yaslanmalı',
  'reason.standsAttached': 'Önce bu terminale yaslı körüklü standları kaldır',
  'reason.parcelLocked': 'Bu arazi henüz satın alınmadı',
  'reason.alreadyOwned': 'Bu arazi zaten senin',
  'reason.notAdjacent': 'Sadece sahip olduğun araziye komşu parseller alınabilir',
  'reason.occupied': 'Alan dolu',
  'reason.blocked': 'Bu yollar burada kesişemez',
  'reason.tunnelEnds':
    'Tünel taksi yolunun ya da karayolunun öbür yanına çıkmalı: servis yolunu ötesine kadar çiz',
  'reason.tunnelJunction': 'Servis tüneli kavşağın altından geçemez: yolun düz bir yerinden geçir',
  'reason.roadTunnelEnds':
    'Yol taksi yolunun altından geçip öbür yanına çıkmalı: yolu taksi yolunun ötesine kadar çiz, taksi yolunu da yolun tüm genişliği boyunca üstünden geçir',
  'reason.roadTunnelJunction':
    'Yol tüneli kavşağın altından ya da başka bir tünelin veya yolun yanından geçemez: yolun düz bir kısmını taksi yolunun altından tek başına geçir',
  'reason.requiresTower': 'Kontrol kulesi seviyesi yetersiz',
  'reason.limitReached': 'Bu binadan daha fazla yapılamaz (kuleyi yükselt)',
  'reason.noFreeCrew':
    'Tüm inşaat ekipleri meşgul: biri işini bitirince yeniden dene ya da İnşaat Ofisi ile ekip ekle',
  'reason.maxLevel': 'Bina en yüksek seviyede',
  'reason.busy': 'Bina zaten inşaatta',
  'reason.unknownBuilding': 'Bina bulunamadı',
  'reason.unknownOffer': 'Teklif artık geçerli değil',
  'reason.insufficientFunds': 'Yetersiz bütçe',
  'ops.title': 'Havayolları ve uçuşlar',
  'ops.tab.offers': 'Teklifler',
  'ops.tab.contracts': 'Sözleşmeler',
  'ops.tab.flights': 'Uçuş tablosu',
  'ops.noOffers': 'Şu an teklif yok. Kule çalıştığı sürece saatte bir yeni teklif gelebilir.',
  'ops.poolFull':
    'Buraya gelebilecek her havayoluyla zaten anlaşman var; yeni teklif ancak şunlarla gelir:',
  'ops.poolPassports': 'Dış hat havayolları: terminali Sv.{level} yap (pasaport kontrolü).',
  'ops.poolCargo': 'Kargo havayolları: yola bağlı bir kargo terminali kur (Kule Sv.2).',
  'ops.poolHelipad': 'Helikopter işletmecileri: yola bağlı bir helikopter pisti kur.',
  'ops.poolWait': 'Bir sözleşmenin süresi bitince o havayolu yeniden teklif verebilir.',
  'ops.nightNeedsLights':
    'Gece uçuşları (22:00–06:00) için pist ışıkları gerekir: pisti 3. seviyeye yükselt. O zamana kadar teklifler 06:00–22:00 arasına gelir.',
  'ops.needsTower': 'Teklif almak için önce bir Kontrol Kulesi kur.',
  'ops.privateOnly':
    'Kule Sv.1: şimdilik yalnızca özel jet işletmecileri teklif verir. Yolcu havayolları kule 2. seviyeye çıkınca gelir.',
  'ops.perDay': '{n} sefer/gün',
  'ops.days': '{n} gün',
  'ops.perFlight': 'Sefer başı ~{amount}',
  'ops.expires': '{h} sa içinde sona erer',
  'ops.accept': 'Kabul et',
  'ops.decline': 'Reddet',
  'ops.requires': 'Gerekli: {what}',
  'ops.noContracts': 'Henüz sözleşme yok. Teklifler sekmesinden bir havayolunu kabul et.',
  'ops.served': '{n} sefer',
  'ops.cancelledCount': '{n} iptal',
  'ops.daysLeft': '{n} gün kaldı',
  'ops.noFlights': 'Planlanmış uçuş yok.',
  'ops.button': 'Uçuşlar',
  'fids.time': 'Saat',
  'fids.flight': 'Uçuş',
  'fids.airline': 'Havayolu',
  'fids.type': 'Tip',
  'fids.status': 'Durum',
  'class.1': 'Bölgesel',
  'class.2': 'Dar gövde',
  'class.3': 'Geniş gövde',
  'class.4': 'Özel jet',
  'status.1': 'Planlandı',
  'status.2': 'Bekliyor',
  'status.3': 'İniyor',
  'status.4': 'Kapıda',
  'status.5': 'Kalkıyor',
  'status.6': 'Kalktı',
  'status.7': 'İptal',
  'hold.0': '',
  'hold.1': 'Terminal yok',
  'hold.2': 'Uygun pist yok',
  'hold.3': 'Boş stand yok',
  'hold.4':
    'Pistten standa taksi yolu yok (ya da bu rüzgâr yönünde pist çıkışı yok: pistin iki ucuna da taksi yolu bağla)',
  'hold.5': 'Pist meşgul',
  'hold.6': 'Gece: pist ışıkları gerekli (Pist Sv.3)',
  'hold.7': 'Taksi yolu meşgul',
  'hold.8': 'Yan rüzgâr sınırın üstünde',
  'wind.title': 'Rüzgâr',
  'wind.value': '{deg}° {kt} kt',
  'wind.calm': 'Sakin',
  'rwy.inUse': 'Kullanımdaki pist',
  'rwy.head': 'Karşı rüzgâr {kt} kt',
  'rwy.tail': 'Arka rüzgâr {kt} kt',
  'rwy.cross': 'Yan rüzgâr {kt} kt',
  'rwy.closedFor': 'Yan rüzgâr nedeniyle kapalı: {classes}',
  'rwy.mode': 'Kullanım',
  'rwy.mode.0': 'Karma',
  'rwy.mode.1': 'Yalnız iniş',
  'rwy.mode.2': 'Yalnız kalkış',
  'rwy.movements': 'Yaklaşan ve pistteki uçak: {n}',
  'rwy.hint':
    'Uçaklar rüzgâra karşı iner ve kalkar; arka rüzgâr 5 knotu geçince kule pistin yönünü çevirir. Farklı yönde ikinci bir pist, güçlü yan rüzgârda havalimanını açık tutar.',
  'ops.renewal': 'Yenileme',
  'ops.score': 'Havayolu memnuniyeti',
  'ops.scoreHint':
    'Rötar, kaçan yolcu ve iptal düşürür. Sözleşme bitince %70 ve üstü memnun havayolu yenileme teklif eder; %90 üstü günde bir sefer daha ister.',
  'ledger.punctuality': 'Zamanında kalkış %{pct} · ort. rötar {avg} dk · {cancelled} iptal',
  'toast.contractRenewal': '{airline} sözleşmeyi yenilemek istiyor',
  'hold.9': 'Pushback aracı yok',
  'gse.0': 'Merdiven',
  'gse.1': 'Otobüs',
  'gse.2': 'Bagaj treni',
  'gse.3': 'Catering kamyonu',
  'gse.4': 'Temizlik aracı',
  'gse.5': 'Yakıt tankeri',
  'gse.6': 'Pushback traktörü',
  'gse.7': 'Buz çözme aracı',
  'hold.10':
    'Düşük görüş (sis ya da kum fırtınası): pist minimumunun altında (CAT III ILS için Pist Sv.4)',
  'hold.11': 'Buz çözme',
  'hold.12': 'İtfaiye yok (geniş gövde için Sv.2)',
  'ready.fire': 'İtfaiye (uçuşlar için zorunlu)',
  'sky.0': 'Açık',
  'sky.1': 'Bulutlu',
  'sky.2': 'Yağmurlu',
  'sky.3': 'Sisli',
  'sky.4': 'Karlı',
  'wx.title': 'Hava durumu',
  'wx.visibility': 'Görüş {v}',
  'wx.icing': 'Buzlanma: kalkıştan önce buz çözme gerekiyor',
  'rwy.visibility': 'Görüş {v} · pist minimumu {min}',
  'rwy.closedFog':
    'Düşük görüş nedeniyle kapalı (sis ya da kum fırtınası): Sv.3 pistin CAT I ILS’i 600 m’ye kadar iner; daha kötü görüşte CAT III (Pist Sv.4) gerekli',
  'svc.tech': 'Teknik arıza onarımı',
  'svc.deice': 'Buz çözme',
  'diag.technical': 'Teknik arıza',
  'ledger.maintenance': 'Bakım (hangar)',
  'fire.title': 'Yangın ve kurtarma',
  'fire.covers': 'Korunan uçaklar: {classes}',
  'fire.needs': 'Geniş gövde uçaklar için itfaiye Sv.2 gerekli.',
  'hangar.title': 'Hat bakımı',
  'hangar.defects': 'Arıza oranı %{pct} · onarım {m} dk',
  'hangar.noHangar': 'Hangar olmadan arızalar dışarıdan gelen teknisyenle {m} dk sürer.',
  'hangar.fee': 'Her kalkıştan bakım geliri: {amount} (dar gövde)',
  'svc.noVehicle': '{vehicle} bekleniyor',
  'fleet.busy': 'işte',
  'fleet.idle': 'boşta',
  'fleet.title': 'Araç filosu',
  'fleet.inUse': '{used} / {total}',
  'fleet.contracted':
    'Çalışan bir yer hizmetleri üssü olmadığı (ya da personeli çok az olduğu) için bagaj, temizlik ve catering işini taşeron yapıyor: %50 daha yavaş ve uçak başına ücretli.',
  'fleet.hint':
    'Bir türün bütün araçları meşgulse sıradaki uçak bekler. Üssü yükselt ya da ikinci bir üs kur.',
  'fleet.fuelHint': 'Tankerler yakıt deposundan gelir; depoyu yükseltmek tanker sayısını artırır.',
  'ledger.handling': 'Yer hizmeti taşeronu',
  'ledger.lost':
    'Kaybedilen dakika: gelen rötar {inbound} · geliş {arrival} · araç {vehicles} · yolcu {passengers} · teknik {technical} · kalkış {departure}',
  'diag.title': 'Rötar analizi',
  'diag.delay': '{m} dk rötar',
  'diag.onTime': 'Zamanında',
  'diag.arrival': 'Geliş (bekleme turu)',
  'diag.vehicles': 'Yer aracı bekleme',
  'diag.passengers': 'Geç kalan yolcular',
  'diag.departure': 'Kalkış sırası (buz çözme, pist, taksi yolu, pushback)',
  'diag.none': 'Kaybedilen zaman yok.',
  'diag.turnaround': 'Taksi ve turnaround süresi',
  'diag.minutes': '{m} dk',
  'diag.hint': 'Rötarın nedenleri için bir uçuşa tıkla.',
  'req.runway2': 'Pist Sv.2',
  'req.stand2': 'Stand Sv.2',
  'ledger.today': 'Bugün',
  'ledger.income': 'Uçuş geliri',
  'ledger.upkeep': 'Bina bakımı',
  'ledger.penalties': 'Cezalar',
  'ledger.net': 'Net',
  'ready.title': 'Uçuşlara hazırlık',
  'ready.terminal': 'Terminal',
  'ready.runway': 'Pist',
  'ready.stand': 'Stand',
  'ready.connected': 'Pist ile stand sarı taksi çizgisiyle bağlı',
  'ready.standRoad': 'Standa karayolu (yer araçları için)',
  'ready.contract': 'Havayolu sözleşmesi (U)',
  'ready.hint':
    'Taksi yolunu döşe (5), sonra Taksi çizgisi (6) ile sarı çizgiyi pistin uzun kenarından standın kenarına kadar çiz. Uçaklar yalnızca sarı çizgiyi izler.',
  'stand.empty': 'Standda uçak yok.',
  'stand.departs': 'Kalkış {time}',
  'svc.deboard': 'Yolcu inişi',
  'svc.unload': 'Bagaj boşaltma',
  'svc.fuel': 'Yakıt',
  'svc.clean': 'Kabin temizliği',
  'svc.catering': 'Catering',
  'svc.load': 'Bagaj yükleme',
  'svc.board': 'Biniş',
  'svc.waiting': 'sırada',
  'svc.minutesLeft': '{m} dk',
  'svc.outsideFuel': 'dış tedarik (2×)',
  'svc.boarding': '{boarded}/{booked} · hazır {ready}',
  'svc.opensAt': '{time} açılır',
  'svc.waitingCabin': 'kabin bekleniyor',
  'term.capacity': 'Check-in + güvenlik',
  'stage.checkIn': 'Check-in ve bagaj',
  'stage.security': 'Güvenlik',
  'stage.passport': 'Pasaport (dış hat)',
  'stage.bottleneck': 'Darboğaz',
  'term.perHour': '{n} yolcu/sa',
  'term.queue': 'Kuyruktaki yolcu',
  'term.wait': 'Ortalama bekleme',
  'term.minutes': '{n} dk',
  'term.los': 'Hizmet seviyesi',
  'term.hint':
    'Yolcular check-in, güvenlik ve dış hatta pasaporttan geçer; en yavaş aşama hızı belirler. Darboğaza göre check-in bankosu ya da güvenlik hattı ekle (terminali seç), terminali yükselt ya da ikinci terminal kur. Kuyruk uzarsa yolcular uçağı kaçırır.',
  'los.optimum': 'Optimum',
  'los.suboptimum': 'Optimum altı',
  'los.under': 'Yetersiz',
  'los.closed': 'Kapalı',
  'hud.rating': 'Havalimanı puanı (yolcu memnuniyeti)',
  'fids.pax': 'Yolcu',
  'ledger.landing': 'İniş ücretleri',
  'ledger.passenger': 'Yolcu ücretleri',
  'ledger.retail': 'Mağaza ve yeme-içme',
  'ledger.fuel': 'Yakıt satışı',
  'ledger.parking': 'Otopark',
  'ledger.stats': '{flights} kalkış · {pax} yolcu · {missed} kaçan',
  'toast.missed': '{flight}: {n} yolcu uçağı kaçırdı',
  'toast.offer': 'Yeni teklif: {airline}',
  'toast.cancelled': '{airline} uçuşu iptal edildi: {reason}',
  'toast.contractEnded': '{airline} sözleşmesi sona erdi',
  'sync.overlay': 'Bir oyuncu oyuna katılıyor, harita gönderiliyor…',
  'toast.desync': '{name} senkronu kaybetti, harita yeniden gönderiliyor',
  'toast.joined': '{name} oyuna katıldı',
  'toast.left': '{name} oyundan ayrıldı',
  'toast.built': '{building} Sv.{level} tamamlandı',
  'error.versionMismatch': 'Sunucu farklı bir oyun sürümü kullanıyor',
  'error.roomNotFound': 'Bu kodla bir oda bulunamadı',
  'error.roomFull': 'Oda dolu (en fazla 4 oyuncu)',
  'error.badMessage': 'Sunucuyla iletişim hatası',
  'error.syncTimeout': 'Harita yüklenirken zaman aşımı',
  'error.fatal': 'Simülasyon hatası: {message}',
  'error.graphicsLost':
    'Ekran kartı bağlantısı koptu. Oyuna yeniden katıl; dünya kaldığı yerden devam ediyor.',
  'toast.graphicsRecovered': 'Grafikler yeniden başlatıldı; oyun kaldığı yerden sürüyor.',
  'error.disconnected': 'Bağlantı koptu ({reason})',
  'mgmt.button': 'Yönetim',
  'mgmt.title': 'Yönetim',
  'mgmt.subtitle': 'Personel, ücretler ve finansman',
  'mgmt.tab.staff': 'Personel',
  'mgmt.tab.finance': 'Finans',
  'staff.lead':
    'Her ekibin ihtiyacı binalarından gelir. Otomatik kadroda havalimanı tam ihtiyaç kadar işe alır; elle azaltırsan maaştan tasarruf edersin ama hizmet aksar.',
  'staff.role.terminal': 'Terminal personeli',
  'staff.role.ground': 'Yer hizmeti ekipleri',
  'staff.role.fire': 'İtfaiyeciler',
  'staff.role.atc': 'Hava trafik kontrolörleri',
  'staff.desc.terminal': 'Check-in ve güvenlik kontrolü',
  'staff.desc.ground': 'Yer hizmeti araçlarının sürücüleri',
  'staff.desc.fire': 'Kurtarma ve yangınla mücadele',
  'staff.desc.atc': 'Kulede iniş ve kalkış izni',
  'staff.auto': 'Otomatik',
  'staff.autoHint': 'Otomatik kadro: ihtiyaç değiştikçe işe alır veya çıkarır',
  'staff.idle': 'Bu ekibin çalışacağı bina yok',
  'staff.full': 'Tam kadro',
  'staff.effect.terminal': 'Check-in kapasitesi %{pct}: kuyruklar uzar',
  'staff.effect.ground': 'Araçların yalnızca ~%{pct} kadarı sürücülü',
  'staff.effect.contractor': 'Ekip çok az: işler taşerona gidiyor (yavaş ve ücretli)',
  'staff.effect.fire': 'İtfaiye kategorisi {cat}/{level}',
  'staff.effect.fireNone': 'İtfaiye hizmet veremiyor: uçuş yapılamaz',
  'staff.effect.atc': 'Pist ayırması +{s} sn uzuyor',
  'staff.effect.towerClosed': 'Kule kapalı: iniş ve kalkış yok',
  'staff.wage': '{amount}/gün',
  'staff.total': 'Toplam {n} çalışan',
  'staff.perDay': 'Maaşlar: {amount}/gün',
  'ledger.wages': 'Maaşlar',
  'ledger.loans': 'Kredi taksitleri',
  'hold.13': 'Kulede kontrolör yok',
  'reason.unknownLoan': 'Böyle bir kredi yok',
  'finance.statement': 'Gelir tablosu',
  'finance.today': 'Bugün',
  'finance.yesterday': 'Dün',
  'finance.income': 'Toplam gelir',
  'finance.costs': 'Toplam gider',
  'finance.fees': 'Havalimanı ücretleri',
  'finance.feesLead':
    'Standart tarifeye göre yüzde. Yüksek ücret sefer başına daha çok kazandırır ama havayolları daha az teklif verir ve memnuniyet düşer.',
  'finance.landingFee': 'İniş ücreti',
  'finance.paxFee': 'Yolcu hizmet ücreti',
  'finance.effect.offers': 'Havayolu teklif sıklığı ×{x}',
  'finance.effect.airlines': 'Havayolu memnuniyeti sefer başına −{n} puan',
  'finance.effect.airlinesOk': 'Havayolları ücretlerden memnun',
  'finance.effect.passengers': 'Yolcu memnuniyeti −{n} puan',
  'finance.effect.passengersOk': 'Yolcular ücretten şikâyetçi değil',
  'finance.apply': 'Uygula',
  'finance.standard': 'Standart tarife',
  'finance.loans': 'Banka kredileri',
  'finance.loansLead':
    '%{pct} faiz, {days} günlük taksitle ödenir. Erken kapatırsan kalan faiz silinir.',
  'finance.loanLeft': 'Kalan {amount} · {days} gün',
  'finance.instalment': 'Taksit {amount}/gün',
  'finance.repay': 'Toplam {amount}',
  'finance.payoff': 'Erken kapat: {amount}',
  'finance.loansFull': 'En fazla {n} kredi kullanılabilir.',
  'load.connecting': 'Sunucuya bağlanılıyor',
  'load.starting': 'Simülasyon başlatılıyor',
  'load.stage.1': 'Dünya yükleniyor',
  'load.stage.2': 'Arazi, binalar ve trafik hazırlanıyor',
  'load.stage.3': 'Grafikler derleniyor',
  'load.stage.4': 'Hazır',
  'load.firstTime': 'İlk açılışta biraz daha uzun sürebilir.',
  'load.nextTip': 'Sonraki ipucu',
  'tip.8':
    'Yönetim (M) penceresinde personeli otomatikten çıkarıp maaştan tasarruf edebilirsin ama hizmet aksar.',
  'tip.9': 'Kulede kontrolör azsa iniş ve kalkışlar arasındaki ayırma uzar, kapasite düşer.',
  'tip.10': 'Nakit sıkışınca bankadan kredi alabilirsin; erken kapatırsan kalan faiz silinir.',
  'tip.11':
    'Ücretleri yükseltmek sefer başına geliri artırır ama havayolları daha az teklif verir.',
  'tip.12':
    'Havayolları önce bölgesel uçaklarla gelir; dar gövde için Pist Sv.2, geniş gövde için Sv.4 gerekir.',
  'tip.13': 'Devlet teşvik primini alırsan 3 gün içinde teşvik tabelasını dikmeyi unutma.',
  'tip.14':
    'Körüklü stand terminale yaslanır: yolcular körükle iner biner, otobüsle taşımaktan çok daha hızlı ve rahat.',
  'tip.15':
    'Kar ve dondurucu yağmurda uçaklar kalkıştan önce buzdan arındırılır; kendi buz çözme aracın işi hızlandırır.',
  'menu.continue': 'Devam et',
  'menu.saves': 'Kayıtlı oyunlar',
  'menu.savesSub': 'Yükle, yedekle, içe aktar',
  'menu.savesTitle': 'Kayıtlı oyunlar',
  'save.title': 'Oyunu kaydet',
  'save.subtitle': 'Hesabında, sunucuda saklanır',
  'save.name': 'Kayıt adı',
  'save.defaultName': 'Havalimanım · Gün {day}',
  'save.autoName': 'Otomatik kayıt',
  'save.auto': 'Otomatik',
  'save.overwriteHint': 'Üzerine yazmak için bir kayıt seç:',
  'save.overwrite': 'Üzerine kaydet',
  'save.saveNew': 'Kaydet',
  'save.cancel': 'Vazgeç',
  'save.saved': 'Oyun kaydedildi: {name}',
  'save.failed': 'Oyun kaydedilemedi',
  'save.saving': 'Kaydediliyor…',
  'save.leaveHint': 'Oyun çıkarken otomatik olarak kaydedilir.',
  'save.lead':
    'Kayıtlar hesabında, sunucuda saklanır: hangi cihazdan girersen gir oradadır ve oyun güncellense de açılır. Tek oyunculu ve co-op oyunlar her 5 dakikada bir ve çıkarken otomatik olarak da kaydedilir.',
  'save.none':
    'Henüz kayıtlı oyun yok. Oyun sırasında ayarlar menüsünden ya da Ctrl+S ile kaydedebilirsin.',
  'save.load': 'Yükle',
  'save.host': 'Co-op aç',
  'save.hostHint': 'Bu kayıttan bir co-op odası kur; arkadaşların oda koduyla katılır',
  'save.export': 'Dosya olarak indir (yedek)',
  'save.delete': 'Sil',
  'save.deleteConfirm': 'Silinsin mi?',
  'save.import': 'Dosyadan içe aktar',
  'save.backupHint':
    'Kayıtları .am27 dosyası olarak indirip yedekleyebilir, dosyadan geri yükleyebilirsin.',
  'save.importError': 'Bu dosya bir Airport Manager 2027 kaydı değil.',
  'save.loadError': 'Kayıt açılamadı.',
  'save.storageError': 'Sunucuya ulaşılamıyor; kayıtlar şu an listelenemiyor.',
  'save.olderVersion': 'sürüm {v} ile kaydedildi',
  'save.newerVersion': 'oyunun daha yeni bir sürümüyle kaydedilmiş',
  'hold.14': 'Pist bakımda',
  'panel.runwayWorks':
    'Yükseltme {hours} saat sürer ve bu sürede pist kapalı olur: uçaklar inemez ve kalkamaz.',
  'panel.standWorks': 'Yükseltme {hours} saat sürer; bu sürede stand yeni uçak almaz.',
  'panel.closureFlights':
    'Bu sürede {n} uçuş inecek ya da kalkacaktı: bekler, iki saat sonra iptal olur (ceza ve havayolu güveni). Yoğun olmayan saatleri seç.',
  'panel.closureQuiet': 'Bu saatlerde planlı uçuş yok: yükseltmek için iyi bir an.',
  'panel.runwayClosed': 'Pist bakımda: iniş ve kalkış yok, uçuşlar bekletiliyor.',
  'panel.standClosed': 'Stand bakımda: yeni uçak almıyor.',
  'panel.upgradeConfirm': 'Kapat ve yükselt',
  'toast.runwayClosed': 'Pist bakıma alındı: uçaklar inemez, uçuşlar bekletiliyor',
  'toast.runwayOpen': 'Pist yeniden açıldı',
  'tool.taxiLine': 'Taksi çizgisi',
  'hud.taxiwayHint':
    'sürükle: 4×4 bloklar, piste/standa kendiliğinden bağlanır · Shift+sürükle: alan (apron)',
  'hud.taxiLineHint':
    'sürükle: sarı çizgi çiz · Shift+sürükle: sil · uçaklar yalnızca sarı çizgiyi izler',
  'hold.15': 'Standa araç yolu yok (yer araçları gelemiyor)',
  'reason.tooLargeArea': 'Alan çok büyük',
  'issue.road': 'Karayolu bağlantısı yok: bu binaya otoyola giden bir yol bağla.',
  'issue.highway':
    'Yol anayola bağlı değil: bu binanın yolu otoyola ulaşmıyor. Yolu otoyola kadar uzat.',
  'issue.highwayService':
    'Yolu bir yere çıkmıyor: bu binanın yolunu otoyola, bir terminale ya da yer hizmeti, yakıt, ikram, itfaiye veya hangar binasına ulaştır.',
  'issue.roadStand':
    'Araç yolu yok: standa bir servis yolu (ya da karayolu) bağla. Servis yolu otoyola, bir terminale ya da yer hizmeti, yakıt, ikram, itfaiye veya hangar binasına ulaşması yeter.',
  'issue.roadService':
    'Araç yolu yok: bu binaya bir servis yolu (ya da karayolu) bağla. Otoyola, bir terminale ya da başka bir hava tarafı tesisine ulaşması yeter.',
  'issue.taxi':
    'Taksi çizgisi yok: sarı çizgiyi pistten buraya kadar çiz; uçak ancak taksi yoluyla gelip park eder.',
  'issue.taxiRunway': 'Taksi çizgisi yok: pistin uzun kenarına değen bir sarı çizgi çiz.',
  'issue.title': 'Eksik bağlantı',
  'menu.airportName': 'Havalimanı adı',
  'menu.airportNameRandom': 'Başka bir isim öner',
  'hud.rename': 'Havalimanının adını değiştir',
  'hud.unnamed': 'İsimsiz havalimanı',
  'building.transitHub': 'Taksi ve Otobüs Durağı',
  'desc.transitHub':
    'Terminale 30 kare içinde ve karayoluna bağlı kurulursa yolcular taksi ve otobüsle gelir: her yolcudan imtiyaz geliri, daha memnun yolcular. Sv.2 daha çok peron.',
  'ledger.transit': 'Taksi ve otobüs imtiyazı',
  'ops.review': 'Sözleşmeyi incele',
  'ops.terminate': 'Feshet',
  'toast.contractSuspended': '{airline} sözleşmeyi askıya aldı',
  'capacity.title': 'Kapasite uyarısı',
  'capacity.short': 'Kapasiteni aşabilir',
  'capacity.stands': '{hour} civarı {need} uçak aynı anda yerde olacak, uygun stand sayın {have}.',
  'capacity.runway':
    '{hour} saatinde {need} iniş-kalkış var, pistlerin saatte yaklaşık {have} hareket kaldırır.',
  'capacity.terminal':
    '{hour} saatinde {need} yolcu check-in yapacak, terminalin saatte {have} yolcu işler.',
  'capacity.choice': 'Gecikmeler, iptaller ve memnuniyetsizlik olabilir. Karar senin.',
  'paper.date': '{day}. gün',
  'paper.manager': 'Havalimanı Müdürü',
  'paper.forAirline': 'Havayolu adına',
  'paper.forAirport': 'Havalimanı adına',
  'paper.agreement': 'Yer Hizmetleri ve Slot Sözleşmesi',
  'paper.agreementLead':
    '{airline}, aşağıdaki şartlarla {days} gün boyunca havalimanınızda düzenli sefer yapmayı teklif eder.',
  'paper.aircraft': 'Uçak',
  'paper.seats': '{n} koltuk',
  'paper.schedule': 'Sefer programı',
  'paper.term': 'Süre',
  'paper.turnaround': 'Yerde kalma süresi',
  'paper.minutes': '{m} dakika',
  'paper.revenue': 'Sefer başı beklenen gelir',
  'paper.perWeek': 'haftada {amount}',
  'paper.perTerm': '{days} günde {amount}',
  'paper.requirements': 'Gereksinimler',
  'paper.fire': 'itfaiye kategorisi {level}',
  'paper.termCancel': 'Havalimanı karşılayamadığı her sefer için {amount} ceza öder.',
  'paper.termSuspend': 'Üst üste {n} sefer karşılanamazsa havayolu sözleşmeyi askıya alır.',
  'paper.termExit':
    'Havalimanı sözleşmeyi erken feshederse kalan seferlerin gelirinin %{pct} kadar cayma bedeli öder.',
  'paper.termRenew': 'Süre sonunda memnun kalan havayolu yenileme teklif edebilir.',
  'paper.sign': 'İmzala',
  'paper.signing': 'İmzalanıyor…',
  'paper.notNow': 'Şimdi değil',
  'paper.stampSigned': 'ONAYLANDI',
  'paper.termination': 'Sözleşme Fesih Bildirimi',
  'paper.terminationLead':
    'Havalimanı, {airline} ile yapılan sözleşmeyi süresinden önce feshetmektedir.',
  'paper.served': 'Karşılanan sefer',
  'paper.fee': 'Cayma bedeli',
  'paper.terminationNote':
    'Cayma bedeli, kalan seferlerin beklenen gelirinin %{pct} kadarıdır ve hemen ödenir. Henüz inmemiş seferler iptal edilir.',
  'paper.terminate': 'Feshet ve öde',
  'paper.keep': 'Vazgeç',
  'paper.stampTerminated': 'FESHEDİLDİ',
  'paper.suspension': 'Sözleşmenin Askıya Alınması',
  'paper.suspensionLead': '{airline}, havalimanınızla yaptığı sözleşmeyi derhal askıya almıştır.',
  'paper.reasonCancellations':
    'Gerekçe: üst üste {n} seferimiz havalimanınızca karşılanamamış ve iptal edilmiştir.',
  'paper.reasonScore':
    'Gerekçe: dakiklik ve hizmet kalitesinden duyduğumuz memnuniyet kabul edilemez düzeye inmiştir.',
  'paper.suspensionNote':
    'Bekleyen seferlerimiz iptal edilmiştir. Bu durum havalimanının itibarını olumsuz etkiler.',
  'paper.stampSuspended': 'ASKIYA ALINDI',
  'paper.understood': 'Okudum',
  'social.button': 'Sosyal',
  'social.title': 'Kanat',
  'social.subtitle': 'Yolcular havalimanın hakkında ne diyor?',
  'social.tab.feed': 'Akış',
  'social.tab.ratings': 'Puanlar',
  'social.mood.crisis': 'Sosyal medya krizi!',
  'social.mood.viral': 'Övgü yağıyor',
  'social.mood.calm': 'Gündem sakin',
  'social.moodHint': 'Krizde havayolları uzak durur, övgü yeni teklif getirir.',
  'social.trending': 'Gündemde:',
  'social.empty': 'Henüz paylaşım yok. Uçuşlar başlayınca yolcular yazmaya başlar.',
  'social.official': 'Onaylı hesap',
  'social.overallHint': 'Genel puan, kategorilerin ağırlıklı ortalaması',
  'rating.punctuality': 'Dakiklik',
  'rating.waiting': 'Bekleme',
  'rating.comfort': 'Konfor',
  'rating.prices': 'Fiyat',
  'rating.reliability': 'Güvenilirlik',
  'rating.punctuality.tip': 'Rötarlar düşürür',
  'rating.waiting.tip': 'Check-in ve güvenlik kuyrukları',
  'rating.comfort.tip': 'Köprü, otobüs, taksi durağı',
  'rating.prices.tip': 'Yolcu hizmet ücreti',
  'rating.reliability.tip': 'İptaller ve kaçan uçuşlar',
  'toast.buzz.crisis': 'Sosyal medyada kriz! Yolcular havalimanına isyan ediyor',
  'toast.buzz.viral': 'Havalimanın sosyal medyada övgü topluyor',
  'catalog.cat.operations': 'İşletme',
  'catalog.cat.airside': 'Hava tarafı',
  'catalog.cat.passengers': 'Yolcu ve kara tarafı',
  'catalog.cat.city': 'Havalimanı şehri',
  'catalog.cat.military': 'Askeri',
  'catalog.cat.other': 'Diğer',
  'catalog.level': 'Sv.{level}',
  'catalog.needs.road': 'Otoyola giden bir karayolu',
  'catalog.needs.service':
    'Servis yolu ya da karayolu: otoyola, bir terminale ya da bir hizmet binasına ulaşmalı',
  'catalog.needs.militaryGate': 'Bakanlığın her askerî anlaşması için gerekli (kule Sv.3)',
  'catalog.needs.fighters':
    'Savaş uçakları için sığınak, harekât binası ve mühimmat deposunun üçü de gerekir (kule Sv.4)',
  'catalog.needs.transports': 'Nakliye uçakları ve İHA’lar burada park eder (kule Sv.4)',
  'catalog.needs.airDefence': 'Şart değil: Bakanlık ödemelerini artırır',
  'catalog.needs.terminalFace': 'Bir terminalin karayolu dışındaki yüzüne yaslı',
  'catalog.needs.taxiLine': 'Pistle arasında sarı taksi çizgisi',
  'catalog.needs.nearTerminal': 'Terminale en fazla 30 kare',
  'catalog.needs.fire': 'Uçuşlar için itfaiye',
  'touch.place': 'Yerleştir',
  'touch.rotate': 'Döndür',
  'touch.buy': 'Satın al',
  'touch.build': 'Yap',
  'touch.remove': 'Kaldır',
  'touch.catalog': 'Katalog',
  'touch.checking': 'Bakılıyor…',
  'touch.again': 'Bir tane daha koymak için haritaya dokun',
  'touch.drawHint': 'tek parmakla çiz · uçlarını sürükleyip düzelt · ✓ ile yap',
  'touch.tapHint': 'haritaya dokun · ✓ ile onayla',
  'touch.bulldozeHint': 'kaldırılacak yolların üstünden sürükle · ✓ ile kaldır',
  'touch.moveHint': 'binayı parmağınla taşı, ✓ ile bırak',
  'touch.junctionHint': 'bir kavşağa dokun: trafik ışığı, akıllı ışık ya da bağlantı yolu',
  'touch.area': 'Alan döşe',
  'touch.erase': 'Silgi',
  'touch.controls':
    'Bir parmak kaydırır · iki parmak yakınlaştırır ve döndürür · iki parmakla yukarı/aşağı eğer · çift dokunuş yaklaştırır',
  'touch.info': 'Bilgi',
  'hud.status': 'Havalimanının durumu',
  'phone.airport': 'Havalimanı',
  'legal.title': 'Hakkında ve yasal',
  'legal.about': 'Hakkında',
  'legal.privacy': 'Gizlilik Politikası',
  'legal.terms': 'Kullanım Koşulları',
  'legal.licences': 'Lisanslar',
  'legal.version': 'Sürüm {version}',
  'legal.publisher': 'Yayıncı',
  'legal.contact': 'İletişim',
  'legal.website': 'Web sitesi',
  'legal.updated': 'Son güncelleme: {date}',
  'legal.aboutText':
    'Soru, öneri, hata bildirimi ve kişisel verilerinle ilgili her talep için e-posta gönderebilirsin. Oyunda reklam, izleme ya da oyun içi satın alma yoktur.',
  'legal.models': 'Üçüncü taraf 3D modeller',
  'legal.modelsText':
    'Bu modeller yapımcılarının lisanslarıyla kullanılır ve oyun için değiştirilmiştir (ölçü, parçalar, boyalar). Oyunda gerçek havayolu ya da üretici adları geçmez.',
  'legal.software': 'Açık kaynak yazılımlar',
  'auth.agree':
    '{age} yaşından büyüğüm; Kullanım Koşulları’nı ve Gizlilik Politikası’nı okudum, kabul ediyorum.',
  'menu.legal': 'Hakkında ve yasal',
  'menu.legalSub': 'Gizlilik, koşullar, lisanslar',
  'install.title': 'Tam ekran oyna',
  'install.how':
    'Safari’de Paylaş düğmesine (kare ve ok) dokun, "Ana Ekrana Ekle"yi seç. Oyun ana ekrandan kendi simgesiyle, adres çubuğu olmadan tam ekran açılır.',
  'phone.rating': 'Puan',
  'phone.weather': 'Hava durumu',
  'phone.noiseOn': 'Gürültü haritasını göster',
  'phone.noiseOff': 'Gürültü haritasını gizle',
  'phone.camera': 'Kamera',
  'phone.watch': 'Uçakları izle (seyir kamerası)',
  'phone.roads': 'Yollar',
  'phone.edit': 'Düzenle',
  'issue.connect': 'Yolu bağla',
  'lesson.waitTower':
    'Bu bina kule Sv.{level} bitince açılır: oyunu hızlandırıp kulenin bitmesini bekle.',
  'issue.connectNone': 'Yakında bağlanacak bir yol yok: yolu kendin çiz.',
  'hud.fullscreen': 'Tam ekran',
  'hud.fullscreenOff': 'Tam ekrandan çık',
  'hud.rotatePhone': 'Cihazını yan çevir: oyun yatay ekranda oynanır.',
  'hold.16': 'Pistte acil durum incelemesi',
  'toast.emergency.1': '{airline}: kuş çarpması! Uçak acil iniş yapıyor, itfaiye pistte',
  'toast.emergency.2': '{airline}: motor arızası! Acil iniş, itfaiye ekipleri yolda',
  'toast.emergency.3': '{airline}: uçakta tıbbi acil durum, ambulans standa gidiyor',
  'toast.emergency.cleared': 'Pist incelendi ve yeniden açıldı',
  'goals.tutorial': 'İlk adımlar',
  'goals.title': 'Hedefler',
  'toast.goal': 'Hedef tamamlandı: {goal} (+{amount})',
  'toast.goalNoReward': 'Hedef tamamlandı: {goal}',
  'ledger.rewards': 'Hedef ödülleri',
  'goal.tower': 'Kontrol kulesini kur',
  'goal.tower.hint':
    'İnşa (3) → İşletme → Kontrol Kulesi. Haritada yerini seç; R ile döndürebilirsin.',
  'goal.runway': 'Pisti kur',
  'goal.runway.hint': 'İnşa → Hava tarafı → Pist. Uzun bir bina: araziye yatay sığdır.',
  'goal.terminal': 'Terminali kur',
  'goal.terminal.hint':
    'İnşa → Yolcu ve kara tarafı → Terminal. Otoyola yakın kurarsan yol kısa olur.',
  'goal.stand': 'Bir stand kur',
  'goal.stand.hint': 'İnşa → Hava tarafı → Stand. Uçaklar burada park eder ve hizmet alır.',
  'goal.fire': 'İtfaiye kur',
  'goal.fire.hint': 'İnşa → İşletme → İtfaiye. İtfaiye olmadan hiçbir uçak inemez.',
  'goal.roadAccess': 'Terminali otoyola bağla',
  'goal.roadAccess.hint':
    'Karayolu (4) ile terminalden haritanın altındaki otoyola bir yol çiz. Yolcular yoldan gelir.',
  'goal.standRoad': 'Standa yol götür',
  'goal.standRoad.hint':
    'Standın bir kenarına karayolu değdir ve bu yolu yol ağına bağla: yer araçları yoldan gelir.',
  'goal.taxiLine': 'Pisti ve standı sarı çizgiyle bağla',
  'goal.taxiLine.hint':
    'Taksi yolu (5) döşe, sonra Taksi çizgisi (6) ile pistin uzun kenarından standın kenarına sarı çizgi çiz.',
  'goal.contract': 'İlk havayolu sözleşmesini imzala',
  'goal.contract.hint': 'Uçuşlar (U) → Teklifler → Sözleşmeyi incele → İmzala.',
  'goal.firstFlight': 'İlk uçuşu karşıla',
  'goal.firstFlight.hint':
    'Oyunu hızlandır ve bekle: uçak inecek, standa gelecek, hizmet alıp kalkacak.',
  'goal.flights10': '10 sefer karşıla',
  'goal.flights10.hint': 'Daha çok sözleşme imzala; kapasite uyarılarına dikkat et.',
  'goal.handling': 'Yer Hizmetleri Üssü kur',
  'goal.handling.hint':
    'Kendi araç filon taşerondan hızlı ve ücretsiz çalışır. Yol ağına bağlamayı unutma.',
  'goal.rating': 'Puanını 3,5 yıldıza çıkar',
  'goal.rating.hint': 'Sosyal (K) → Puanlar: hangi kategorinin düşük olduğuna bak.',
  'goal.runway2': 'Pisti Sv.3 yap (ışıklar)',
  'goal.runway2.hint':
    'Pist ışıkları ve CAT I ILS gece uçuşlarını ve ince siste inişi açar. Yükseltme sırasında pist kapanır!',
  'goal.narrowbody': 'İlk dar gövdeli uçağı karşıla',
  'goal.narrowbody.hint': 'Pist Sv.2 olunca havayolları dar gövdeli uçak teklif eder.',
  'goal.flights50': '50 sefer karşıla',
  'goal.flights50.hint': 'Büyümeye devam: stand, terminal ve personel kapasitesini dengede tut.',
  'goal.transit': 'Taksi ve otobüs durağı kur',
  'goal.transit.hint':
    'Terminalin 30 kare yakınına, yola bağlı kur: ek gelir ve daha mutlu yolcular.',
  'goal.terminal3': 'Terminali Sv.3 yap',
  'goal.terminal3.hint': 'Daha büyük terminal daha hızlı check-in ve daha çok mağaza geliri demek.',
  'goal.widebody': 'İlk geniş gövdeli uçağı karşıla',
  'goal.widebody.hint': 'Pist Sv.4 ve itfaiye Sv.2 gerekir.',
  'goal.flights200': '200 sefer karşıla',
  'goal.flights200.hint': 'Artık bölgenin önemli havalimanlarından birisin.',
  'goal.millionaire': 'Kasada 1.000.000 $',
  'goal.millionaire.hint': 'Giderlerini izle: Yönetim (M) → Finans.',
  'goal.rating5': 'Puanını 4,5 yıldıza çıkar',
  'goal.rating5.hint': 'Dakik, kuyruksuz, konforlu ve makul fiyatlı bir havalimanı.',
  'settings.volume': 'Ses',
  'settings.soundMix': 'Ses kanalları',
  'settings.mixEngines': 'Uçaklar',
  'settings.mixWorld': 'Çevre',
  'settings.mixInterface': 'Arayüz',
  'finance.history': 'Son günler',
  'finance.historyEmpty': 'Birkaç gün oynadıkça gelir, gider ve sefer grafikleri burada görünür.',
  'finance.flights': 'Seferler',
  'building.cargoTerminal': 'Kargo Terminali',
  'desc.cargoTerminal':
    'Kargo havayollarını getirir: penceresiz kargo uçakları çoğunlukla geceleri gelir, ton başına elleçleme ücreti öder. Seviye arttıkça yükleme hızlanır ve ücret artar. Tırlar için yol bağlantısı gerekir.',
  'cargo.chip': 'Kargo',
  'paper.freight': 'yaklaşık {t} ton yük',
  'ledger.cargo': 'Kargo elleçleme',
  'goal.freight': 'İlk kargo seferini karşıla',
  'goal.freight.hint':
    'Kule Sv.2 ile Kargo Terminali kur ve yola bağla; kargo havayolları teklif vermeye başlar.',
  'staff.shiftLead':
    'Gece (22:00–06:00) her ekip tam, yarım ya da hiç çalışmayabilir; gece saatleri %25 zamlı ödenir. Sözleşmelerinde gece {n} iniş var.',
  'staff.night': 'Gece vardiyası',
  'staff.night.100': 'Tam',
  'staff.night.50': 'Yarım',
  'staff.night.0': 'Yok',
  'menu.startKind': 'Başlangıç',
  'menu.start.empty': 'Boş arazi',
  'menu.start.emptySub': 'Her şeyi sıfırdan kur',
  'menu.start.demo': 'Hazır havalimanı',
  'menu.start.demoSub': 'Pist, terminal, 5 stand ve ilk sözleşmeler hazır',
  'diag.inbound': 'Kalkış havalimanından rötarlı',
  'board.expected': 'Tahmini {time}',
  'ledger.noise': 'Gürültü cezası',
  'noise.quota': 'Gece gürültü kotası: {used}/{quota} puan',
  'noise.title': 'Gece gürültüsü',
  'noise.parts': 'Kota: temel {base} · kule +{tower} · ses yalıtımı +{homes}',
  'noise.insulate': 'Evlere ses yalıtımı {step}/{of} (+{points} puan) · {cost}',
  'noise.insulationTower': 'Sonraki yalıtım adımı kule seviye {level} ister.',
  'noise.insulationDone': 'Ses yalıtımı programı tamamlandı.',
  'noise.help':
    'Gece 22:00–06:00 iniş-kalkışları puan sayar; kotayı aşan her puan ceza ve kötü haber getirir. Kule yükseldikçe kota artar; çevredeki evlere ses yalıtımı yaptırmak kotayı kalıcı olarak büyütür.',
  'toast.noise': 'Gece gürültü kotası aşıldı: {amount} ceza, çevre sakinleri şikâyetçi',
  'capacity.noise':
    'Gece uçuşları bir gecede ~{need} gürültü puanı yazar, kota {have}: aşan her puan ceza ve şikâyet getirir.',
  'building.hotel': 'Otel',
  'building.cafe': 'Kafe',
  'desc.cafe':
    'Şemsiyeli terasıyla küçük bir kafe. Terminale yakınsa (40 kare) yolculara, her yerde şehirden gelenlere ve iş merkezi çalışanlarına satar; her satıştan havalimanı pay alır. Yanındaki dükkânlar, park ve AVM daha çok müşteri getirir; terminale yakın yeme-içme yeri yolcuların konforunu artırır. Karayoluna bağla.',
  'building.restaurant': 'Restoran',
  'desc.restaurant':
    "Pergolalı terasıyla bir restoran: daha az ama daha çok harcayan müşteri. Öğle saatinde iş merkezi çalışanları akın eder; terminale yakınsa yolcular da gelir. Kafe ve AVM'nin yanında daha çok kazanır. Karayoluna bağla. Kule Sv.2 gerekir.",
  'building.mall': 'AVM',
  'desc.mall':
    "Cam atriyumlu büyük bir alışveriş merkezi, otoparkıyla. Şehirden en çok ziyaretçiyi o çeker; yolcular 80 kareye kadar uzaktan gelir. Çevresindeki (24 kare) kafe ve restoranlara müşteri taşır. Sv.3'te sinema ve çatı yemek terası. Karayoluna bağla. Kule Sv.3 gerekir.",
  'building.fuelStation': 'Akaryakıt İstasyonu',
  'desc.fuelStation':
    'Kanopili pompaları ve marketiyle bir benzinlik: terminale yolcu getiren arabalar ve şehirden gelenler yakıt alır. Terminale giden yolun üstüne kur. Sv.2: üçüncü pompa adası, oto yıkama ve elektrikli şarj. Karayoluna bağla.',
  'building.officePark': 'İş Merkezi',
  'desc.officePark':
    "Cam bir ofis kulesi: kiracıları her gün kira öder, havalimanının puanı yükseldikçe doluluk ve kira artar. Her seviyede 120 çalışan; sabah ve öğleden sonra kafelere, öğlen restoranlara giderler. Sv.3'te çatıda helikopter pisti. Karayoluna bağla. Kule Sv.3 gerekir.",
  'building.cityPark': 'Park',
  'desc.cityPark':
    'Havuzlu, ağaçlı, banklı bir park: kendisi para kazanmaz ama 20 kare içindeki her dükkânı daha çekici yapar (seviye başına +%10). Sv.2: oyun alanı, çiçek tarhları ve gölet. Yola bağlanması gerekmez.',
  'city.title': 'Havalimanı şehri',
  'city.customers': 'Bu saat {n}/{of} müşteri',
  'city.attraction': 'Çekicilik %{pct}: park +{park}, çevredeki dükkânlar +{street}, AVM +{mall}',
  'city.nearTerminal': 'Terminale yakın: yolcular da geliyor.',
  'city.farTerminal':
    'Terminale uzak: yolcular gelmiyor, yalnız şehirden gelenler. Terminalin yakınına kur.',
  'city.full': 'Kapasite dolu: yükseltirsen daha çok müşteriye hizmet eder.',
  'city.closed': 'Karayoluyla otoyola bağlı değil: müşteri gelmiyor.',
  'city.office':
    '{workers} çalışan · günlük kira {rent} (doluluk %{occupancy}, puan yükseldikçe artar)',
  'city.park': '{reach} kare içindeki her dükkân seviye başına %{bonus} daha çok müşteri çeker.',
  'city.today': 'Bugün tüm şehir: {sales} satış, {customers} müşteri, {rent} kira',
  'desc.hotel':
    'Erken uçuşu olan yolcular ve havayolu ekipleri konaklar: her gece oda geliri getirir, konfor puanını artırır. Seviye arttıkça oda sayısı ve fiyat yükselir. Yol bağlantısı gerekir.',
  'ledger.commerce': 'Şehir satışları',
  'ledger.rent': 'Ofis kirası',
  'ledger.hotel': 'Otel',
  'ledger.transfers':
    'Aktarma: {n} yolcu bağlantı yaptı · {missed} kaçırdı (tazminat cezalara yazılır)',
  'goal.hub': 'Bir günde 100 aktarma yolcusu',
  'goal.hub.hint':
    'En az iki yolcu hattı aktarma getirir; hat sayısı arttıkça oran büyür. İnişleri kalkışlardan 1 saat önce topla.',
  'weekday.0': 'Pzt',
  'weekday.1': 'Sal',
  'weekday.2': 'Çar',
  'weekday.3': 'Per',
  'weekday.4': 'Cum',
  'weekday.5': 'Cmt',
  'weekday.6': 'Paz',
  'weekday.long.0': 'Pazartesi',
  'weekday.long.1': 'Salı',
  'weekday.long.2': 'Çarşamba',
  'weekday.long.3': 'Perşembe',
  'weekday.long.4': 'Cuma',
  'weekday.long.5': 'Cumartesi',
  'weekday.long.6': 'Pazar',
  'season.0': 'İlkbahar: normal yoğunluk',
  'season.1': 'Yaz: tatil sezonu, dolu uçaklar ve daha çok teklif',
  'season.2': 'Sonbahar: biraz sakin',
  'season.3': 'Kış: sakin sezon, kar ve buzlanma',
  'hold.17': 'Pist kar nedeniyle kapalı',
  'wx.runwaySnow': 'Pistte kar %{pct}',
  'wx.snowClosed': 'Pistte kar %{pct}: kar nedeniyle kapalı pist var',
  'toast.dustStarted':
    'Kum fırtınası başladı 💨 Görüş düştü: pas geçmeler artar, apron işleri yavaşlar.',
  'toast.dustEnded': 'Kum fırtınası dindi, görüş açılıyor.',
  'toast.snowDeep':
    '{runway} pistinde kar birikiyor, ekipler yetişemiyor. Kar küreme araçlarını şimdiden gönderebilirsin.',
  'toast.snowClosed':
    '{runway} pisti kar nedeniyle kapandı! Uçaklar inemiyor: kar küreme araçlarını yönlendir.',
  'toast.snowOverdue': '{runway} pisti 12 saattir kapalıydı: ekipler sonunda kendileri çıktı.',
  'toast.snowCleared': '{runway} pisti temizlendi, uçuşlara yeniden açık.',
  'toast.ploughsOut': 'Kar küreme ekibi yola çıktı: {n} araç, {runway} pistine.',
  'toast.blizzardWarning':
    'Meteoroloji uyarısı: 6 saat içinde kar fırtınası bekleniyor. Pistler kapanabilir, kar küreme ekibini hazır tut.',
  'toast.blizzardStarted': 'Kar fırtınası başladı: görüş çok düşük, pistlerde kar hızla birikiyor.',
  'toast.blizzardEnded': 'Kar fırtınası dindi.',
  'snow.closed': '{runway} pisti kar nedeniyle kapalı',
  'snow.holding': '{flight} inemiyor · {n} uçak havada bekliyor',
  'snow.waiting': 'Uçuşlar bu pisti kullanamıyor',
  'snow.dispatch': 'Kar küreme araçlarını yönlendir',
  'snow.dispatchContractor': 'Yükleniciyi çağır ({cost})',
  'snow.dispatchHint':
    'Ekip yer hizmetleri üssünden çıkar, pisti iki turda temizler. Üssün yoksa yüklenici yoldan gelir, daha geç varır.',
  'snow.enRoute': 'Kar küreme ekibi yolda · {n} araç · ~{min} dk',
  'snow.pass': 'Pist temizleniyor · {pass}. tur · %{pct}',
  'snow.returning': 'Pist temiz · ekip dönüyor',
  'snow.markerDeep': 'Kar birikiyor %{pct}',
  'snow.markerClosed': 'KAPALI · kar %{pct}',
  'snow.blizzardSoon': 'Kar fırtınası yaklaşıyor (~{h} sa): pistler kapanabilir',
  'snow.blizzardNow': 'Kar fırtınası sürüyor',
  'snowfall.1': 'Hafif kar',
  'snowfall.2': 'Orta şiddette kar',
  'snowfall.3': 'Yoğun kar',
  'snowfall.4': 'Kar fırtınası',
  'rwy.snow': 'Pistte kar',
  'rwy.snowClear': 'Pist temiz',
  'intl.chip': 'Dış hat',
  'paper.international':
    'Uluslararası sefer: yolcu ücreti %50, mağaza harcaması %60 daha yüksek; pasaport kontrolü check-in süresini uzatır.',
  'goal.international': 'İlk dış hat sözleşmesini imzala',
  'goal.international.hint':
    'Terminali Sv.2 yap (pasaport kontrolü): uluslararası havayolları teklif vermeye başlar.',
  'ledger.overdraft': 'Kasa açığı faizi',
  'toast.inRed':
    'Kasa eksiye düştü: bakiyeye günlük %0,6 faiz işliyor ve havayolları daha az teklif veriyor. Kredi al ya da giderleri kıs.',
  'mgmt.tab.airlines': 'Havayolları',
  'airlines.lead':
    '{total} havayolundan {n} tanesi burada uçuyor. Memnuniyet dakikliğe ve iptallere bağlı; düşük puanlı havayolu sözleşmeyi askıya alabilir, yüksek puanlı yenilerken sefer ekler.',
  'airlines.kind.domestic': 'İç hat',
  'airlines.kind.intl': 'Dış hat',
  'airlines.kind.cargo': 'Kargo',
  'airlines.flying': 'Günde {n} sefer · {served} uçuş, {cancelled} iptal · {revenue} gelir',
  'airlines.offer': 'Masada bir teklifi var',
  'airlines.none': 'Şu an ilgilenmiyor; puanın ve ücretlerin teklif sıklığını belirler',
  'airlines.needs.passports': 'Pasaport kontrolü (Terminal Sv.2) bekliyor',
  'airlines.needs.cargo': 'Kargo terminali bekliyor',
  'airlines.score': 'Memnuniyet',
  'facility.title': 'Terminal olanakları',
  'facility.checkIn': 'Ek check-in bankosu',
  'facility.security': 'Ek güvenlik hattı',
  'facility.lounge': 'VIP salonu',
  'facility.shops': 'Duty free mağaza',
  'facility.checkIn.effect': 'Check-in ve bagaj aşaması +%35',
  'facility.security.effect': 'Güvenlik aşaması +%45',
  'facility.lounge.effect': 'Konfor puanı artar, her yolcudan salon geliri',
  'facility.shops.effect': 'Mağaza geliri +%25',
  'facility.metro': 'Metro istasyonu',
  'facility.metro.effect':
    'Yolcuların %20si metroyla gelir (yol ve kavşak yükü düşer), konfor ve memnuniyet artar, her yolcudan bilet payı',
  'facility.needsLevel': 'Terminal Sv.{level} gerekir',
  'reason.requiresLevel': 'Bina seviyesi yetersiz',
  'chat.placeholder': 'Mesaj yaz, Enter ile gönder',
  'chat.open': 'Sohbet (Enter)',
  'menu.mapTheme': 'Arazi',
  'menu.mapTheme.0': 'Yeşil Vadi',
  'menu.mapTheme.0.sub': 'Ilıman iklim, dört mevsim',
  'menu.mapTheme.1': 'Çöl',
  'menu.mapTheme.1.sub': 'Kavurucu yazlar, kum fırtınaları, vahalar',
  'menu.mapTheme.2': 'Karlı Dağlar',
  'menu.mapTheme.2.sub': 'Sert kışlar, bol kar, vadi sisi',
  'menu.mapSize': 'Harita',
  'menu.mapSize.normal': 'Normal (256)',
  'menu.mapSize.large': 'Geniş (384)',
  'charter.chip': 'Charter',
  'event.cupFinal': 'Kupa finali',
  'event.festival': 'Yaz festivali',
  'event.concert': 'Stadyum konseri',
  'event.fair': 'Uluslararası fuar',
  'event.congress': 'Tıp kongresi',
  'event.pilgrimage': 'Umre dönemi',
  'paper.charter':
    'Etkinlik için kısa bir seri: uçaklar neredeyse dolu, yolcu ücreti %40 fazla; etkinlik bitince sözleşme yenilenmez.',
  'building.railStation': 'Tren İstasyonu',
  'desc.railStation':
    'Terminale yakın kurulunca yolcular trenle gelir: her yolcudan ulaşım imtiyazı, daha mutlu yolcular ve konfor puanı. Kule Sv.4 gerekir; Sv.2 ikinci peron ve tren ekler.',
  'news.title': 'Yenilikler',
  'news.ok': 'Hadi oynayalım',
  'news.demo': 'Hazır havalimanı',
  'news.demo.text':
    'Yeni oyunda "Başlangıç: Hazır havalimanı" seç: pist, 5 stand, terminal, kargo, otel ve ilk sözleşmelerle başla.',
  'news.transfers': 'Aktarma yolcuları',
  'news.transfers.text':
    'İki ve daha fazla hatla yolcuların bir kısmı burada aktarma yapar (⇄). İnişleri kalkışlardan önce topla.',
  'news.international': 'Dış hatlar',
  'news.international.text':
    'Terminal Sv.2 pasaport kontrolüyle uluslararası havayollarını getirir: daha çok kazanç, daha uzun işlem.',
  'news.charter': 'Charter seferleri',
  'news.charter.text':
    'Kupa finali, festival gibi etkinlikler için 2 günlük, dolu ve kazançlı seriler.',
  'news.seasons': 'Hafta günleri ve mevsimler',
  'news.seasons.text':
    'Cuma ve Pazar dolu, yaz yoğun, kış sakin ve karlı. Üst çubukta gün ve mevsim.',
  'news.snow': 'Kar temizliği',
  'news.snow.text': 'Kışın pistte kar birikir; kar ekipleri temizler, çok birikirse pist kapanır.',
  'news.shifts': 'Gece vardiyaları',
  'news.shifts.text':
    'Yönetim → Personel: her ekip için gece tam / yarım / yok. Gece saatleri zamlı.',
  'news.noise': 'Gece gürültü kotası',
  'news.noise.text':
    'Gece iniş-kalkışları puan yazar; kotayı aşan her puan ceza ve şikâyet getirir.',
  'news.facilities': 'Terminal olanakları',
  'news.facilities.text': 'Terminali seç: ek check-in, güvenlik hattı, VIP salonu ve duty free.',
  'news.hotel': 'Otel',
  'news.hotel.text': 'Yolcular ve havayolu ekipleri konaklar; her gece oda geliri.',
  'news.rail': 'Tren istasyonu',
  'news.rail.text': 'Terminalin yanına kur: yolcular trenle gelir, gelir ve konfor artar.',
  'news.cargo': 'Hava kargo',
  'news.cargo.text':
    'Kargo terminaliyle kargo havayolları gece uçar, ton başına ücret öder; tırlar gelir.',
  'news.airlines': 'Havayolları sekmesi',
  'news.airlines.text': 'Yönetim → Havayolları: kim uçuyor, ne kadar memnun, kim ne bekliyor.',
  'news.coop': 'Co-op sohbet ve işaret',
  'news.coop.text': 'Enter ile mesaj yaz, Alt+tık ile haritada bir yeri herkese göster.',
  'news.night': 'Gece görünümü',
  'news.night.text': 'Ay ışığı, taksi yolu ışıkları, uçak farları ve yanıp sönen işaret ışıkları.',
  'news.largeMap': 'Geniş harita',
  'news.largeMap.text': 'Boş araziyle başlarken 384×384 haritayı seç.',
  'building.constructionOffice': 'İnşaat Ofisi',
  'desc.constructionOffice':
    'Her seviyesi aynı anda çalışabilen inşaat ekibi sayısını bir artırır. Kule Sv.2 gerekir.',
  'news.office': 'İnşaat Ofisi',
  'news.office.text': 'Her seviyesi aynı anda bir inşaat ekibi daha çalıştırır.',
  'building.cateringKitchen': 'Catering Mutfağı',
  'desc.cateringKitchen':
    'Havayollarına yolcu başına yemek satar ve catering yüklemesini %30 hızlandırır. Kule Sv.3, yol bağlantısı gerekir.',
  'ledger.catering': 'Catering satışı',
  'news.kitchen': 'Catering Mutfağı',
  'news.kitchen.text': 'Havayollarına yolcu başına yemek satar, catering yüklemesini hızlandırır.',
  'hud.noiseMap': 'Gürültü haritası (N): pistlerin çevresindeki gürültü konturları',
  'news.noiseMap': 'Gürültü haritası',
  'news.noiseMap.text':
    'N tuşu ya da üst çubuktaki "dB": pistlerin çevresindeki gürültü konturları.',
  'tutorial.title': 'Başlangıç rehberi',
  'tutorial.step': 'Adım {n}/{of}',
  'tutorial.next': 'İleri',
  'tutorial.back': 'Geri',
  'tutorial.try': 'Dene',
  'tutorial.done': 'Başlayalım',
  'welcome.kicker': 'Airport Manager 2027',
  'welcome.title': 'Hoş geldin, Kaptan!',
  'welcome.text':
    "Ben Kaptan Kanat. Bu boş araziyi birlikte, uçakların inip kalktığı bir havalimanına çevireceğiz. İstersen sana adım adım yol göstereyim; dilediğin an atlayabilirsin, dersler her zaman Akademi'de.",
  'welcome.point1': 'Kule, pist ve terminalle başla',
  'welcome.point2': 'Havayollarıyla sözleşme imzala, ilk uçuşu karşıla',
  'welcome.point3': 'Hedefleri tamamla, havalimanını büyüt',
  'welcome.start': 'Öğreticiyi başlat',
  'welcome.skip': 'Öğreticiyi geç',
  'lesson.gotIt': 'Anladım',
  'lesson.confirmFirst': 'Önce maddeleri onayla',
  'tutorial.skip': 'Rehberi kapat',
  'tutorial.skipAll': 'Öğreticiyi geç',
  'tutorial.skipShort': 'Geç',
  'tutorial.restart': 'Başlangıç rehberini yeniden göster',
  'tutorial.0.title': 'Havalimanına hoş geldin',
  'tutorial.0.text':
    'Burayı sıfırdan bir havalimanına çevireceksin: pist, terminal, yollar, sonra havayolları ve uçuşlar. Kamerayı sağ tıkla ya da WASD ile kaydır, tekerlekle yakınlaştır, Q/E ile döndür.',
  'tutorial.1.title': 'Arazi al',
  'tutorial.1.text':
    'Küçük bir arsayla başlarsın. Arazi aracıyla (2) mevcut arazine bitişik parselleri satın al; pist uzundur, yer lazım.',
  'tutorial.2.title': 'Kule, pist ve stand',
  'tutorial.2.text':
    'İnşa aracını (3) aç: önce kontrol kulesi (yeni binaları o açar), sonra pist ve en az bir stand. R binayı döndürür. Binaları sonradan seçip "Taşı" ile yerini değiştirebilirsin.',
  'tutorial.3.title': 'Taksi yolu',
  'tutorial.3.text':
    'Taksi yolu aracıyla (5) pistten standa giden yolu sürükleyerek çiz. Yol 4×4 bloklarla döşenir; ucunu piste ya da standa yaklaştırman yeter, kendisi birleşir.',
  'tutorial.4.title': 'Sarı taksi çizgisi',
  'tutorial.4.text':
    'Uçaklar sarı çizgiyi izler. Taksi çizgisi aracıyla (6) pistin kenarından standın önüne kadar çizgi çiz. Turuncu uyarı işareti çizginin eksik olduğunu gösterir.',
  'tutorial.5.title': 'Terminal ve karayolu',
  'tutorial.5.text':
    'Terminal kur, sonra Karayolu aracıyla (4) terminali, standları ve hizmet binalarını otoyola bağla. Kırmızı işaret yol olmadığını, pembe işaret yolun otoyola ulaşmadığını söyler.',
  'tutorial.6.title': 'Uçuşları al',
  'tutorial.6.text':
    'Uçuşlar panelinden (U) teklifleri kabul et; uçaklar gelmeye başlar. İlk kulede özel jetler gelir, yolcu havayolları için kuleyi 2. seviyeye yükselt. Gece uçuşları için pisti 3. seviyeye (pist ışıkları) yükselt. Sol üstteki hedefler seni adım adım götürür.',
  'academy.title': 'Akademi',
  'academy.button': 'Akademi',
  'academy.sub': 'Kılavuz ve dersler',
  'academy.search': 'Kılavuzda ara…',
  'academy.lessons': 'Dersler',
  'academy.buildings': 'Binalar',
  'academy.reference': 'Başvuru',
  'academy.keys': 'Tuş kısayolları',
  'academy.results': 'Arama sonuçları',
  'academy.noResults': 'Hiçbir şey bulunamadı. Başka bir kelime dene.',
  'academy.building': 'Bina',
  'academy.welcome': "Akademi'ye hoş geldin",
  'academy.intro':
    'Oyunla ilgili her şey burada: adım adım dersler, her konunun ayrıntılı anlatımı ve her binanın seviye tablosu. İstediğin an F1 ile açabilirsin. Yeni başlıyorsan "Temeller" dersiyle başla.',
  'academy.topics': 'Konular',
  'academy.steps': '{n} adım',
  'academy.pages': '{n} sayfa',
  'academy.done': 'Tamamlandı',
  'academy.show': 'Oyunda göster',
  'academy.lesson': 'Ders: {name}',
  'academy.related': 'İlgili konular',
  'academy.read': 'Kılavuzda oku',
  'academy.start': 'Dersi başlat',
  'academy.replay': 'Dersi yeniden yap',
  'academy.inGameOnly': "Dersler oyun içinde çalışır: bir oyun başlatıp Akademi'yi (F1) oradan aç.",
  'academy.footprint': '{w}×{h} kare',
  'academy.levels': 'Seviyeler',
  'academy.level': 'Seviye',
  'academy.cost': 'Maliyet',
  'academy.time': 'Süre',
  'academy.tower': 'Kule',
  'academy.limits': 'Kule seviyesine göre en çok adet',
  'academy.count': 'Adet',
  'academy.place': 'Yerleştir',
  'academy.aircraft': 'Uçaklar',
  'academy.drag': 'Sürükle: döndür · Tekerlek: yakınlaş',
  'academy.seats': 'Koltuk',
  'academy.turnaround': 'Turnaround',
  'academy.runwayLevel': 'Gereken pist',
  'academy.standLevel': 'Gereken stand',
  'academy.towerLevel': 'Gereken kule',
  'academy.fireLevel': 'Gereken itfaiye',
  'academy.crosswind': 'Yan rüzgâr sınırı',
  'academy.wake': 'İz türbülansı',
  'academy.wake.0': 'Hafif',
  'academy.wake.1': 'Orta',
  'academy.wake.2': 'Ağır',
  'academy.landingFee': 'İniş ücreti',
  'academy.militaryFee': 'Bakanlık ödemesi (sefer başı)',
  'lesson.waiting': 'Yapınca kendiliğinden ilerler',
  'lesson.doneNow': 'Tamam!',
  'lesson.manual': 'Kılavuz',
  'lesson.show': 'Göster',
  'lesson.skipStep': 'Atla',
  'help.title': 'Nasıl oynanır',
  'help.ok': 'Anladım',
  'help.credits': 'Emeği geçenler',
  'help.creditsNote':
    '3D uçak, araç ve bina modelleri (Sketchfab): oyun için ölçeklendi, sadeleştirildi ve boyandı.',
  'help.step.1':
    'Kontrol kulesini kur (İnşa → Kule). Kule seviyesi diğer binaların sayısını ve seviyesini açar.',
  'help.step.2':
    'Pist, terminal ve stand kur; karayolunu otoyola bağla (stand ve üsler de yol ister).',
  'help.step.3':
    'Taksi yolu döşe ve sarı taksi çizgisini pistten standa çiz; uçaklar yalnızca sarı çizgiyi izler.',
  'help.step.4':
    'Uçuşlar (U) panelinden havayolu tekliflerini oku ve imzala; kapasite uyarılarına dikkat et.',
  'help.step.5':
    'Yer hizmetleri, itfaiye, yakıt ve personeli (M) büyüt; rötar analiziyle darboğazları bul.',
  'help.step.6': 'Kuleyi yükselt, arazi al ve kargo, otel, tren, dış hat ve aktarma ile büyü.',
  'help.key.tools': 'Araçlar: seç, arazi, inşa, karayolu, taksi yolu, taksi çizgisi, buldozer',
  'help.key.pan': 'Kamerayı kaydır (sağ tık sürükle de olur)',
  'help.key.rotate': 'Kamerayı döndür',
  'help.key.rotateBuilding': 'Yerleştirilen binayı döndür',
  'help.key.pause': 'Duraklat / devam',
  'help.key.flights': 'Uçuşlar paneli',
  'help.key.management': 'Yönetim: personel, finans, havayolları',
  'help.key.social': 'Sosyal medya',
  'help.key.noiseMap': 'Gürültü haritası',
  'help.key.save': 'Hızlı kayıt',
  'help.key.chat': 'Co-op sohbet',
  'help.key.ping': 'Co-op: haritada bir yeri işaretle',
  'help.key.cancel': 'İptal / seçimi bırak',
  'help.key.help': 'Bu yardım',
  'mgmt.tab.marketing': 'Pazarlama',
  'marketing.lead':
    'Havalimanını tanıt: sosyal medya gündemi hemen yükseltir, havayolu tanıtım turu iki gün boyunca daha çok teklif getirir.',
  'marketing.social': 'Sosyal medya kampanyası',
  'marketing.social.text':
    'Gündem hemen yükselir (iyi gündem daha çok teklif getirir). Günde bir kez.',
  'marketing.roadshow': 'Havayolu tanıtım turu',
  'marketing.roadshow.text':
    'Rota geliştirme ekibi havayollarını ziyaret eder: 2 gün boyunca %50 daha sık teklif.',
  'marketing.ready': 'Hazır',
  'marketing.again': '{h} saat sonra yeniden',
  'marketing.running': 'Sürüyor: {h} saat kaldı',
  'ledger.marketing': 'Pazarlama',
  'news.marketing': 'Pazarlama kampanyaları',
  'news.marketing.text': 'Yönetim → Pazarlama: sosyal medya kampanyası ve havayolu tanıtım turu.',
  'finance.pax': 'Yolcu',
  'finance.onTime': 'Zamanında kalkış %',
  'sky.5': 'Gök gürültülü fırtına',
  'diag.weather': 'Hava (yıldırım uyarısı, kum fırtınası)',
  'wx.storm': 'Fırtına: yıldırım uyarısı, apron çalışmaları durdu',
  'news.storm': 'Gök gürültülü fırtına',
  'news.storm.text':
    'Yazın sıcak yağmur fırtınaya döner: şimşek çakar, yıldırım uyarısıyla apron durur.',
  'ledger.bags':
    'Kayıp bagaj: {n} (her biri 60 $ tazminat). Kendi tam kadrolu yer hizmetin daha az kaybeder.',
  'goal.office': 'İnşaat Ofisi kur',
  'goal.office.hint': 'Kule Sv.2 ile: aynı anda bir inşaat ekibi daha çalışır.',
  'goal.hotel': 'Otel aç',
  'goal.hotel.hint': 'Kule Sv.3 ile kara tarafına, yol kenarına bir otel kur.',
  'goal.kitchen': 'Catering Mutfağı kur',
  'goal.kitchen.hint': 'Kule Sv.3 ile: havayollarına yemek sat, catering hızlansın.',
  'goal.charter': 'İlk charter seferini imzala',
  'goal.charter.hint':
    'Pist Sv.2 ile etkinlik teklifleri gelir; Uçuşlar panelinde kırmızı "Charter" etiketine bak.',
  'goal.rail': 'Tren istasyonu aç',
  'goal.rail.hint': 'Kule Sv.4 ile terminalin yanına kur: yolcular trenle gelsin.',
  'staff.wage.title': 'Ücret düzeyi',
  'staff.wage.low':
    'Düşük ücret: maaştan tasarruf, ama her sabah %{pct} grev riski ve biraz daha az iş.',
  'staff.wage.high': 'Yüksek ücret: herkes %{pct} daha verimli, aynı işi daha az kişi yapar.',
  'staff.wage.normal': 'Piyasa ücreti: grev riski yok.',
  'staff.strike': 'GREV: ekiplerin yarısı iş bıraktı ({h} saat daha). Ücretleri artır ya da bekle.',
  'toast.strike': 'Grev! Düşük ücret yüzünden ekiplerin yarısı iş bıraktı.',
  'toast.strikeOver': 'Grev sona erdi, ekipler işbaşında.',
  'news.wages': 'Ücret politikası ve grev',
  'news.wages.text':
    'Yönetim → Personel: ücret düzeyini seç. Düşük ücret grev riski, yüksek ücret verimlilik getirir.',
  'building.wildlifeControl': 'Yaban Hayatı Kontrol',
  'desc.wildlifeControl':
    'Şahinciler ve kuş kovucular kuşları yaklaşma yolundan uzak tutar: kuş çarpmalarının %70’i hiç olmaz. Kule Sv.2 gerekir.',
  'finance.value': 'Havalimanı değeri',
  'finance.valueHint': 'Binaların defter değeri (maliyetin %60’ı) + kasa − kalan kredi borcu',
  'goal.value10m': 'Havalimanı değerini 10 milyon $ yap',
  'goal.value10m.hint': 'Yönetim → Finans’ta görünür: binalar, kasa ve borç birlikte.',
  'hold.18': 'Pist bakımda (yüzey yenileme)',
  'pave.title': 'Pist yüzeyi',
  'pave.new': 'Yeni',
  'pave.good': 'İyi',
  'pave.worn': 'Aşınmış',
  'pave.poor': 'Kötü',
  'pave.fod':
    'Lastik birikintisi ve döküntü: her inişte %{pct} lastik hasarı riski (tazminatı havalimanı öder).',
  'pave.fine': 'Yüzey temiz: döküntü riski yok.',
  'pave.planned': 'Bakım planlandı: pist {from}–{until} arası kapalı.',
  'pave.underway': 'Bakım sürüyor: pist {until} saatine kadar kapalı.',
  'pave.tonight': 'Bu gece 01:00 · {cost}',
  'pave.now': 'Hemen başlat',
  'pave.hint':
    'Her iniş pisti aşındırır, ağır uçaklar daha çok. Yüzey yenileme (lastik temizliği ve onarım) pisti {hours} saat kapatır.',
  'toast.runwayWorn': 'Pist aşınıyor: lastik birikintisi döküntü riski yaratıyor. Bakım planla.',
  'toast.runwayPoor': 'Pist yüzeyi kötü durumda! Lastik hasarları sıklaşacak.',
  'toast.fod': 'Pistteki döküntü bir uçağın lastiğini kesti: lastik değişimi ve {amount} tazminat.',
  'toast.worksStarted': 'Pist bakımı başladı: pist kapalı.',
  'toast.worksDone': 'Pist bakımı bitti: yüzey yeni gibi.',
  'news.pavement': 'Pist aşınması ve bakımı',
  'news.pavement.text':
    'Her iniş piste lastik bırakır. Aşınmış pistte döküntü lastik keser; pisti seç, bakımı bu geceye planla.',
  'news.value': 'Havalimanı değeri',
  'news.value.text': 'Yönetim → Finans: binalar, kasa ve borç tek rakamda. Hedef 10 milyon $.',
  'sky.6': 'Kum fırtınası',
  'fc.title': 'Hava tahmini',
  'fc.hint': 'Uzak saatler daha belirsiz',
  'fc.fog': '{time} civarı sis bekleniyor: Sv.3 pist ince siste iner, yoğun siste yalnız Sv.4.',
  'fc.storm': '{time} civarı fırtına bekleniyor: şimşekte apron işleri durur.',
  'fc.snow': '{time} civarı kar bekleniyor: kar temizliği ve buz çözme hazır olsun.',
  'fc.blizzard':
    '{time} civarı kar fırtınası bekleniyor: pistler kapanabilir, kar küreme ekibi hazır olsun.',
  'fc.icing': '{time} civarı buzlanma: kalkışlar buz çözme ister.',
  'fc.dust':
    '{time} civarı kum fırtınası bekleniyor: görüş düşer, pas geçmeler artar, apron işleri yavaşlar.',
  'fc.calm': 'Önümüzdeki saatlerde operasyonu zorlayacak hava beklenmiyor.',
  'wo.title': 'Önümüzdeki 7 gün',
  'wo.hint': 'Uzak günler daha belirsiz',
  'wo.snow': 'Kar %{pct}',
  'wo.rain': 'Yağmur %{pct}',
  'wo.storm': 'Fırtına %{pct}',
  'wo.blizzard': 'Kar fırtınası!',
  'wo.untilWinter': 'Kış {day}. günde başlıyor ({n} gün sonra); kar çoğunlukla kışın yağar.',
  'wo.winterNow': 'Kış sürüyor: {n} gün daha. Günlerin çoğunda kar yağar, pistleri temiz tut.',
  'seasonName.0': 'İlkbahar',
  'seasonName.1': 'Yaz',
  'seasonName.2': 'Sonbahar',
  'seasonName.3': 'Kış',
  'news.forecast': 'Hava tahmini ve CAT I ILS',
  'news.forecast.text':
    'Hava çipine tıkla ya da uçuş tablosuna bak: önümüzdeki 6 saat. CAT I ILS’li pist (Sv.3) ince siste iner.',
  'market.oil': 'Petrol',
  'market.barrel': 'varil',
  'market.economy': 'Ekonomi',
  'market.recession': 'Durgunluk',
  'market.weak': 'Zayıf',
  'market.normal': 'Normal',
  'market.strong': 'Güçlü',
  'market.boom': 'Patlama',
  'market.effects':
    'Etkisi: havayolu teklifleri %{offers}, doluluk {load} puan, yakıt satışı %{fuel}.',
  'toast.market.oilHigh': 'Petrol fiyatı fırladı: havayolları temkinli, yakıt satışı ise kârlı.',
  'toast.market.oilNormal': 'Petrol fiyatı normale döndü.',
  'toast.market.recession': 'Ekonomi durgunlukta: daha az yolcu, daha az yeni hat.',
  'toast.market.boom': 'Ekonomi patlamada: uçaklar dolu, havayolları yeni hat arıyor.',
  'toast.market.economyNormal': 'Ekonomi normale döndü.',
  'news.market': 'Petrol ve ekonomi',
  'news.market.text':
    'Yönetim → Finans: petrol fiyatı ve ekonomi günden güne değişir; talebi, doluluğu ve yakıt satışını etkiler. Hafif arka rüzgârda uçaklar artık pisti ters yönden de kullanır.',
  'year.title': '{year} yılı raporu',
  'year.passengers': 'Yolcu',
  'year.departures': 'Kalkış',
  'year.onTime': 'Dakiklik',
  'year.cancelled': 'İptal',
  'year.income': 'Gelir',
  'year.net': 'Net kâr',
  'year.rating': 'Puan',
  'year.bestDay': 'En yoğun gün: {day}. gün, {pax} yolcu.',
  'year.award.punctual': 'Dakiklik Ödülü',
  'year.award.punctual.text': 'Kalkışların en az %80’i zamanında.',
  'year.award.loved': 'Yolcuların Gözdesi',
  'year.award.loved.text': 'Yılı 4 yıldız ve üstüyle kapattın.',
  'year.award.busy': 'Yüz Bin Yolcu',
  'year.award.busy.text': 'Bir yılda 100.000 yolcuyu aştın.',
  'year.award.profit': 'Kârlı Yıl',
  'year.award.profit.text': 'Yıllık net kâr 1 milyon $’ı geçti.',
  'year.award.reliable': 'Sıfır İptal',
  'year.award.reliable.text': 'Bütün yıl tek bir uçuş iptal edilmedi.',
  'year.noAward': 'Bu yıl ödül yok. Dakiklik, puan ve kâr için hedefler koy, gelecek yıl dene!',
  'year.next': 'Yeni yıla başla',
  'news.yearReport': 'Yıl sonu raporu',
  'news.yearReport.text':
    'Her oyun yılı (28 gün) bitince yolcu, gelir, dakiklik ve puan özeti; iyi bir yıla ödüller.',
  'auth.login': 'Giriş yap',
  'auth.register': 'Kayıt ol',
  'auth.loginLead':
    'Kayıtlı oyunların hesabında, sunucuda saklanır: her cihazdan kaldığın yerden devam edersin.',
  'auth.registerLead': 'Bir hesap aç: tek oyunculu ve co-op kayıtların sunucuda saklanır.',
  'auth.username': 'Kullanıcı adı',
  'auth.password': 'Şifre',
  'auth.repeat': 'Şifre (tekrar)',
  'auth.rules': 'Kullanıcı adı 3–20 karakter: harf, rakam, _ . -  Şifre en az 6 karakter.',
  'auth.wait': 'Bekle…',
  'auth.logout': 'Çıkış',
  'menu.accountTitle': 'Hesap',
  'account.cardLocal': 'Bu cihazda oynuyorsun',
  'account.cardSync': 'Hesap aç: oyunun telefonda, tablette, bilgisayarda',
  'account.cardSynced': 'Oyunların hesabında, her cihazda',
  'account.local': 'Kayıt olmadan oynuyorsun.',
  'account.why':
    'Oyunların bu cihazda saklanır. Ücretsiz bir hesap açarsan sunucuda saklanır: telefondan, tabletten ya da bilgisayardan aynı havalimanına kaldığın yerden devam edersin. Bu cihazda oynadıkların da hesabına taşınır. Co-op, dünya sıralaması ve profil de hesapla açılır.',
  'account.needed': '{what} için ücretsiz bir hesap gerekir.',
  'account.signedInAs': '{name} olarak giriş yaptın',
  'account.syncOn':
    'Oyunların hesabında saklanıyor: telefon, tablet ya da bilgisayar, hangisinden girersen kaldığın yerden devam edersin.',
  'account.moved': 'Bu cihazdaki {n} oyun hesabına taşındı.',
  'account.delete': 'Hesabımı sil',
  'account.deleteWarn':
    'Hesabın, sunucudaki bütün kayıtların ve profilin kalıcı olarak silinir; geri alınamaz. Bu cihazdaki kayıtlar yerinde kalır.',
  'account.wrongPassword': 'Şifre yanlış.',
  'account.keep': 'Vazgeç',
  'account.deleteNow': 'Kalıcı olarak sil',
  'auth.error.badUsername': 'Kullanıcı adı 3–20 karakter olmalı (harf, rakam, _ . -).',
  'auth.error.rudeUsername': 'Bu kullanıcı adı kullanılamaz. Başka bir ad seç.',
  'auth.error.badPassword': 'Şifre en az 6 karakter olmalı.',
  'auth.error.taken': 'Bu kullanıcı adı alınmış.',
  'auth.error.wrongLogin': 'Kullanıcı adı ya da şifre yanlış.',
  'auth.error.slowDown': 'Çok fazla deneme. Bir dakika sonra tekrar dene.',
  'auth.error.offline': 'Sunucuya ulaşılamıyor. İnternet bağlantını kontrol et.',
  'auth.error.mismatch': 'Şifreler aynı değil.',
  'auth.error.server': 'Bir şeyler ters gitti, tekrar dene.',
  'save.coop': 'Co-op',
  'auth.loginName': 'Kullanıcı adı veya e-posta',
  'auth.email': 'E-posta',
  'auth.error.badEmail': 'Geçerli bir e-posta adresi yaz.',
  'auth.error.emailTaken': 'Bu e-posta ile zaten bir hesap var.',
  'ach.firstFlight': 'İlk Kalkış',
  'ach.firstFlight.text': 'İlk uçuşunu uğurla.',
  'ach.flights100': 'Yüz Kalkış',
  'ach.flights100.text': 'Bir havalimanında 100 kalkış.',
  'ach.flights1000': 'Bin Kalkış',
  'ach.flights1000.text': 'Bir havalimanında 1.000 kalkış.',
  'ach.flights5000': 'Gökyüzü Trafiği',
  'ach.flights5000.text': 'Bir havalimanında 5.000 kalkış.',
  'ach.widebody': 'Geniş Gövde',
  'ach.widebody.text': 'Geniş gövdeli bir uçağı uğurla.',
  'ach.threeRunways': 'Üç Pist',
  'ach.threeRunways.text': 'Üç pisti olan bir havalimanı işlet.',
  'ach.value1m': 'İlk Milyon',
  'ach.value1m.text': 'Havalimanı değeri 1 milyon $.',
  'ach.value10m': 'On Milyon',
  'ach.value10m.text': 'Havalimanı değeri 10 milyon $.',
  'ach.value50m': 'Elli Milyon',
  'ach.value50m.text': 'Havalimanı değeri 50 milyon $.',
  'ach.value200m': 'İki Yüz Milyon',
  'ach.value200m.text': 'Havalimanı değeri 200 milyon $.',
  'ach.cash10m': 'Kasa Dolu',
  'ach.cash10m.text': 'Kasada 10 milyon $.',
  'ach.debtFree': 'Borçsuz Büyüme',
  'ach.debtFree.text': 'Kredisiz, 5 milyon $ değerinde bir havalimanı.',
  'ach.rating4': 'Dört Yıldız',
  'ach.rating4.text': 'Puanı 4 yıldıza çıkar.',
  'ach.rating5': 'Beş Yıldız',
  'ach.rating5.text': 'Puanı neredeyse kusursuz yap (%95).',
  'ach.fullService': 'Tam Hizmet',
  'ach.fullService.text': 'Otel, tren istasyonu ve uçuş mutfağı kur.',
  'ach.freight': 'Kargo Hattı',
  'ach.freight.text': 'İlk kargoyu taşı.',
  'ach.hub': 'Aktarma Merkezi',
  'ach.hub.text': 'Bir günde 100 aktarma yolcusu.',
  'ach.international': 'Dış Hatlar',
  'ach.international.text': 'Uluslararası bir havayoluyla anlaş.',
  'ach.charter': 'Etkinlik Seferi',
  'ach.charter.text': 'Bir charter etkinlik serisi imzala.',
  'ach.allMilestones': 'Eksiksiz',
  'ach.allMilestones.text': 'Bütün hedefleri tamamla.',
  'ach.yearOne': 'Bir Yıl',
  'ach.yearOne.text': 'Bir havalimanını bir yıl işlet.',
  'ach.veteran': 'Kıdemli',
  'ach.veteran.text': 'Bir havalimanını dört yıl işlet.',
  'ach.coop': 'Ekip Oyunu',
  'ach.coop.text': 'Bir co-op oyununu kaydet.',
  'ach.privateJet': 'Özel Jet',
  'ach.privateJet.text': 'Bir özel jeti uğurla.',
  'ach.collector': 'Koleksiyoncu',
  'ach.collector.text': 'Havayolu albümünde 20 havayolu topla.',
  'ach.redCarpet': 'Kırmızı Halı',
  'ach.redCarpet.text': 'Beş VIP yolcuyu zamanında ve memnun uğurla.',
  'ach.airshow': 'Gösteri Zamanı',
  'ach.airshow.text': 'Havalimanında bir hava gösterisine ev sahipliği yap.',
  'ach.spotters': 'Meraklı Gözler',
  'ach.spotters.text': 'Uçak meraklıları için bir İzleme Terası aç.',
  'ach.helicopter': 'Rotor Sesi',
  'ach.helicopter.text': 'Bir özel helikopteri helikopter pistinden uğurla.',
  'ach.military': 'Hava Üssü',
  'ach.military.text': 'İlk askeri uçuşu gönder.',
  'ach.grant': 'Devlet Teşviki',
  'ach.grant.text': 'Teşviki al ve tabelasını zamanında dik.',
  'ach.airlines10': 'Havayolu Ağı',
  'ach.airlines10.text': 'Aynı anda 10 farklı havayoluyla uç.',
  'ach.comfort': 'VIP Konfor',
  'ach.comfort.text': 'Bir terminale yolcu salonu ve iki duty free mağazası aç.',
  'ach.towerTop': 'Göğün Gözü',
  'ach.towerTop.text': 'Kontrol kulesini en üst seviyeye çıkar.',
  'ach.terminal5': 'Simge Terminal',
  'ach.terminal5.text': 'Bir terminali Sv.5 yap.',
  'ach.jetBridges': 'Körüklü Köprüler',
  'ach.jetBridges.text': '4 körüklü stand kur.',
  'ach.metro': 'Metro Hattı',
  'ach.metro.text': 'Terminalin altına metro getir.',
  'ach.deicePad': 'Buz Çözme',
  'ach.deicePad.text': 'Bir buz çözme alanı kur.',
  'ach.landlord': 'Arazi Sahibi',
  'ach.landlord.text': '20 parsel araziye sahip ol.',
  'ach.unlocked': 'Başarım açıldı',
  'ach.points': '+{n} puan',
  'ach.newTitle': 'Yeni ünvan: {title}',
  'achgroup.traffic': 'Trafik',
  'achgroup.business': 'İşletme',
  'achgroup.service': 'Hizmet',
  'achgroup.growth': 'Büyüme',
  'achgroup.build': 'Altyapı',
  'achgroup.social': 'Sosyal',
  'rank.rookie': 'Çaylak',
  'rank.apron': 'Apron Görevlisi',
  'rank.tower': 'Kule Kontrolörü',
  'rank.operations': 'Operasyon Müdürü',
  'rank.director': 'Havalimanı Direktörü',
  'rank.mogul': 'Havacılık Patronu',
  'rank.legend': 'Gökyüzü Efsanesi',
  'title.controller': 'Trafik Ustası',
  'title.tycoon': 'Havalimanı Baronu',
  'title.favourite': 'Yolcuların Gözdesi',
  'title.cargo': 'Kargo Kralı',
  'title.hub': 'Hub Mimarı',
  'title.perfectionist': 'Mükemmeliyetçi',
  'title.veteran': 'Kıdemli Kaptan',
  'title.teamPlayer': 'Takım Oyuncusu',
  'title.commander': 'Üs Komutanı',
  'title.architect': 'Baş Mimar',
  'menu.leaderboard': 'Dünya sıralaması',
  'menu.leaderboardSub': 'En değerli havalimanları',
  'menu.leaderboardTitle': 'Dünya sıralaması',
  'menu.profile': 'Profil ve başarımlar',
  'menu.profileSub': 'Ünvanın, rekorların',
  'menu.profileTitle': 'Profil',
  'lb.world': 'Genel',
  'lb.value': 'Değer',
  'lb.rating': 'Puan',
  'lb.leadWorld':
    'Dünya puanı = başarım puanın + en değerli havalimanın (her 10 katı +500: 1 milyon $ 500, 1 milyar $ 2000) + en iyi puanın (5★ 1000). Başarımlar ve yıldızlar dolunca sırayı havalimanının değeri belirler.',
  'lb.lead':
    'Tüm oyuncuların en değerli havalimanları. Kayıt aldığında sunucu havalimanını okur ve rekorunu günceller.',
  'lb.leadRating':
    'En az 200 kalkış yapmış havalimanlarının en iyi puanı; eşit puanda daha çok kalkış yapan öndedir.',
  'lb.empty': 'Henüz sıralamada kimse yok. İlk sen ol!',
  'lb.you': 'Sen: {rank}. sıra / {n} oyuncu',
  'lb.notYet': 'Henüz sıralamada değilsin: bir oyun kaydet.',
  'lb.loading': 'Yükleniyor…',
  'lb.error': 'Sıralama alınamadı.',
  'profile.points': '{points} / {max} puan',
  'profile.nextRank': 'Sonraki rütbe: {rank} ({points} puan)',
  'profile.maxRank': 'En yüksek rütbedesin!',
  'profile.title': 'Gösterilen ünvan',
  'profile.titleHint': 'Sıralamada, profilde ve co-op sohbetinde görünür.',
  'profile.best': 'En değerli havalimanı',
  'profile.bestNone': 'Henüz kayıtlı bir havalimanın yok.',
  'profile.bestLine': '{name} · {day}. gün · {value}',
  'profile.records': 'Rekorlar',
  'profile.bestRating': 'En iyi puan',
  'profile.mostDepartures': 'En çok kalkış',
  'profile.pointsLabel': 'Başarım puanı',
  'profile.worldScore': 'Dünya puanı',
  'profile.worldRank': '{rank}. sıra / {n}',
  'profile.worldParts': 'Dünya puanı = başarım {points} + değer {value} + puan {rating}',
  'profile.achievements': 'Başarımlar ({n}/{total})',
  'profile.joined': 'Katıldı: {date}',
  'profile.email': 'E-posta: {email}',
  'profile.back': 'Sıralamaya dön',
  'profile.unlocked': 'Açıldı: {date}',
  'profile.locked': 'Kilitli',
  'profile.showcase': 'Vitrin',
  'profile.error': 'Profil alınamadı.',
  'menu.online': '{online} oyuncu co-op oynuyor · {rooms} açık oda · {accounts} kayıtlı pilot',
  'coop.openRooms': 'Açık odalar',
  'coop.openRoomsSub': 'Herkese açık co-op oyunları: tıkla ve katıl.',
  'coop.noRooms': 'Şu an açık oda yok. Sen bir tane aç!',
  'coop.roomLine': '{host} · {players}/{max} oyuncu',
  'coop.public': 'Odayı herkese açık listele',
  'coop.publicHint':
    'Açık odalar co-op sayfasında herkese görünür; kod paylaşmadan katılabilirler.',
  'coop.refresh': 'Yenile',
  'coop.playingAs': 'Oyuncu adın: {name}',
  'chat.title': 'Sohbet',
  'chat.empty': 'Henüz mesaj yok. Ekibine merhaba de!',
  'chat.send': 'Gönder',
  'chat.actions': 'Sustur veya bildir',
  'chat.mute': 'Sustur',
  'chat.unmute': 'Sesini aç',
  'chat.report': 'Bildir',
  'chat.mutedCount': '{n} susturuldu',
  'chat.mutedList': 'Susturduğun oyuncular (bu cihazda)',
  'chat.reportSubject': 'Sohbet bildirimi: {name}',
  'chat.reportBody': 'Oyuncu: {name}\nOda: {room}\nMesaj: {text}\n\nNe oldu? (isteğe bağlı)\n',
  'news.community': 'Dünya sıralaması, başarımlar ve ünvanlar',
  'news.community.text':
    'En değerli havalimanı sıralaması, 23 başarım, 7 rütbe ve özel ünvanlar. Profilinden göstereceğin ünvanı seç.',
  'news.accounts': 'Hesaplar ve açık odalar',
  'news.accounts.text':
    'Kayıtların sunucuda; co-op odalarını herkese açık listele, sohbette ünvanlar görünsün.',
  'news.liveMenu': 'Canlı menü ve yeni görüntü',
  'news.liveMenu.text':
    'Menü arkasında gerçek oyun, açılış ekranı, minyatür odak efekti ve kuş sürüleri.',
  'news.desktop': 'Windows sürümü',
  'news.desktop.text':
    'Oyun artık kendi penceresinde, kurulumla geliyor: ekran kartını doğrudan kullanır, tarayıcıdan çok daha akıcıdır. Her açılışta güncellemeleri denetler, yenisini kendisi kurar. Menü de artık anında açılıyor.',
  'news.realPlanes': 'Gerçek uçak modelleri',
  'news.realPlanes.text':
    'Uçaklar artık gerçek 3D modeller: özel jet, bölgesel jet, dar ve geniş gövde. Her havayolunun kendi rengi ve boya deseni (6 şema), gövdesinde adı, kuyruğunda kodu var; her uçağın ayrı tescili (TC-…) arka gövdede yazar. Gece kabin pencereleri yanar.',
  'news.realVehicles': 'Gerçek araçlar',
  'news.realVehicles.text':
    'Yollarda 10 çeşit gerçek araba, şehir otobüsleri, taksiler, polis, çöp kamyonu ve çekiciler; itfaiye ve ambulans da yeni. Apronda gerçek apron otobüsü ve konteyner arabalı bagaj treni. Farlar ve stop lambaları gece yanar.',
  'news.towns': 'Ufukta kasabalar',
  'news.towns.text':
    'Haritanın kuzeyinde ve güneyinde, ormanın ötesinde sokakları, evleri, apartmanları ve mağazalarıyla kasabalar var; gece pencereleri yanar. (Düşük grafik ayarında gizlenir.)',
  'news.privateJets': 'Önce özel jetler',
  'news.privateJets.text':
    'Yeni havalimanında ilk kulede özel jet işletmecileri gelir: az yolcu, hızlı turnaround. Kuleyi 2. seviyeye yükseltince yolcu havayolları teklif vermeye başlar.',
  'news.brush': '4×4 yol fırçası',
  'news.brush.text':
    'Yol ve taksi yolu artık 4×4 bloklarla çizilir: bloklar ızgaraya oturur, yakındaki yola, otoyola, piste ya da standa kendiliğinden bağlanır.',
  'news.move': 'Yapıları taşı',
  'news.move.text':
    'Bir yapıyı seçip "Taşı" ile başka yere koyabilirsin; döndürmek de serbest. Bedeli yapıya harcananın onda biri. Uçak bağlıyken ya da inşaat sürerken taşınamaz.',
  'news.nightFlights': 'Akşam uçuşları',
  'news.nightFlights.text':
    'Işıksız pist artık 06:00–22:00 arası uçuş alır. Gece (22:00–06:00) için pistin ışıklı olması gerekir (Sv.3); teklifler sekmesi bunu hatırlatır.',
  'news.junctions': 'Kavşaklarda düzen',
  'news.junctions.text':
    'Araçlar kavşağa ancak karşıya geçecek yer varsa girer, birbirinin önünü kesen dönüşler sırasını bekler: yoğunlukta kavşak kilitlenmez, araçlar kafa kafaya kalmaz. Virajlar yuvarlak, kamyonlar düzgün döner.',
  'news.lights': 'Gerçekçi sokak ışıkları',
  'news.lights.text':
    'Lambaların ışığı artık yere yumuşakça yayılır, zemini aydınlatır; yerde yuvarlak lekeler yok.',
  'news.tunnels': 'Otoyol tünelleri',
  'news.tunnels.text':
    'Otoyol harita kenarlarında tepelerin altındaki tünellere girer; yollardaki ağaçlar temizlendi, karşılama tabelası yolu kapatmayacak yere konur.',
  'news.tutorial': 'Başlangıç rehberi',
  'news.tutorial.text':
    'Yeni oyunda kısa bir rehber ne yapacağını adım adım anlatır. Yardım ekranından yeniden açabilirsin.',
  'news.grass': 'Daha gerçekçi çim',
  'news.grass.text':
    'Çim baştan yapıldı: uzaktan renk geçişleri ve öbekler, yakından tutamlar, rüzgâra yatmış yapraklar ve küçük kır çiçekleri. Havalimanı arazisinde biçilmiş çim şeritleri bakış yönüne göre açık ya da koyu görünür.',
  'news.traffic': 'Akıllı araçlar, çakışma yok',
  'news.traffic.text':
    'Arabalar ve apron araçları artık kendi yollarını virajlarıyla birlikte önceden görür: kuyrukta arayı korur, kavşakta bekler, uçağa yol verir, burun buruna kalınca biri geri manevra yapar. Uçağın etrafına sırayla, birbirine değmeden yanaşırlar; yol kapanırsa yeni rota çizerler.',
  'news.fleet': 'Yeni yer hizmet araçları',
  'news.fleet.text':
    'Bütün apron araçları yenilendi: ikram kasası kapıya yükselir, yakıt hortumu kanada uzanır, bant yükleyici çalışır, gece farlar yolu aydınlatır. İnen uçakları artık FOLLOW ME aracı stanta götürür.',
  'class.5': 'Hafif savaş uçağı',
  'class.6': 'Askeri nakliye uçağı',
  'class.7': 'Taktik İHA',
  'class.8': 'Helikopter',
  'hold.19': 'Pist kapalı: savaş uçakları acil kalkışta',
  'hold.20': 'Pas geçti, yeni sıra bulunamadı: başka havalimanına yönlendirildi',
  'hold.21': 'Boş ve yola bağlı helikopter pisti yok',
  'hold.22': 'Yer hizmeti araçları bekleniyor (merdiven, otobüs, bagaj, yakıt): hepsi meşgul',
  'hold.23': 'Pistler kapalı: Hava Kuvvetleri uçakları alçak geçiş yapıyor',
  'delayTip.23':
    'Hava Kuvvetleri geçişi kısa sürer: pistler birkaç dakikada açılır, beklemek yeter.',
  'flypast.kicker': 'Hava Kuvvetleri · Acil NOTAM',
  'flypast.title': 'Savaş uçakları havalimanının üzerinden geçecek',
  'flypast.body':
    'Test uçuşundan dönen {n} savaş uçağı birazdan pistlerin üzerinden alçak ve ses hızının üstünde geçecek. Güvenlik için bütün kalkış ve inişler {minutes} dakika durduruldu; bekleyen uçaklar sıraya alındı.',
  'flypast.closed': 'Kapanan pistler',
  'flypast.closedFor': '{minutes} dakika',
  'flypast.compensation': 'Savunma Bakanlığı tazminatı',
  'flypast.watch': 'Tamam’a bas ve piste göz at: sonik patlamalara ve flare gösterisine hazır ol.',
  'flypast.paused': 'Oyun durdu. Geçiş boyunca normal hızda sürer, sonra kaldığı hıza döner.',
  'flypast.together': 'Ortak oyunda zaman durmaz; geçişi herkes kendi ekranında izler.',
  'flypast.ok': 'Tamam',
  'toast.flypastOver': 'Hava Kuvvetleri geçişi bitti: pistler yeniden açıldı.',
  'toast.balloons': 'Sakin bir sabah: sıcak hava balonları havalanıyor 🎈',
  'news.roadsLight': 'Gerçekçi asfalt, kavşak çizgileri ve gün ışığı',
  'news.roadsLight.text':
    'Yollar ve otoyol artık lacivert değil, dokulu koyu gri asfalt (agrega tanesi, eski ve yeni kısımlar, onarım yamaları). Kavşaklarda yaya geçitleri ve dur çizgileri var, orta çizgi dur çizgisinde bitiyor; kavşak köşeleri bordürü ve kaldırımıyla kavisli dönüyor. Gündüz ışığı daha doğal: gökyüzünün mavisi her yüzeye sinmiyor, beyaz binalar beyaz, çimen yeşil.',
  'news.motorwayOut': 'Otoyol artık uzaklara gidiyor',
  'news.motorwayOut.text':
    'Otoyol ve viyadük harita kenarında tünele girmiyor: bariyerleri, aydınlatması ve trafiğiyle kırların içinden uzanıyor ve çok ileride, kameranın gitmediği yerde bir tepenin altındaki tünele giriyor. Gece ışıkları ufka kadar yanıyor.',
  'news.trees': 'Yeni ağaçlar: yapraklılar, çamlar ve palmiyeler',
  'news.trees.text':
    'Ağaçlar baştan çizildi. Yapraklı ağaçların tacı yaprak kümeleriyle kabarık, gövdelerinde kökler ve dallar var; çamlar kat kat, kenarlarından dal uçları sarkıyor; çöl palmiyelerinin tüy gibi yaprakları hurma salkımlarının üstünde kavis yapıp sarkıyor. Mevsimler de ağaçlarda görünüyor: baharda çalılar pembe, beyaz ve sarı çiçek açar, yaz sonunda böğürtlen ve elma olgunlaşır, sonbaharda yapraklar sararıp tek tek dökülür, kışın çıplak dallar kalır.',
  'news.maps': 'Yeni haritalar: Çöl ve Karlı Dağlar',
  'news.maps.text':
    "Yeni oyun açarken arazini seç: Yeşil Vadi, Çöl ya da Karlı Dağlar. Çölde kum tepeleri, katman katman kızıl mesa kayalıkları, palmiye vahaları, kubbeli ve minareli kasabalar, ufukta gökdelenli bir şehir; kavurucu yazlar, serin geceler, sıcak öğleden sonralarda dönen kum hortumları ve görüşü düşüren kum fırtınaları (pas geçmeler artar, apron işleri yavaşlar). Dağlarda karlı zirveler, ladin ormanları ve dağ evleri; sert kışlar, bol kar, vadi sisi ve kar fırtınaları. Haritalar co-op'ta da seçilebilir, kayıtlar haritasını hatırlar.",
  'news.airportCity': 'Havalimanı şehri',
  'news.airportCity.text':
    'Kara tarafına kendi şehrini kur: kafeler, restoranlar, AVM, akaryakıt istasyonu, iş merkezleri ve parklar. Yolcular, şehirden gelenler ve ofis çalışanları alışveriş yapar; her satıştan havalimanı pay alır, ofisler kira öder. Yerleşim önemli: yan yana dükkânlar birbirini besler, parklar çevresini güzelleştirir, AVM etrafına müşteri taşır; terminale yakın yeme-içme yerleri yolcuların konforunu artırır. Katalogda yeni Havalimanı şehri bölümü.',
  'news.playtestNotes': 'Rötar danışmanı, rapor defteri ve yeni binalar',
  'news.playtestNotes.text':
    "Rötarın sebebi artık yazıyor: Uçuşlar listesindeki danışman hangi sebebin kaç dakika kaybettirdiğini, ne yapman gerektiğini ve nereden yapacağını söyler; personel kartı tarifene göre kaç üs seviyesi ve personel gerektiğini tahmin eder. Yer hizmetleri üssü Sv.6'ya çıkar, kule Sv.4'te 3 üs kurulur. Sözleşmeye tıklayınca havayolunun memnuniyeti ve sebepleri açılır. Yeni: Havalimanı Müdürlüğü ve canlı rapor defteri, geniş gövde ve dev uçaklar için büyük buz çözme pedi. Geniş gövde artık büyük stand ister. Köprülü kavşak yerine bağlantı yolu; otoyoldan her yeni giriş kapasiteyi artırır. Karayolu taksi yolunun altından tünelle geçer. Gürültü kotası iki katı, arazi daha ucuz, An-124'ün iniş takımları var, jet geçişleri daha seyrek ve sessiz.",
  'news.languages': 'Almanca, Fransızca ve Rusça',
  'news.languages.text':
    'Oyun artık beş dilde: Türkçe ve İngilizcenin yanında Almanca, Fransızca ve Rusça. Menüler, dersler, Akademi, haberler, sosyal akış ve yasal metinler dahil her şey çevrildi. Dil, ana menünün köşesinden ya da ayarlardan değişir. Klavye kısayolları da artık klavyenin üstünde yazdığı gibi gösteriliyor (AZERTY’de WASD yerine ZQSD).',
  'news.menuFilms': 'Ana menü baştan çekildi',
  'news.menuFilms.text':
    'Ana menünün arka planında 11 yeni film, Full HD ve çoğu gece: alçaktan geçen F-22’ler, gün batımında F-35 kolu, An-124’ün ve A350’nin gece inişi, A380’in gece kalkışı, ışıklı apron, otoyolun üstünden süzülen A220 ve dahası. Hepsi oyunun kendi motorunda çekildi.',
  'news.stealthJets': 'F-35 ve F-22',
  'news.stealthJets.text':
    'Gökyüzünden geçen savaş uçağı kollarının yarısı artık F-35 ya da F-22: arkalarında kalın, uzun süren bir duman izi bırakıyor ve her geçişte sonic boom patlıyor. Askerî havalimanına inen filolarda da F-16’ların yanında F-35 ve F-22 var; iniş takımları yerde ve inişte açık.',
  'news.jetSound': 'Savaş uçaklarına gerçek ses ve sonic boom',
  'news.jetSound.text':
    'Savaş uçaklarının her geçişi artık gerçek bir jet geçişi kaydıyla duyuluyor: en yüksek an uçağın sana en yakın olduğu ana denk geliyor, ses uçakla birlikte sağdan sola kayıyor, uzaktan geçen daha kısık. İnen savaş uçağının sesi piste yaklaştıkça büyüyor ve tekerlekler yere değerken sönüyor. Geçişlerin çoğunda gerçek bir sonic boom patlıyor, ama hiçbir zaman arka arkaya değil. Yolcu uçaklarının sesleri olduğu gibi.',
  'news.legal': 'Gizlilik, koşullar ve güvenli sohbet',
  'news.legal.text':
    'Ana menüde ve ayarlarda “Hakkında ve yasal”: gizlilik politikası (hangi veriyi neden tuttuğumuz, nasıl sildirebileceğin), kullanım koşulları ve açık kaynak lisansları. Hesap açarken koşulları onaylıyorsun. Co-op sohbetinde küfürler maskeleniyor; bir oyuncunun adına dokunup onu susturabilir ya da mesajını bize bildirebilirsin.',
  'news.playtest': 'Oyun testinden düzeltmeler',
  'news.playtest.text':
    'Gelebilecek her havayolu sözleşme yapınca teklifler artık kesilmiyor: burada uçan havayolları ek sefer ve yeni hat teklif ediyor (havayolu başına en çok 3 sözleşme). Hedef ödülleri yarıya indi; para artık uçuşlardan geliyor. Tek pistin yükseltme uyarısı kapalı kalacağı saatlerde kaç uçuş olduğunu söylüyor. Yolu olmayan yöne bakan terminal tek dokunuşla başka kenarından yola bağlanıyor; yeni terminal kaldırımı otoyola bakar şekilde geliyor. Ders kayıtla birlikte saklanıyor, telsiz kullanılan pisti ve ILS’siz pistte görerek yaklaşmayı doğru söylüyor.',
  'news.phoneHud': 'Telefona özel arayüz',
  'news.phoneHud.text':
    'Telefonda oyunun kendi arayüzü var. Üstte para, gün, saat ve hava; ona dokununca havalimanı sayfası açılır: puan, kule, hava tahmini, rüzgâr, gürültü haritası ve seyir kamerası. Altında sıradaki hedef var; dokununca tüm hedefler ve günün görevleri açılır. Sol altta adıyla beş araç: Seç, Arazi, İnşa, Yollar ve Düzenle. Yollar ile Düzenle kendi araçlarını küçük bir tepside açar. İnşa kataloğu, ayarlar ve hedefler sağdan açılan sayfalarda; haritaya dokununca kapanır. iPhone’da Safari’den "Ana Ekrana Ekle" ile oyun tam ekran açılır.',
  'news.mobile': 'Telefonda ve tablette parmakla oyna',
  'news.mobile.text':
    'Oyun artık telefonda ve tablette yatay ekranda rahat oynanıyor. Katalogdan seçtiğin bina haritada boş bir yere düşer: parmağınla tutup taşı, ↻ ile döndür, ✓ ile yerleştir; ⓘ ne işe yaradığını söyler. Yolları ve taksi yollarını tek parmakla çiz, uçlarındaki tutamaçları sürükleyip düzelt; kenara yaklaşınca harita kendisi kayar. Yolu olmayan binanın panelindeki "Yolu bağla" onu en yakın yola bağlar. Kamera: bir parmak kaydırır, iki parmak yakınlaştırıp döndürür, iki parmağı birlikte yukarı-aşağı kaydırmak eğer, çift dokunuş yaklaştırır. Pencereler telefonda tam ekran, bina paneli yanda tam boy. Tarayıcıda oyun tam ekrana geçer; ana ekrana eklersen uygulama gibi açılır.',
  'news.guestPlay': 'Kayıt olmadan oyna, hesapla her cihazda devam et',
  'news.guestPlay.text':
    'Oyun artık hesap açmadan oynanıyor: oyunların bu cihazda saklanır. Ücretsiz bir hesap açarsan oyunların sunucuda saklanır ve telefondan, tabletten ya da bilgisayardan aynı havalimanına kaldığın yerden devam edersin; bu cihazda oynadıkların da hesabına taşınır. Co-op, dünya sıralaması ve profil hesapla açılır. Ana menü telefon ekranlarına göre yeniden düzenlendi; Hesap sayfasından çıkış yapabilir ya da hesabını kalıcı olarak silebilirsin.',
  'news.oneRunway': 'Tek pist, beş seviye',
  'news.oneRunway.text':
    'Küçük, normal ve büyük pist yerine artık tek bir pist var ve seviye atladıkça büyüyor: Sv.1 dar pist (küçük uçaklar, özel ve bölgesel jetler), Sv.2 daha geniş (dar gövdeler), Sv.3 pist ışıkları ve CAT I ILS, Sv.4 yaklaşma ışıkları, CAT III ILS ve geniş gövdeler, Sv.5 en geniş pist (jumbo ve dev kargo dahil hepsi). Her uçak için ayrı pist kurman gerekmiyor; ikinci pist yalnız kapasite içindir. Eski kayıtlardaki pistler olduğu gibi çalışmaya devam ediyor. Ayrıca jetlerin sonik patlamasında kamera artık sarsılmıyor, Hava Kuvvetleri gösterisinde de kamera senin bıraktığın yerde kalıyor.',
  'news.realHelicopters': 'Gerçek helikopterler',
  'news.realHelicopters.text':
    'Helipadlara gelen özel helikopterler artık gerçek modeller: kızaklı, kuyruk rotoru dikmenin içinde dönen iki orta boy tip ve yumurta gövdeli küçük, çevik bir helikopter. Her işletmeci birini uçuruyor, kendi renginde; ana rotor ve kuyruk rotoru dönüyor, hızlanınca rotor hafif bir diske dönüşüyor, kuyruğun tepesinde kırmızı çakar lamba yanıp sönüyor.',
  'news.roadTunnels': 'Karayolunun altından servis tüneli, gerçek yarmalar',
  'news.roadTunnels.text':
    'Servis yolunu bir karayolunun üstünden geçecek şekilde çizdiğinde artık altından tünelle geçiyor: arabalar üstten akmaya devam ediyor, yer hizmeti araçları alttan geçiyor, kimse kimseyi beklemiyor (karayolunda biten servis yolu eskisi gibi yola bağlanır). Tüneller de yenilendi: rampa artık zemine açılmış gerçek bir yarmada daha derine iniyor; istinat duvarları, sarı başlıklı korkuluk, rampa dibinde ızgara, uyarı şeritli portal ve içi lambalarla aydınlatılmış karanlık bir tüp var.',
  'news.motorwayKit': 'Bölünmüş yol gibi otoyol',
  'news.motorwayKit.text':
    'Havalimanının önünden geçen otoyolun ortasında artık beton bariyer, kenarlarında direkli çelik otokorkuluk ve çakıl banket var. Bariyerler kavşaklarda açılıyor, korkuluk uçları yere iniyor; refüjdeki çift kollu direkler geceleri iki yönü de aydınlatıyor. Otoyola bağlanan yolda dur çizgisi ve yaya geçidi var; kavşağa yaklaşan her şeritte, kavşağın gerçekten nereye çıktığına göre düz, sola ya da sağa yön oku boyalı.',
  'news.moreTypes': 'Çift katlı dev ve üç yeni tip daha',
  'news.moreTypes.text':
    'Jumbo sınıfına iki katlı, dört motorlu dev bir yolcu uçağı geldi (iki sıra penceresi ve dörtlü boji tekerlekleriyle). Dar gövdeye iri motorlu yeni nesil bir jet, geniş gövdeye kıvrık kanat uçlu yeni nesil bir çift motorlu, bölgesele T-kuyruklu, altı pervane kanatlı uzun bir turboprop eklendi; bu sınıflarda artık üç tip var. Kargo havayollarının uçaklarında yolcu penceresi yok, dev çift katlıyı da uçurmuyorlar.',
  'news.aircraftTypes': 'Yeni uçak tipleri',
  'news.aircraftTypes.text':
    'Her sınıfa ikinci bir uçak tipi geldi: dar gövdede winglet’li yeni nesil bir jet, geniş gövdede uzun gövdeli büyük motorlu bir çift motorlu, bölgeselde yüksek kanatlı pervaneli bir uçak, özel jette T-kuyruklu bir iş jeti. Her havayolu bir tipi uçurur, gökyüzü ve apron artık daha çeşitli.',
  'news.balloons': 'Sıcak hava balonları',
  'news.balloons.text':
    'Kış dışında açık ve rüzgârsız bazı sabahlar, havalimanının rüzgâr üstündeki bir tarlada sıcak hava balonları şişirilir; havalanıp havalimanının yanından süzülerek geçer, bir buçuk saat sonra ötede iner. Brülörler ara ara gürler, şafakta balonlar içeriden parlar. Bildirime tıklayınca kamera balonlara gider.',
  'news.flypast': 'Hava Kuvvetleri geçişi',
  'news.flypast.text':
    'Ara sıra test uçuşundan dönen beş savaş uçağı havalimanının üzerinden geçer: oyun durur, NOTAM gelir, pistler bir süre kapanır (bakanlık tazminat öder). Tamam’a basınca kamera piste döner; jetler art yakıcıyla alçaktan geçer, tek tek sonik patlamalar duyulur, flare atar ve dikine tırmanırken "melek" figürü çizerler.',
  'toast.goAround': '{airline} pas geçti: tur atıp yeniden yaklaşıyor',
  'toast.diverted': '{airline} pas geçti ve sıra bulamadı: başka havalimanına yönlendirildi',
  'ledger.military': 'Askeri anlaşmalar',
  'rwy.usage': 'Pist kullanımı',
  'rwy.usage.0': 'Ortak',
  'rwy.usage.1': 'Yalnız sivil',
  'rwy.usage.2': 'Yalnız askeri',
  'rwy.usageHint':
    'Ortak pistte acil kalkış sırasında sivil trafik bekler. Yalnız sivil pistler acil kalkışta kapanmaz.',
  'toast.scramble':
    'Acil kalkış! Savaş uçakları havalanıyor, pistler kapalı. Bakanlık ödemesi: {bonus}',
  'building.militaryGate': 'Askeri Bölge Kapısı',
  'desc.militaryGate':
    'Askeri bölgeyi açar: bakanlık İHA ve nakliye uçağı anlaşmaları teklif etmeye başlar. Askeri uçaklar terminal kullanmaz, yolcu taşımaz; her sefer için bakanlık sabit ücret öder. Kule Sv.3 gerekir.',
  'building.shelter': 'Korunaklı Sığınak',
  'desc.shelter':
    'Bir savaş uçağı için beton sığınak (stand gibi çalışır). Savaş uçağı filosu için sığınak, harekât binası ve mühimmat deposu gerekir. Kule Sv.4 gerekir.',
  'building.militaryApron': 'Askeri Apron',
  'desc.militaryApron':
    'Nakliye uçağı ya da İHA için park yeri (stand gibi çalışır); taksi yoluna ve karayoluna bağla. Kule Sv.4 gerekir.',
  'building.opsCenter': 'Harekât Binası',
  'desc.opsCenter':
    'Savaş uçağı filosunun merkezi. Filo burada konuşlanınca ara sıra acil kalkış olur: pistler birkaç dakika kapanır, bakanlık ek ödeme yapar.',
  'building.munitions': 'Mühimmat Deposu',
  'desc.munitions': 'Toprak örtülü, çitle çevrili depo. Savaş uçağı filosu için gerekir.',
  'building.airDefence': 'Hava Savunma Mevzii',
  'desc.airDefence':
    'Dönen arama radarı ve füze rampaları. Bakanlık her askeri sefer ve acil kalkış için %15 (Sv.2’de %30) fazla öder. Sv.2’ye uzun menzilli rampa ve atış kontrol radarı eklenir. Kule Sv.4 gerekir.',
  'news.cinema': 'Sinematik ana menü',
  'news.cinema.text':
    'Ana menünün arkasında artık oyunun kendi motoruyla ultra ayarlarda çekilmiş filmler dönüyor: otoyolun üstünden alçak geçen yolcu uçağı, iki jetin eskort ettiği geniş gövde, İHA devriyesi, art yakıcılı jet geçişi ve gece inişi.',
  'news.settings': 'Ayrıntılı ayarlar',
  'news.settings.text':
    'Beş grafik profili (zayıf bilgisayarlar için Patates dahil), gölge, ağaç, efekt ve çözünürlük ayarları tek tek; FPS göstergesi, FPS sınırı, kamera ve otomatik kayıt ayarları.',
  'news.academy': 'Akademi: kılavuz ve dersler',
  'news.academy.text':
    'F1 ya da üst çubuktaki Akademi: oyunun tüm konuları wiki gibi, aramalı; her binanın seviye ve sınır tablosu; adım adım dersler (Temeller, Uçuşlar, Yolcular, Yönetim, Hava, Askeri) ekranın ilgili yerini parlatır ve yaptığında kendiliğinden ilerler. Binalar (her seviyesiyle) ve uçaklar canlı 3D, dönen modellerle. Arayüz yeni kokpit görünümünde. Katalogda yeni "Askeri" sekmesi.',
  'news.hints': 'Bağlantı ipuçları',
  'news.hints.text':
    'İnşa ederken bina kenarlarında nereye yol ve taksi yolu bağlanacağı görünür: yeşil bağlı, turuncu bir yere çıkmıyor, sarı buraya çiz. Uçağın gireceği kenar okla gösterilir; yol ya da taksi yolu çizerken tüm açık bağlantı noktaları yanar.',
  'news.atc': 'Gerçekçi kule',
  'news.atc.text':
    'İz türbülansı ayırması (ağır uçağın arkasında daha uzun aralık), planlı saate göre kalkış sırası, kötü havada pas geçen uçaklar, köprülü standa öncelik ve rötar zinciri: geç kalkan uçak bir sonraki seferine de geç döner. Terminalde yolcular check-in, güvenlik ve pasaport aşamalarından geçer; panel darboğazı gösterir.',
  'news.military': 'Askeri bölge',
  'news.military.text':
    'Kule Sv.3’te askeri bölge kapısı, Sv.4’te sığınak, askeri apron, harekât binası ve mühimmat deposu açılır. Bakanlık İHA, savaş uçağı ve nakliye uçağı anlaşmaları teklif eder; her pist ortak, yalnız sivil ya da yalnız askeri olarak ayarlanabilir. Savaş uçakları ara sıra acil kalkışa geçer. Hava Savunma Mevzii (dönen radar, füze rampaları) Bakanlık ödemelerini artırır.',
  'graphics.potato': 'Patates',
  'graphics.potato.desc':
    'Yarım çözünürlük, efekt yok, ağaçlar kapalı, 30 FPS. En zayıf bilgisayarlar için.',
  'graphics.low.desc':
    'Düşük çözünürlük, efekt yok, yakın ağaçlar, 60 FPS. Eski bilgisayarlar için.',
  'graphics.medium.desc':
    'Tam çözünürlük, 2× kenar yumuşatma, ışık parlaması, kasabalar. Çoğu bilgisayar için.',
  'graphics.high.desc':
    'Tam çözünürlük, 4× kenar yumuşatma, uzak ağaçlar. Güçlü bilgisayarlar için.',
  'graphics.ultra': 'Ultra',
  'graphics.ultra.desc': 'Yüksek ayarların üstüne en uzak ağaç ayrıntısı.',
  'settings.all': 'Tüm ayarlar',
  'settings.game': 'Oyun',
  'settings.soundLang': 'Ses ve dil',
  'settings.custom': 'Özel ayarlar: bir profil seçersen hepsi o profile döner.',
  'settings.image': 'Görüntü',
  'settings.renderScale': 'Çözünürlük ölçeği',
  'settings.renderScale.hint': 'Ekranın ne kadarı çizilir. Düşürmek en büyük hız kazancıdır.',
  'settings.autoResolution': 'Otomatik akıcılık',
  'settings.autoResolution.hint':
    'Kareler yetişemezse çözünürlüğü bir süre biraz düşürür (ayarın %60ına kadar), rahatlayınca geri yükseltir: zayıf cihazlarda da akıcı.',
  'settings.hiDpi': 'Yüksek DPI',
  'settings.hiDpi.hint': 'Retina / 4K ekranlarda tam yoğunluk. Kapalıyken çok daha hızlı.',
  'settings.msaa': 'Kenar yumuşatma',
  'settings.upscale': 'Akıllı ölçekleme',
  'settings.upscale.hint':
    'DLSS / FSR 2 gibi: sahne daha düşük çözünürlükte çizilir, önceki karelerle keskin tam görüntüye yeniden kurulur. Her ekran kartında çalışır, en büyük FPS kazancı; kenar yumuşatmayı kendisi yapar.',
  'settings.upscale.native': 'Doğal (DLAA)',
  'settings.upscale.quality': 'Kalite',
  'settings.upscale.balanced': 'Dengeli',
  'settings.upscale.performance': 'Performans',
  'settings.fpsCap': 'FPS sınırı',
  'settings.fpsCap.hint': 'Dizüstünde pil ve ısı için 30 ya da 60.',
  'settings.unlimited': 'Sınırsız',
  'settings.off': 'Kapalı',
  'settings.lighting': 'Işık ve efektler',
  'settings.shadows': 'Gölgeler',
  'settings.shadows.hint': 'En pahalı ayarlardan biri.',
  'settings.ao': 'Ortam gölgelemesi',
  'settings.ao.hint': 'Köşelerde ve binaların dibinde yumuşak gölge (ağır).',
  'settings.bloom': 'Işık parlaması',
  'settings.bloom.hint': 'Gece ışıklarının parlaması.',
  'settings.tiltShift': 'Minyatür odak',
  'settings.tiltShift.hint': 'Yakından bakınca üst ve alt kenar bulanık.',
  'settings.world': 'Dünya',
  'settings.vegetation': 'Ağaçlar',
  'settings.vegetation.hint': 'Ormanların ayrıntı mesafesi; kapalıyken ağaç yok.',
  'settings.towns': 'Kasabalar',
  'settings.towns.hint': 'Havalimanı çevresindeki kasabalar (çok üçgen).',
  'settings.weatherFx': 'Hava efektleri',
  'settings.weatherFx.hint': 'Yağmur, kar, şimşek ve kum fırtınası ekranda.',
  'settings.birds': 'Kuş sürüleri',
  'quality.off': 'Kapalı',
  'quality.low': 'Düşük',
  'quality.medium': 'Orta',
  'quality.high': 'Yüksek',
  'quality.ultra': 'Ultra',
  'settings.interface': 'Arayüz',
  'settings.fpsMeter': 'FPS göstergesi',
  'settings.fpsMeter.hint': 'Ekranın köşesinde kare hızı (ayrıntılı: çizim sayısı ve üçgen).',
  'settings.detailed': 'Ayrıntılı',
  'settings.reports': 'Çökme ve takılma raporları',
  'settings.reports.hint':
    'Oyun çökerse, donarsa ya da takılırsa ne olduğunu (sürüm, ekran kartı, oyunun o anı ve kaydı) geliştiricilere gönderir; sorunu bulup düzeltmemize yarar.',
  'advice.title': 'Havalimanı bu sözleşmeye hazır değil',
  'advice.sub': 'İmzalarsan uçuşlar inemez ya da bekler; önce şunları yap:',
  'advice.note':
    'Yine de imzalayabilirsin; eksikleri sözleşme süresince tamamlarsan uçuşlar başlar.',
  'advice.ok': 'Tamam',
  'advice.missing': 'Eksikler',
  'advice.noHelipad': 'Helikopter pisti yok',
  'advice.buildHelipad': 'Yola bağlı bir helikopter pisti kur',
  'advice.noLargeRunway': 'Bu dev uçak için büyük pist yok',
  'advice.buildLargeRunway': "Pisti Sv.5'e yükselt (Kule Sv.3)",
  'advice.noRunway': 'Pist yok',
  'advice.buildRunway': 'Bir pist kur ve taksi yoluna bağla',
  'advice.shortRunway': 'Pistin bu uçağa yetmiyor',
  'advice.upgradeRunway': 'Pisti Sv.{level} yap',
  'advice.noLargeStand': 'Bu uçak için büyük stand yok',
  'advice.buildLargeStand': 'Büyük stand kur (Kule Sv.3), servis yolu ve taksi çizgisiyle',
  'advice.noStand': 'Stand yok',
  'advice.buildStand': 'Bir stand kur, servis yolu ve taksi çizgisiyle bağla',
  'advice.smallStand': 'Standların bu uçağa yetmiyor',
  'advice.upgradeStand': "Bir standı Sv.2'ye yükselt ya da büyük stand kur",
  'advice.noFire': 'İtfaiye bu uçağın kategorisini karşılamıyor',
  'advice.upgradeFire': 'İtfaiyeyi kur ya da Sv.{level} yap (personeliyle)',
  'advice.noCargo': 'Kargo terminali yok',
  'advice.buildCargo': 'Yola bağlı bir kargo terminali kur',
  'advice.noTerminal': 'Terminal yok',
  'advice.buildTerminal': 'Terminal kur ve karayoluyla otoyola bağla',
  'advice.noPassports': 'Dış hat yolcusu için pasaport kontrolü yok',
  'advice.upgradeTerminal': "Terminali Sv.{level}'ye yükselt",
  'advice.night': 'Gece saatlerinde uçuş var ama pistte ışık yok',
  'advice.lightRunway': "Pisti Sv.3'e yükselt (ışıklar)",
  'delayAlert.departure': 'Olağan dışı kalkış rötarı',
  'delayAlert.arrival': 'Olağan dışı iniş beklemesi',
  'delayAlert.lateOut': 'Kalkış saatinin üstünden {late} geçti, uçak hâlâ yerde.',
  'delayAlert.lateIn': 'İniş saatinin üstünden {late} geçti, uçak hâlâ inemedi.',
  'delayAlert.days': '{d} gün {h} saat',
  'delayAlert.hours': '{h} saat {m} dakika',
  'delayAlert.minutes': '{m} dakika',
  'delayAlert.why': 'Sebep',
  'delayAlert.tip': 'Ne yapmalı',
  'delayAlert.turnaround': 'Yer hizmetleri ve biniş bitmedi',
  'delayAlert.paused': 'Oyun durduruldu; kapatınca kaldığı hızla devam eder.',
  'delayAlert.show': 'Uçuşu göster',
  'delayAlert.mute': 'Bu sebebi bir daha gösterme',
  'delayAlert.ok': 'Anladım',
  'settings.delayAlerts': 'Olağan dışı rötar uyarıları',
  'settings.delayAlerts.hint':
    'Kalkışı 3 saatten fazla geciken ya da 45 dakikadan uzun inemeyen uçuşta oyun durur ve sebebini söyler. Kapatıp açmak gizlenen sebepleri geri getirir.',
  'advice.delay.title': 'Rötar Danışmanı',
  'advice.delay.summary': 'Dün ve bugün: zamanında kalkış %{pct}, ortalama rötar {avg} dk',
  'advice.delay.minutes': '{m} dk',
  'advice.cause.vehicles': 'Yer hizmeti araçları',
  'advice.cause.passengers': 'Geç kalan yolcular',
  'advice.cause.departure': 'Kalkış sırası',
  'advice.cause.arrival': 'İniş ve stand beklemesi',
  'advice.cause.technical': 'Teknik arıza',
  'advice.cause.weather': 'Yıldırım, fırtına ve kum fırtınası',
  'advice.delay.estimate':
    'Tahmin: tarifen aynı anda en çok {need} uçağa yer hizmeti istiyor ({hour} civarı), üslerinin araçları {have} uçağa yetiyor. Rötarsız olması için yaklaşık {levels} üs seviyesi ve {staff} yer hizmetleri personeli gerekir.',
  'advice.delay.noBase':
    "Yer hizmetlerini dış firma yapıyor: %50 daha yavaş ve uçak başına ücretli. Katalog → Operasyon'dan bir Yer Hizmetleri Üssü kur ve servis yoluyla standlara bağla.",
  'advice.delay.crews':
    "Yer hizmetleri personelin eksik ({hired}/{needed}): araçların bir kısmı sürücüsüz bekliyor. Yönetim → Personel'den işe al ya da Otomatik'i aç.",
  'advice.delay.crewsAuto':
    "Yer hizmetleri personeli şu an eksik ({hired}/{needed}): gece vardiyası azsa ya da grev varsa araçlar sürücüsüz kalır. Yönetim → Personel'den gece vardiyasını ve ücretleri kontrol et.",
  'advice.delay.fuel':
    'Yakıt tankerleri yetmiyor: tankerler yakıt deposundan gelir. Yakıt deposunu yükselt ya da ikinci bir depo kur.',
  'advice.delay.upgradeBase':
    'Yer hizmeti araçları yetmiyor: üssü bir seviye yükselt, Sv.{level} (üsse tıkla → Yükselt). Her seviye daha çok merdiven, otobüs, bagaj, catering ve temizlik aracı getirir.',
  'advice.delay.moreBases':
    "Üslerin en yüksek seviyede ama araç yetmiyor: {n}. Yer Hizmetleri Üssü'nü kur (kulen {max} üse izin veriyor), servis yoluyla standların yakınına.",
  'advice.delay.towerUp':
    'Kulenin izin verdiği her şey kurulu ve araç hâlâ yetmiyor: kuleyi yükselt, Sv.{level} (daha çok üs ve üs seviyesi açılır) ya da sözleşmeleri farklı saatlere yay.',
  'advice.delay.spread':
    'Yer hizmetleri tam kapasitede: aynı saate yığılan sözleşmeleri farklı saatlere yay ya da yoğun saatte yeni sözleşme imzalama.',
  'advice.delay.passengers':
    'Yolcular uçağa geç yetişiyor: check-in ve güvenlik kuyrukları uzun. Terminale tesis (check-in, güvenlik) ekle ya da terminali yükselt; körüklü stand ve otobüs istasyonu da hızlandırır.',
  'advice.delay.passengersStaff':
    "Yolcular uçağa geç yetişiyor: terminal personeli eksik, check-in ve güvenlik yavaş. Yönetim → Personel'den terminal personelini tamamla.",
  'advice.delay.departure':
    'Hazır uçaklar kalkış için sıra bekliyor: pist ya da taksi yolu yoğun. Pisti ikiye çıkar, paralel taksi yolu aç ya da sözleşmeleri farklı saatlere yay.',
  'advice.delay.arrival':
    'Uçaklar inmek ya da boş stand bulmak için bekliyor: stand ekle (geniş gövdeye büyük stand), uzun kalanlar için uzak park yeri kur, pist kapasitesini artır.',
  'advice.delay.technical':
    'Teknik arızalar uçakları bekletiyor: bir hangar kur ya da yükselt; bakım ekipleri onarımı kısaltır.',
  'advice.delay.weather':
    'Yıldırım, fırtına ya da kum fırtınası yer işlerini durdurdu veya yavaşlattı: hava geçince düzelir; yapılacak pek bir şey yok.',
  'advice.go.staff': "Personel'e git",
  'advice.go.build': '{building} kur',
  'advice.go.select': 'Binayı göster',
  'advice.toast.vehicles':
    'Rötarlı kalkış oranı %{pct}, en çok yer hizmeti araçları yüzünden. Ne yapacağını görmek için tıkla.',
  'advice.toast.passengers':
    'Rötarlı kalkış oranı %{pct}, en çok uçağa geç yetişen yolcular yüzünden. Ne yapacağını görmek için tıkla.',
  'advice.toast.departure':
    'Rötarlı kalkış oranı %{pct}, en çok kalkış sırası yüzünden. Ne yapacağını görmek için tıkla.',
  'advice.toast.arrival':
    'Rötarlı kalkış oranı %{pct}, en çok iniş ve stand beklemesi yüzünden. Ne yapacağını görmek için tıkla.',
  'advice.toast.technical':
    'Rötarlı kalkış oranı %{pct}, en çok teknik arızalar yüzünden. Ne yapacağını görmek için tıkla.',
  'advice.toast.weather':
    'Rötarlı kalkış oranı %{pct}, en çok fırtına yüzünden. Ayrıntılar için tıkla.',
  'toast.open': 'Açmak için tıkla',
  'delayAlert.turnaroundBy': 'Yer işlemleri bitmedi, en çok şu yüzden: {cause}',
  'delayAlert.fix': 'Düzeltmeye git',
  'staff.estimate':
    'Tahmin: tarifen aynı anda en çok {need} uçağa yer hizmeti istiyor ({hour} civarı), üslerin {have} uçağa yetiyor. Bunun için yaklaşık {levels} üs seviyesi ve {staff} personel gerekir. Kurulu üs: {bases}/{max}.',
  'capacity.handling':
    "{hour} civarı aynı anda {need} uçağa yer hizmeti gerekecek, yer hizmetleri üslerin {have} uçağa yetiyor: rötar olur. Üssü yükselt ya da yeni üs kur, Yönetim → Personel'den yer hizmetleri personelini tamamla.",
  'capacity.largeStands':
    '{hour} civarı {need} büyük uçak (geniş gövde, jumbo, dev kargo) aynı anda yerde olacak, {have} büyük standın var.',
  'req.largeStand': 'Büyük stand',
  'ops.report': 'Memnuniyet',
  'report.title': 'Havayolu Değerlendirmesi',
  'report.lead':
    '{airline}, havalimanınızla çalışmaktan memnuniyetini %{score} olarak değerlendiriyor. Aşağıda uçuşlarının burada neler yaşadığı ve memnuniyetsizliğin sebepleri var.',
  'report.verdict.bonus':
    'Çok memnun: süre bitince sözleşmeyi yeniler ve sefer ekler (puan %{bonus} ve üstü).',
  'report.verdict.renew':
    "Memnun: süre bitince sözleşmeyi yeniler (puan %{renew} ve üstü). %{bonus}'a çıkarsa sefer de ekler.",
  'report.verdict.noRenew':
    "Memnun değil: puan %{renew}'in altında kalırsa süre bitince yenilemez. %{suspend}'in altına düşerse uçuşları askıya alır.",
  'report.verdict.suspend':
    "Çok kızgın: puan %{suspend}'in altında, uçuşlarını askıya almak üzere. Hemen aşağıdaki sebepleri düzelt.",
  'report.none': 'Bu sözleşmeyle henüz kalkış yapılmadı.',
  'report.punctuality': 'Dakiklik',
  'report.punctualityValue': '{onTime} zamanında · {late} rötarlı (zamanında %{pct})',
  'report.avgDelay': 'Ortalama rötar',
  'report.lostBy': 'Kaybedilen dakikalar',
  'report.causeValue': '{cause}: {m} dk',
  'report.missed': 'Uçağı kaçıran yolcu',
  'report.missedValue': '{n} / {of} (%{pct})',
  'report.bags': 'Uçağa yetişmeyen bagaj',
  'report.fees': 'Ücretler',
  'report.feesValue': 'Tarifenin üstünde: her kalkışta {pts} puan düşürüyor',
  'report.feesOk': 'Tarifede ya da altında: sorun yok',
  'report.why': 'Memnuniyetsizliğin sebepleri',
  'report.why.late':
    'Kalkışlarında {m} dakikayı aşan rötar oranı %{pct}; en çok dakikayı "{cause}" kaybettiriyor. {m} dakikayı aşan her rötar dakikası puanı 2 düşürür.',
  'report.why.missed':
    'Uçağı kaçıran yolcu oranı %{pct}: yolda trafik, check-in ve güvenlik kuyrukları. Kavşakları, terminali ve terminal personelini kontrol et.',
  'report.why.bags':
    '{n} bagaj uçağa yetişmedi (her biri tazminat): bagaj araçları ve yer hizmetleri yetmiyor olabilir.',
  'report.why.fees':
    "İniş ve yolcu ücretlerin tarifenin üstünde: her kalkışta {pts} puan. Yönetim → Finans'tan ücretleri düşür.",
  'report.why.cancelled':
    '{n} seferi iptal oldu: iptaller güvenilirliği düşürür ve üst üste gelirse sözleşme askıya alınır.',
  'report.why.happy': 'Şikâyeti yok: böyle devam et.',
  'report.why.none': 'Belirgin bir şikâyet yok; puan yeni kalkışlarla yavaşça yükselir.',
  'report.fix': 'Ne yapmalı:',
  'report.how':
    'Puan her kalkışta yeniden değerlendirilir: {m} dakikayı aşan her rötar dakikası 2 puan, uçağı kaçıranların yüzdesinin yarısı ve tarifenin üstündeki ücretler düşürür; puan her seferinde yeni değere dörtte bir yaklaşır.',
  'book.open': 'Rapor defterini aç',
  'book.title': 'Müdürlük Rapor Defteri',
  'book.page.now': 'Mevcut Durum',
  'book.page.allTime': 'Bu Zamana Kadar',
  'book.page.satisfaction': 'Memnuniyet',
  'book.page.delays': 'Rötarlar',
  'book.page.money': 'Kasa',
  'book.cutOff':
    'Müdürlüğe servis yolu bağlı değil: personel gelemiyor, defter tutulamıyor. Binayı servis yoluyla bağla.',
  'book.prev': 'Önceki sayfa',
  'book.next': 'Sonraki sayfa',
  'book.pageOf': 'Sayfa {n} / {of}',
  'book.money': 'Kasa',
  'book.rating': 'Havalimanı puanı',
  'book.contracts': 'Yürürlükteki sözleşmeler',
  'book.offers': 'Bekleyen teklifler',
  'book.aircraftNow': 'Şu an havalimanındaki uçaklar',
  'book.departuresToday': 'Bugün kalkan',
  'book.passengersToday': 'Bugün yolcu',
  'book.onTimeToday': 'Bugün zamanında kalkış',
  'book.cancelledToday': 'Bugün iptal',
  'book.staff': 'Personel (çalışan / gereken)',
  'book.buildings': 'Bina sayısı',
  'book.profitToday': 'Bugünkü kâr',
  'book.cityCustomers': 'Şehir müşterileri',
  'book.citySales': 'Şehirden gelir (satış ve kira)',
  'book.departures': 'Kalkan uçak',
  'book.passengers': 'Yolcu',
  'book.days': 'Gün',
  'book.transfers': 'Aktarmalı yolcu',
  'book.tonnes': 'Taşınan yük',
  'book.tonnesValue': '{t} ton',
  'book.onTime': 'Zamanında kalkış',
  'book.avgDelay': 'Ortalama rötar',
  'book.cancelled': 'İptal edilen sefer',
  'book.missed': 'Uçağı kaçıran yolcu',
  'book.bags': 'Uçağa yetişmeyen bagaj',
  'book.hotelGuests': 'Otel misafiri',
  'book.income': 'Gelir',
  'book.costs': 'Gider',
  'book.profit': 'Kâr',
  'book.olderSave':
    'Bu kayıt defterden önce başladı: yolcu ve para toplamları bu sürümden itibaren tutuluyor, kalkışlar baştan beri.',
  'book.passengersSay': 'Yolcular ne diyor',
  'book.airlinesSay': 'Havayolları ne diyor',
  'book.airlinesAverage': 'Havayollarının ortalama memnuniyeti: %{pct}',
  'book.airlinesHint': 'Ayrıntı ve sebepler için bir havayoluna tıkla.',
  'book.inbound': 'Kalkış yerinden geç gelenler (sizin suçunuz değil)',
  'book.delaysLead': 'Bu zamana kadar kalkışların kaybettiği dakikalar, sebebe göre:',
  'book.today': 'Dün ve bugün',
  'book.delaysHint': 'Danışman boşsa uçuşlar zamanında kalkıyor demektir.',
  'book.col.today': 'Bugün',
  'book.col.yesterday': 'Dün',
  'book.col.average': 'Ortalama gün',
  'delayTip.0':
    'Yer hizmetleri ve biniş henüz bitmedi: uçuş kartından neyin beklediğine bak; yer hizmetleri üssü, merdiven/otobüs ve check-in kapasitesini artır.',
  'delayTip.1': 'Terminal kur ve karayoluyla otoyola bağla.',
  'delayTip.2':
    'Bu uçağa yetecek pist yok: pisti yükselt (bölgesel Sv.1, dar gövde Sv.2, geniş gövde Sv.4, jumbo ve dev kargo Sv.5).',
  'delayTip.3':
    'Uygun boş stand yok: stand ekle ya da standları yükselt; uzun kalan uçaklar için uzak park yeri kur.',
  'delayTip.4':
    'Pistle stand arasında sarı taksi çizgisi yok ya da kesik: taksi çizgilerini baştan sona kontrol et.',
  'delayTip.5': 'Pist çok yoğun: ikinci bir pist kur ya da sözleşmeleri farklı saatlere yay.',
  'delayTip.5.single':
    'Pist çok yoğun: sözleşmeleri farklı saatlere yay. İkinci pist kule Sv.{level} ile açılır.',
  'delayTip.8.single':
    'Yan rüzgâr sınırın üstünde: rüzgârın dönmesini bekle. Farklı yönde ikinci pist kule Sv.{level} ile açılır.',
  'delayTip.14.single':
    'Pist yükseltme için kapalı: bitmesini bekle. İkinci pist kule Sv.{level} ile açılır.',
  'delayTip.18.single':
    'Pist yüzey yenilemede: bitmesini bekle. İkinci pist kule Sv.{level} ile açılır.',
  'delayTip.6': "Gece iniş-kalkış için pist ışıkları gerekir: pisti Sv.3'e yükselt.",
  'delayTip.7': 'Taksi yolu tıkalı: paralel bir taksi yolu ya da ikinci bir bağlantı ekle.',
  'delayTip.8': 'Yan rüzgâr sınırın üstünde: farklı yönde ikinci bir pist kur.',
  'delayTip.9':
    'Pushback çekicileri yetmiyor: yer hizmetleri üssünü yükselt, personelini tamamla; kule izin veriyorsa yeni üs kur.',
  'delayTip.10':
    "Sis ya da kum fırtınası: pisti Sv.3'e (CAT I ILS), çok düşük görüş için Sv.4'e (CAT III) yükselt.",
  'delayTip.11': 'Buz çözme uzun sürüyor: buz çözme pedi kur.',
  'delayTip.12': 'İtfaiye yok ya da seviyesi yetmiyor: itfaiye kur ya da yükselt.',
  'delayTip.13': "Kulede kontrolör yok: Yönetim → Personel'den kontrolör işe al.",
  'delayTip.14': 'Pist yükseltme için kapalı: bitmesini bekle ya da ikinci bir pist kur.',
  'delayTip.15': 'Standlara servis yolu ya da karayolu bağlı değil: yer araçlarının yolunu bağla.',
  'delayTip.16': 'Pist acil durum incelemesinde: kısa sürede açılır.',
  'delayTip.17': 'Pist karla kapalı: kar ekiplerini ve kar üssünü güçlendir.',
  'delayTip.18': 'Pist yüzey yenilemede: bitmesini bekle ya da ikinci pist kur.',
  'delayTip.19': 'Savaş uçakları acil kalkışta: askerî pist ayırmak sivil trafiği korur.',
  'delayTip.20': 'Uçak başka havalimanına yönlendirildi: pist ve stand kapasitesini artır.',
  'delayTip.21': 'Boş ve yola bağlı helikopter pisti yok: helikopter pisti ekle ya da yola bağla.',
  'delayTip.22':
    'Yer hizmeti araçları yetmiyor: yer hizmetleri üssünü yükselt, personelini tamamla; kule izin veriyorsa yeni üs kur.',
  'settings.quietToasts': 'Yalnız önemli bildirimler',
  'settings.quietToasts.hint': 'Uyarılar ve başarımlar kalır, sıradan bildirimler gizlenir.',
  'settings.camera': 'Kamera',
  'settings.panSpeed': 'Kaydırma hızı',
  'settings.edgePan': 'Kenarda kaydır',
  'settings.edgePan.hint': 'Fare ekranın kenarına gelince harita kayar.',
  'settings.invertZoom': 'Yakınlaştırmayı ters çevir',
  'settings.saving': 'Kayıt',
  'settings.autosave': 'Otomatik kayıt',
  'settings.autosave.hint': 'Oyun bu aralıkla kendiliğinden kaydeder.',
  'settings.minutes': '{n} dk',
  'spectate.title': 'Seyir kamerası',
  'spectate.chip': 'Seyir kamerası: uçakları izle (C)',
  'spectate.searching': 'İzlenecek uçak aranıyor…',
  'spectate.follow': 'Takip',
  'spectate.cockpit': 'Kokpit',
  'spectate.tower': 'Kule',
  'spectate.trackside': 'Pist kenarı',
  'spectate.tour': 'Tur',
  'spectate.tour.hint': 'Kamera en ilginç uçaklar ve açılar arasında kendi geçiş yapar',
  'spectate.prev': 'Önceki uçak ([)',
  'spectate.next': 'Sonraki uçak (])',
  'spectate.exit': 'Haritaya dön (Esc)',
  'admin.title': 'Admin modu (geçici)',
  'admin.on': 'Sınırsız parayı aç',
  'admin.off': 'Sınırsız parayı kapat',
  'admin.hint':
    'Denemek için: para hiç bitmez. Bu oyun bir kez açılınca başarımlara ve dünya sıralamasına sayılmaz.',
  'admin.used': 'Bu oyunda admin modu kullanıldı: başarımlara ve sıralamaya sayılmıyor.',
  'dgoal.title': 'Bugünün görevleri',
  'dgoal.0': 'Bugün {n} kalkış',
  'dgoal.1': 'Bugün {n} yolcu',
  'dgoal.2': 'Bugün {money} gelir',
  'dgoal.3': 'Bugün {n} ton kargo',
  'dgoal.4': 'Gün boyu kalkışların %{n} dakik',
  'dgoal.5': 'Gün boyu hiç iptal yok',
  'toast.dailyMet': 'Günlük görev tamam: {goal} (+{reward})',
  'toast.dailyNew': 'Yeni günün görevleri hazır.',
  'fcard.title': 'Uçuş kartı',
  'fcard.status': 'Durum',
  'fcard.aircraft': 'Uçak',
  'fcard.stand': 'Park yeri',
  'fcard.contact': 'Körüklü stand {n}',
  'fcard.remote': 'Apron park yeri {n}',
  'fcard.arrival': 'Geliş',
  'fcard.departure': 'Kalkış',
  'fcard.late': '{time} (+{min} dk rötar)',
  'fcard.onDay': '{day}. gün {time}',
  'fcard.reason': 'Bekleme sebebi',
  'fcard.paxIn': 'Gelen yolcu',
  'fcard.paxOut': 'Binen yolcu',
  'fcard.cargo': 'Kargo',
  'fcard.tonnes': '{n} ton',
  'fcard.service': 'Yer hizmetleri',
  'fcard.bye': 'İyi uçuşlar! Uçak gidince bu kart kapanır.',
  'fcard.vip': 'VIP',
  'fcard.livery': 'Boya',
  'fcard.special': 'Özel boya (yıldönümü)',
  'vip.1': 'Dışişleri Bakanı Selin Aksoy',
  'vip.2': 'Rock yıldızı Kaan Ateş',
  'vip.3': 'İş insanı Cem Taşkıran',
  'vip.4': 'Karadeniz Yıldızları SK',
  'news.spotterDeck': 'Yeni bina: İzleme Terası',
  'news.spotterDeck.text':
    'Kule Sv.1 ile açılan küçük bir bina. Pistin yakınına, yola bağlı kurarsan gündüz her kalkışta ziyaretçiler ücret öder; geniş gövdeli ve askeri uçaklar daha çok kalabalık çeker. Havalimanı hakkındaki konuşmaları da olumlu yönde canlı tutar. Sv.2 üst kat ekler.',
  'toast.goSee': 'Tıkla, kamera oraya gitsin',
  'toast.rainbow': 'Yağmur dindi, gökkuşağı çıktı! Görmek için tıkla.',
  'toast.firstSnow':
    'İlk kar düştü ❄️ Kar tutunca terminalin çevresinde kardan adamlar yapılacak ⛄ Görmek için tıkla.',
  'toast.celebration': '{n}. kalkış! Havalimanı kutluyor, sahiplerden tebrik: +{reward}',
  'news.terminalSound': 'Terminalin sesi',
  'news.terminalSound.text':
    'Kamerayı bir terminale yaklaştırınca içerideki kalabalığın uğultusu duyulur; kuyruklar uzadıkça uğultu artar. Ara sıra terminalin anons zili çalar.',
  'news.engineSound': 'Gerçekçi motor sesleri',
  'news.engineSound.text':
    'Uçak sesleri baştan yapıldı: her yakın uçağın kendi sesi var, kameraya göre sağdan ya da soldan duyulur. Kalkışta tam gücün gürlemesi, yaklaşmada fan ıslığı, inişte ters itki, taksi rölantisi, helikopterde pal vuruşu; yaklaşırken tizleşip uzaklaşırken pesleşir (Doppler), uzaktakiler boğuklaşır ve havalimanında yankılanır. Havai fişekler ve gök gürültüsü de yankılı.',
  'news.rainbow': 'Yağmurdan sonra gökkuşağı',
  'news.rainbow.text':
    'Gündüz yağmur dinince, güneş alçaktaysa (sabah ya da öğleden sonra) güneşin tam karşısında bir süre gökkuşağı belirir, üstünde soluk ikinci bir yay ile. Kamerayı alçaltınca ya da izleyici kamerasında görürsün.',
  'news.celebrations': 'Kalkış kutlamaları',
  'news.celebrations.text':
    'Havalimanın 100., 500., 1000., 2500., 5000. … kalkışına ulaştığında terminalin üstünde havai fişekler patlar, sosyal medya konuşur ve havalimanının sahipleri bir tebrik ödemesi gönderir (10 bin $’dan 1 milyon $’a kadar).',
  'toast.airshowAnnounced': 'Bugün 15:00’te akrobasi timi gösterisi var! İzleme terasları dolacak.',
  'toast.airshow': 'Hava gösterisi başladı! Teraslardan gelir: +{income}',
  'news.airshow': 'Hava gösterisi',
  'news.airshow.text':
    'Kule Sv.3 ve en az bir İzleme Terası olunca bazı günler (yaklaşık sekiz günde bir) bir akrobasi timi gelir: sabah haber verilir, saat 15:00’te dört jet kırmızı-beyaz dumanla pist boyunca alçak geçiş yapar, döngü atar ve sonunda bomba patlaması figürüyle dağılır. Teraslar seviyelerine göre gelir getirir, havalimanı da çok konuşulur.',
  'toast.newYear': 'Mutlu yıllar! Havalimanı yeni yılı havai fişeklerle karşılıyor.',
  'news.fireworks': 'Havai fişekler',
  'news.fireworks.text':
    'Yeni yıla girerken ve kule her seviye atladığında terminalin üzerinde havai fişek gösterisi olur. Oyun duraklatılmış olsa da gösteri sürer; gece çok daha güzel görünür.',
  'toast.waterSalute': '{airline} yeni hattının ilk uçuşu su takıyla karşılanıyor!',
  'news.waterSalute': 'İlk uçuşa su takı',
  'news.waterSalute.text':
    'Yeni bir hattın ilk uçağı inince itfaiye onu gerçek havalimanlarındaki gibi karşılar: iki itfaiye aracı taksi yolunun iki yanına dizilir, uçak su kemerinin altından geçerek standına gider. Bir itfaiye istasyonu olması yeter.',
  'toast.vipAnnounced': 'VIP geliyor: {who}, {time} kalkışlı {flight} uçuşunda. Zamanında uğurla!',
  'toast.vipPleased': '{who} memnun ayrıldı: teşekkür ödemesi +{reward}',
  'toast.vipLetDown': '{who} hayal kırıklığıyla ayrıldı; basında kötü haber var.',
  'fcard.follow': 'Kamerayla izle',
  'fcard.close': 'Kapat',
  'phase.1': 'Yaklaşmada',
  'phase.2': 'İniyor',
  'phase.3': 'Taksi: apronya',
  'phase.4': 'Park yerinde',
  'phase.5': 'Kalkışa hazır',
  'phase.6': 'Taksi: piste',
  'phase.7': 'Kalkıyor',
  'phase.8': 'Tırmanışta',
  'phase.9': 'Pas geçti',
  'photo.title': 'Fotoğraf modu',
  'photo.exit': 'Fotoğraf modundan çık (Esc)',
  'photo.hour': 'Işık saati',
  'photo.gameTime': 'oyun saati',
  'photo.reset': 'Oyun saatine dön',
  'photo.freeze': 'Dondur',
  'photo.resume': 'Devam',
  'photo.take': 'Fotoğraf çek',
  'photo.hint':
    'Arayüz gizli. Kamerayı fare ve WASD ile ayarla; uçağı izlerken sürükleyerek çevir, tekerlekle yaklaş.',
  'help.key.spectate':
    'Seyir kamerası: uçakları izleyen otomatik tur (bir uçağa tıklamak da onu izletir)',
  'help.key.spectateView': 'Seyir kamerası görünümü: takip, kokpit, kule, pist kenarı',
  'help.key.spectateCycle': 'Önceki / sonraki uçağı izle',
  'help.key.photo': 'Fotoğraf modu: arayüz gizlenir, ışık saati seçilir, fotoğraf çekilir',
  'radio.station.tower': '{airport} Kule',
  'radio.station.ground': '{airport} Yer',
  'radio.approach.1': '{airport} Kule, {cs}, ILS pist {rwy} yaklaşmasında.',
  'radio.approach.visual': '{airport} Kule, {cs}, pist {rwy} için görerek yaklaşmadayız.',
  'radio.approach.2':
    '{cs}, {airport} Kule, rüzgâr {wdir} derece {wspd} knot, pist {rwy} iniş serbest.',
  'radio.landed.1':
    '{cs}, ilk uygun çıkıştan pisti terk edin, Yer ile irtibat kurun, 121 virgül 7.',
  'radio.landed.2': 'Pisti terk ediyoruz, Yer 121 virgül 7, {cs}.',
  'radio.taxiIn.1': '{airport} Yer, {cs}, park yeri {stand} üzerindeyiz.',
  'radio.taxiIn.2': '{cs}, anlaşıldı, iyi günler.',
  'radio.ready.1': '{airport} Yer, {cs}, park yeri {stand}, itme ve çalıştırma için hazırız.',
  'radio.ready.2': '{cs}, itme ve çalıştırma onaylandı, kalkış pisti {rwy}.',
  'radio.taxiOut.1': '{cs}, pist {rwy} için taksi edin, pist girişinde bekleyin.',
  'radio.taxiOut.2': 'Pist {rwy} için taksi, girişte bekleyeceğiz, {cs}.',
  'radio.takeoff.1': '{airport} Kule, {cs}, pist {rwy} girişinde, kalkışa hazır.',
  'radio.takeoff.2': '{cs}, rüzgâr {wdir} derece {wspd} knot, pist {rwy} kalkış serbest.',
  'radio.climb.1': '{cs}, Yaklaşma ile irtibat kurun, iyi uçuşlar.',
  'radio.climb.2': 'Yaklaşma ile irtibat, iyi günler, {cs}.',
  'radio.goAround.1': '{airport} Kule, {cs}, pas geçiyoruz.',
  'radio.goAround.2':
    '{cs}, anlaşıldı, pist ekseninde üç bin fite tırmanın, yeniden sıraya alınacaksınız.',
  'radio.mayday.1':
    'Mayday, mayday, mayday, {cs}, acil durum ilan ediyoruz, öncelikli iniş talep ediyoruz.',
  'radio.mayday.2': '{cs}, mayday anlaşıldı, pist {rwy} sizin, kurtarma ekipleri hazırda.',
  'settings.radio': 'Kule telsizi',
  'settings.radio.hint': 'Uçaklarla kule arasındaki konuşmalar, yazılı kayıt olarak.',
  'settings.radio.text': 'Yazılı',
  'radio.title': 'Kule frekansı',
  'ops.tab.apron': 'Apron planı',
  'ops.tab.album': 'Albüm',
  'album.collected': 'Havayolu albümü %{pct} tamam',
  'album.kind.domestic': 'İç hat',
  'album.kind.international': 'Dış hat',
  'album.kind.cargo': 'Kargo',
  'album.kind.private': 'Özel jet',
  'album.kind.heli': 'Helikopter',
  'album.kind.military': 'Askerî',
  'album.need.domestic': 'Sözleşme imzalayıp ilk uçuşunu uğurla',
  'album.need.international': 'Pasaport kontrolü gerekir (terminal Sv.2)',
  'album.need.cargo': 'Kargo terminali gerekir',
  'album.need.private': 'İlk kuleyle gelir',
  'album.need.heli': 'Helikopter pisti gerekir',
  'album.need.military': 'Askerî bölge gerekir (kule Sv.3)',
  'toast.albumNew': 'Albüme yeni havayolu: {airline} ({n}/{total})',
  'news.advice': 'Teklifte eksik uyarısı',
  'news.advice.text':
    'Bir teklifi açtığında havalimanın onu karşılayamıyorsa neyin eksik olduğu ve ne yapman gerektiği (pist, stand, itfaiye, terminal, kargo terminali, gece ışıkları) bir pencerede yazar.',
  'news.sizes': 'Üç boy pist, stand ve park yeri',
  'news.sizes.text':
    'Küçük stand tek motorlu küçük uçaklar için; mevcutlar orta boy olarak aynen çalışıyor; Kule Sv.3 ile büyük stand ve büyük park yeri açılıyor. Büyük olanları "herkese açık" ya da "yalnız büyükler" yapabilirsin. Geniş gövdeler büyük standı önce seçer. (Pist sonradan beş seviyeli tek piste dönüştü.)',
  'news.giants': 'Dev uçaklar: 747 tipi ve Antonov tipi',
  'news.giants.text':
    'Dev yolcu uçağı (Kule Sv.4) ve 150 ton taşıyan dev kargo uçağı (Kule Sv.3) yalnız Sv.5 piste iner ve büyük standa park eder. Aeroklüp ve uçuş okullarının tek motorlu küçük uçakları da geldi.',
  'news.militaryTower': 'Askerî kule',
  'news.militaryTower.text':
    'Askerî bölgeye kendi kulesi: her seviyesi Bakanlık tekliflerini sıklaştırır, aynı anda daha çok askerî teklif ve sözleşmeye izin verir.',
  'news.delayAlerts': 'Olağan dışı rötar uyarısı',
  'news.delayAlerts.text':
    'Bir uçuşun kalkışı 3 saatten fazla gecikirse ya da 45 dakikadan uzun inemezse oyun durur ve sebebini, ne yapman gerektiğini söyler. "Bu sebebi bir daha gösterme" ile susturabilirsin. Park yerinde günlerce bekleyen uçak hatası da düzeltildi.',
  'news.boom': 'Ürkütücü sonik patlama',
  'news.boom.text':
    'Jetler geçerken çift çatlamalı gerçek bir sonik patlama, göğüste hissedilen bir gümleme ve uzaklara yuvarlanan bir gürültü duyulur. Savaş uçağı motorları daha sert.',
  'news.tollIncome': 'Gişe geliri',
  'news.tollIncome.text':
    'Otoyoldan terminale giden yol bir gişeden geçiyorsa her binen yolcu 0,50 $ geçiş ücreti öder (yolda birden fazla gişe olsa da bir kez). Gelir tablosunda "Gişe geçişleri" satırı.',
  'news.serviceTunnels': 'Taksi yolu altından servis tüneli',
  'news.serviceTunnels.text':
    'Servis yolunu bir taksi yolunun üstünden çizdiğinde artık altından tünelle geçiyor: taksi yolu yerinde kalıyor, yer hizmeti araçları rampadan inip taksi yolunun altından öbür tarafa ulaşıyor ve üstten geçen uçağı beklemiyor. Taksi yolunda biten bir servis yolu öbür yana kendisi uzar.',
  'news.tolls': 'Gişe artık ayrı bir yapı',
  'news.tolls.text':
    'Yeni Gişe aracı (0): karayoluna tıkla, gişe yolun tüm genişliğini kaplasın; gişeye tıklamak kaldırır. Otoyol bağlantısına artık kendiliğinden gişe konmuyor. Bariyerler açık, araçlar beklemeden geçiyor; birden fazla giriş varsa her araç geldiği yöne en yakın gişeden giriyor.',
  'news.insulation': 'Gürültü kotasını büyüt',
  'news.insulation.text':
    'Gece gürültü kotası kule her yükseldiğinde +4 puan artıyor. dB düğmesinin kartından evlere ses yalıtımı yaptırarak kotayı kalıcı büyütebilirsin (3 adım, +12 puan). Kule Sv.4 ile 4 pist kurulabiliyor.',
  'news.militaryRoads': 'Askeri bölge: servis yolu ve uyarılar',
  'news.militaryRoads.text':
    'Askeri bölge kapısı servis yoluyla da bağlanabiliyor; sığınak ve askeri apron karayolu yerine servis yolu istiyor. Askeri yapıların kartları neyin nereye konacağını sivildeki gibi yazıyor. Hava Kuvvetleri paylaşımları da artık gerçekçi.',
  'news.look': 'Daha dengeli ışık',
  'news.look.text':
    'Gündüz daha az parlak (helikopter pistindeki H artık okunuyor), gece ay ışığı havalimanını aydınlatıyor; stand zemini derz çizgisiz, daha gri beton.',
  'news.flyby': 'Jet geçişleri',
  'news.flyby.text':
    'Üçüncü günden itibaren ara sıra savaş jetleri (gri, koyu, kum rengi) ya da kırmızı-beyaz gösteri jeti havalimanının arkasındaki ormanın üstünden haritayı boydan boya geçip gider; bazıları ince bir duman izi bırakır. Kameraya en yakın geçtikleri an ses patlamasına yakın bir gürleme duyulur.',
  'news.sharp': 'Daha keskin görüntü, üç kat FPS',
  'news.sharp.text':
    'Gölgeler, akıllı ölçekleme, ortam gölgelendirmesi, minyatür odak, yüksek DPI ve otomatik akıcılık kaldırıldı: oyuncuların denemesinde bunlar kapalıyken görüntü daha keskin, FPS üç kat yüksekti (50 → 150). Oyun artık ekran çözünürlüğünde, kenar yumuşatmayla çiziliyor.',
  'news.onTime': 'Uçaklar kâğıttaki saatte kalkar',
  'news.onTime.text':
    'Gece kalan ve kiralık park uçakları artık gerçekten uzak park pozisyonuna çekilir; beklerken stand, merdiven, bagaj treni ve çekici tutmaz. Böylece diğer uçaklar saatinde hizmet alıp kalkar. Bir uçuş gecikirse uçuş kartında rötar ve sebebi yazar (gece pist ışığı, rüzgâr, araçlar meşgul…).',
  'news.apron': 'Bitişik standlar tek apron',
  'news.apron.text':
    'Kenar kenara bitişik standlar (körüklü ve uzak park dahil) artık tek apron: birinin servis yolu varsa yanındakiler ek servis yolu istemez, araçlar apronun üstünden geçer. Bağlı bir standın yanına konan körüklü stand kendi yolunu döşemez.',
  'news.snowmen': 'Kardan adamlar',
  'news.snowmen.text':
    'Kar tutunca terminalin, otelin, istasyonun ve otoparkın çevresindeki çimlerde birer birer kardan adamlar yapılır (şapka, atkı, havuç burun); hava ısınınca çöküp erirler. Her kışın ilk karında bir bildirim gelir, tıklayınca kamera oraya gider.',
  'news.weatherOutlook': 'Hava tahmini ve karlı kışlar',
  'news.weatherOutlook.text':
    'Üst çubuktaki hava durumuna tıkla: önümüzdeki saatlerin yanında 7 günlük tahmin (en düşük/en yüksek sıcaklık, kar, yağmur ya da fırtına ihtimali, kar fırtınası günü) ve mevsim şeridi var; kışa kaç gün kaldığını görürsün. Kış (her yılın 22–28. günleri) artık gerçekten karlı: günlerin çoğunda kar yağar.',
  'news.freeBrush': 'Serbest yol çizimi',
  'news.freeBrush.text':
    'Yol ve taksi yolu artık 4 karelik ızgaraya oturmaz: imleç nereden başlayıp nerede biterse yol orada, kare kare çizilir. Var olan bir yolun üstünden ya da ucundan başlarsan onun hizasında devam eder; bir yolun yanından dönersen köşe kenarı kenarına oturur. Bina ile pist (ya da iki bina) arasındaki dar bir boşluğa tıklayınca ya da üstünden sürükleyince yol boşluk kadar kesilip tam oturur.',
  'news.buildSites': 'Canlı şantiyeler',
  'news.buildSites.text':
    'Şantiyelerde vinç, ekskavatör, damperli kamyon ve kasklı işçiler çalışır; toz kalkar, kaynak kıvılcımı sıçrar, geceleri projektörler yanar, yaklaşınca çekiç sesi duyulur. Bina bitince "tak tak tak" diye dört adımda yerine oturur.',
  'news.album': 'Havayolu albümü',
  'news.album.text':
    'Uçuşlar panelinde yeni bir sekme: havalimanından kalkan her havayolu albüme kartıyla girer, gelmeyenler kilitli bekler ve ne gerektiği yazar (kargo terminali, helikopter pisti, askerî bölge…). Kaç tanesini topladığını ve yüzdeyi görürsün; 20 havayolu Koleksiyoncu başarımını getirir.',
  'apron.stand': 'Park {n}',
  'apron.unassigned': 'Atanmadı',
  'apron.busy': 'Dolu park yeri',
  'apron.late': 'Rötarlı',
  'apron.clashes': 'Çakışma',
  'apron.none': 'Henüz park yeri yok.',
  'apron.hint':
    'Her satır bir park yeri; çubuklar uçağın geliş ve kalkış arasıdır. Turuncu: kalkış saati geçti, kırmızı: aynı park yerine iki uçuş. Üstteki araçlardan biri kırmızıysa hepsi dışarıda: yenisini al. Bir park yerine tıkla, haritada seçilsin.',
  'apron.tone.planned': 'planlı',
  'apron.tone.on': 'park yerinde',
  'apron.tone.late': 'rötarlı',
  'apron.tone.clash': 'çakışma',
  'building.largeDeicePad': 'Büyük Buz Çözme Pedi',
  'desc.largeDeicePad':
    'Geniş gövde, jumbo ve dev kargo uçakları için buz çözme pedi: kanatların üstünden geçen püskürtme köprüsü ve dört kamyon. Bu uçaklar küçük pede sığmaz; bu ped yoksa buzlanmalı havada park yerlerinde kamyonla, daha yavaş arındırılırlar. Küçük uçaklar da kullanabilir. Taksi yoluna bağla. Kule Sv.4 gerekir, en fazla 2 tane.',
  'building.directorate': 'Havalimanı Müdürlüğü',
  'desc.directorate':
    'Yönetimin dört katlı plazası, personel otoparkıyla. Tıklayınca rapor defteri açılır: havalimanının şu anki durumu, bu zamana kadar kalkan uçaklar ve taşınan yolcular, memnuniyet ayrıntıları, sayfa sayfa ve canlı. Servis yolu bağlantısı şart: personel araçları oradan gelir. Kule Sv.3 gerekir.',
  'building.deicePad': 'Buz Çözme Pedi',
  'desc.deicePad':
    'Buzlanmalı havada uçaklar park yerinde değil, piste giderken bu pedde buzdan arındırılır: park yeri hemen boşalır, sabit püskürtme kuleleri kamyondan hızlıdır ve uçak başına ücret yoktur. Geniş gövde, jumbo ve dev kargo uçakları sığmaz: onlar için Büyük Buz Çözme Pedi kur. Taksi yoluna bağla. Kule Sv.3 gerekir.',
  'phase.10': 'Buz çözülüyor',
  'radio.taxiPad.1': '{cs}, itme tamam, buz çözme pedine taksi edin.',
  'radio.taxiPad.2': 'Buz çözme pedine taksi, {cs}.',
  'radio.deice.1': '{airport} Yer, {cs}, buz çözme pedindeyiz, motorlar rölantide.',
  'radio.deice.2':
    '{cs}, buz çözme başlıyor, tip dört sıvı; bitince kalkış için Kule ile irtibat kurun.',
  'radio.lvp.on':
    'Tüm istasyonlar, {airport} Kule: alçak görüş prosedürleri yürürlükte, görüş {vis} metre. Yalnız ILS yaklaşmaları.',
  'radio.lvp.off': 'Tüm istasyonlar, {airport} Kule: alçak görüş prosedürleri kaldırıldı.',
  'building.remoteParking': 'Uzak Park Pozisyonu',
  'desc.remoteParking':
    'Uçakların uçuşlar arasında beklediği sade apron: gece konaklayan uçaklar ve park kiralayan havayolları burada durur, saatlik park ücreti öder. Çekici uçağı park yerinden buraya çeker, park yeri boşalır; kalkıştan önce geri çeker. Hizmet yok, karayolu gerekmez; taksi yoluna bağla. Kule Sv.2 gerekir.',
  'building.smallRunway': 'Küçük Pist (eski)',
  'desc.smallRunway':
    'Tek motorlu küçük uçaklar için kısa, dar bir pist: aeroklüpler, uçuş okulları ve hava taksileri. Işığı yok (yalnız gündüz). Ucuz ve kısa sürede biter; taksi yoluna bağla. Kule Sv.1 gerekir.',
  'building.largeRunway': 'Büyük Pist (eski)',
  'desc.largeRunway':
    "Uzun ve geniş pist: dev yolcu uçakları ve dev kargo uçakları yalnız buraya iner; ışıkları ve ILS'i baştan var. Herkese açık ya da yalnız büyük uçaklara ayrılabilir. Kule Sv.3 gerekir.",
  'building.smallStand': 'Küçük Stand',
  'desc.smallStand':
    'Tek motorlu küçük uçakların standı: bağlama halkaları, takozlar. Küçük uçaklar önce buraya çeker. Servis yolu ve taksi yoluna bağla. Kule Sv.1 gerekir.',
  'building.largeStand': 'Büyük Stand',
  'desc.largeStand':
    'Geniş gövde, dev yolcu ve dev kargo uçaklarının standı: geniş gövdeler başka standa sığmaz. Herkese açık ya da yalnız büyük uçaklara ayrılabilir. Servis yolu ve taksi yoluna bağla. Kule Sv.3 gerekir.',
  'building.smallParking': 'Küçük Park Yeri',
  'desc.smallParking':
    'Küçük uçakların uzun beklediği park yeri. Hizmet yok, taksi yoluna bağla. Kule Sv.1 gerekir.',
  'building.largeParking': 'Büyük Park Yeri',
  'desc.largeParking':
    'Dev uçakların gece kaldığı ve kiralık park ettiği geniş park yeri. Yalnız büyük uçaklara ayrılabilir. Hizmet yok, taksi yoluna bağla. Kule Sv.3 gerekir.',
  'building.militaryTower': 'Askerî Kule',
  'desc.militaryTower':
    'Askerî bölgenin kontrol kulesi: her seviyesi Bakanlık tekliflerini sıklaştırır, aynı anda açık bekleyebilecek askerî teklif ve birlik başına sözleşme sayısını artırır. Askerî bölge kapısı gerekir. Kule Sv.3 gerekir.',
  'class.9': 'Tek motorlu küçük uçak',
  'class.10': 'Dev yolcu uçağı',
  'class.11': 'Dev kargo uçağı',
  'bigOnly.title': 'Kim kullanır',
  'bigOnly.all': 'Herkese açık',
  'bigOnly.big': 'Yalnız büyükler',
  'bigOnly.allHint': 'Her boy uçak kullanabilir; büyükler yine önce buraya gelir.',
  'bigOnly.bigHint':
    'Yalnız büyük uçaklar (geniş gövde, dev yolcu, dev kargo) gelir; küçükler buraya çekmez.',
  'phase.11': 'Çekiliyor',
  'phase.12': 'Parkta',
  'rental.chip': 'Park kiralama',
  'rental.days': '{n} gün park',
  'rental.total': '≈ {amount} park ücreti',
  'rental.paper':
    '{time} gelir, {n} gün uzak park pozisyonunda durur; saatlik ücretle toplam ≈ {amount}. Süre bitince park yerine çekilir, hazırlanıp kalkar.',
  'ledger.aircraftParking': 'Uçak park ücretleri',
  'ledger.tolls': 'Gişe geçişleri',
  'apron.remote': 'Uzak {n}',
  'radio.towOut.1': '{airport} Yer, {cs}, yolcular indi, uzak parka çekilmek için hazırız.',
  'radio.towOut.2': '{cs}, çekmeye onay, uzak park pozisyonuna.',
  'radio.towIn.1':
    '{airport} Yer, {cs}, uzak parkta, kalkış için park yerine çekilmeyi talep ediyoruz.',
  'radio.towIn.2': '{cs}, çekmeye onay, park yeri {stand}.',
  'news.parking': 'Uçak park yerleri ve kiralama',
  'news.parking.text':
    'Yeni Uzak Park Pozisyonu: akşam inen bazı uçaklar gece kalır ve sabah kalkar. Yolcular inince çekici uçağı uzak parka çeker, park yeri boşalır; kalkıştan önce geri çeker. Havayolları birkaç günlük park kiralama da teklif eder. Park eden uçaklar saatlik ücret öder.',
  'news.deicePad': 'Buz çözme pedi',
  'news.deicePad.text':
    'Buzlanmalı havada uçaklar park yerinde değil, piste giderken pedde buzdan arındırılır: park yeri hemen boşalır, daha hızlıdır, ücret yoktur. Sisli havada kule alçak görüş prosedürlerini duyurur.',
  'news.spectator': 'Seyir kamerası ve fotoğraf modu',
  'news.spectator.text':
    'Bir uçağa tıkla: takip, kokpit, kule ve pist kenarı görünümleri. C ile otomatik tur, P ile fotoğraf modu (ışık saati, dondurma, PNG kaydet).',
  'news.radio': 'Kule telsizi',
  'news.radio.text':
    'Pilotlarla kule ve yer kontrol arasındaki konuşmalar gerçek hareketlerden üretilir ve yazılı kayıtta görünür. Ayarlardan kapatılabilir.',
  'news.apronPlan': 'Apron planı',
  'news.apronPlan.text':
    'Uçuşlar penceresinde yeni sekme: park yerleri zaman çizelgesinde, rötar ve çakışmalar renkli, araç filosu doluluğu üstte.',
  'news.trafficAi': 'Daha akıllı trafik',
  'news.trafficAi.text':
    'Araçlar yumuşak hızlanıp frenler, virajlarda yavaşlar, otoyolda sollar. Apron araçları da artık trafik kurallarına uyuyor: gidişte de dönüşte de sağ şeritten gider, kavşaklarda otomobillerle aynı sıraya girer, kavşağın ortasında kalmaz. Oyun menüsü de çok daha hızlı açılır.',
} as const;

export type MessageKey = keyof typeof tr;

export const en: Record<MessageKey, string> = {
  'menu.subtitle': 'Build your airport, run it, grow it together.',
  'build.perTile': ' / tile',
  'menu.defaultPlayer': 'Player',
  'city.istanbul': 'Istanbul',
  'city.london': 'London',
  'city.berlin': 'Berlin',
  'city.dubai': 'Dubai',
  'city.rome': 'Rome',
  'city.paris': 'Paris',
  'city.amsterdam': 'Amsterdam',
  'city.vienna': 'Vienna',
  'city.athens': 'Athens',
  'city.madrid': 'Madrid',
  'city.baku': 'Baku',
  'city.doha': 'Doha',
  'menu.singleSub': 'Build your own airport from scratch',
  'menu.coop': 'Co-op',
  'menu.coopSub': '2–4 players, one airport',
  'menu.settings': 'Settings',
  'menu.settingsSub': 'Graphics and language',
  'menu.gallery': 'Model gallery',
  'menu.gallerySub': 'Buildings, aircraft and weather',
  'menu.academy': 'Academy',
  'menu.academySub': 'Manual, lessons and building tables',
  'menu.singleTitle': 'New airport',
  'menu.coopTitle': 'Co-op',
  'menu.settingsTitle': 'Settings',
  'menu.singleLead':
    'Start with empty land and a tight budget. Raise the tower, build a runway and a terminal, win over airlines and grow your airport.',
  'menu.feature.build': 'Prefab buildings, level-by-level upgrades and land purchases',
  'menu.feature.flights': 'Realistic traffic: runway direction, wind, fog, taxiing and turnarounds',
  'menu.feature.ops': 'Passengers, a ground handling fleet, maintenance and delay analysis',
  'menu.feature.weather': 'Day cycle and changing weather: rain, fog, snow, icing and sandstorms',
  'menu.start': 'Start game',
  'menu.coopLead':
    'Run the same airport together with friends. One player hosts a room, the others join with its code.',
  'menu.host': 'Host room',
  'menu.hostSub': 'Share the code with your friends',
  'menu.join': 'Join',
  'menu.joinSub': 'Enter the 5-letter room code',
  'menu.language': 'Language',
  'board.departures': 'Departures',
  'board.onTime': 'On time',
  'board.boarding': 'Boarding',
  'board.gateClosed': 'Gate closed',
  'board.departed': 'Departed',
  'menu.name': 'Player name',
  'menu.singleplayer': 'Single player',
  'menu.hostCoop': 'Host co-op room',
  'menu.joinCoop': 'Join room',
  'menu.roomCode': 'Room code',
  'menu.relayUrl': 'Server address',
  'menu.connecting': 'Connecting…',
  'menu.coopHint': 'Co-op needs the relay server: pnpm relay',
  'settings.graphics': 'Graphics',
  'graphics.high': 'High',
  'graphics.medium': 'Medium',
  'graphics.low': 'Low',
  'hud.day': 'Day {day}',
  'building.grantSign': 'Grant Sign',
  'desc.grantSign':
    'Condition of the state incentive grant: a large sign saying the airport benefited from it.',
  'ready.road': 'Terminal linked to the motorway by road',
  'req.runway': 'Runway Lv.{level}',
  'reason.requiresGrant': 'Accept the state incentive grant first',
  'toast.grantOffered': 'State incentive grant offered! Flights → Offers',
  'toast.grantFulfilled': 'Grant condition met: the sign is up',
  'toast.grantRepaid': 'The sign was not put up in time: the grant was clawed back',
  'grant.title': 'State Incentive Grant',
  'grant.program': 'Regional Airports Incentive Programme',
  'grant.condition':
    'Condition: within 3 days, put up a large sign at the airport saying it benefited from the state incentive grant.',
  'grant.clawback': 'If the sign is not up in time, the grant is clawed back.',
  'grant.accept': 'Accept',
  'grant.decline': 'Decline',
  'grant.signDue': 'Grant condition: put up the sign',
  'grant.signLeft': 'Time left: {h} h',
  'grant.placeSign': 'Place the sign',
  'tip.7': 'Passengers come by road: link the terminal to the motorway.',
  'hud.budget': 'Budget',
  'hud.todayNet': "Today's net result",
  'hud.speed': 'Game speed',
  'hud.level': 'Lv.{level}',
  'hud.leaveConfirm': 'Sure? Back to the main menu',
  'hud.drawHint': 'drag: 4×4 blocks, joins a nearby road by itself',
  'hud.moveHint': 'Click its new place · R to turn · Esc to cancel',
  'hud.close': 'Close',
  'catalog.title': 'Build',
  'catalog.rotateHint': 'R: rotate · Esc: cancel',
  'ops.subtitle': 'Offers, contracts and the flight board',
  'tip.title': 'Tip:',
  'tip.0': 'Draw taxiways so they touch the long side of the runway and the edge of the stand.',
  'tip.1':
    'In light fog the CAT I ILS of a Lv.3 runway is enough; in thick fog only CAT III (Runway Lv.4) works.',
  'tip.2': 'A Ground Handling Base ends contractor fees, but size its fleet well.',
  'tip.3': 'Click a row on the flight board to see why a flight was late.',
  'tip.4': 'A hangar means fewer defects and maintenance income from every departure.',
  'tip.5': 'Satisfied airlines offer to renew when their contract ends.',
  'tip.6': 'Once the tailwind exceeds 5 knots the tower turns the runway round by itself.',
  'hud.pause': 'Pause',
  'hud.room': 'Room',
  'hud.offline': 'Single player',
  'hud.leave': 'Main menu',
  'hud.ping': '{ms} ms',
  'crews.title': 'Construction crews · {busy}/{total} busy',
  'crews.none': 'Nothing being built: every crew is free.',
  'crews.show': 'Show',
  'crews.free': 'Crews free: {n}',
  'crews.allBusy':
    'Every crew is busy: a new build starts when one finishes. Each Construction Office level brings another crew.',
  'full.title': 'Full Version',
  'full.unlock': 'Unlock with the Full Version',
  'full.reason.building': 'This building comes with the Full Version',
  'full.reason.upgrade': 'This level comes with the Full Version',
  'full.reason.tower': 'Tower level 3 and beyond come with the Full Version',
  'full.reason.junction': 'The slip road comes with the Full Version',
  'full.reason.map': 'The large map comes with the Full Version',
  'full.reason.coop': 'Hosting co-op comes with the Full Version (joining is free)',
  'full.lead':
    'The game is free up to tower level {level}. The Full Version opens everything to keep growing your airport:',
  'full.opens.tower': 'Tower levels 3, 4 and 5 and all they open',
  'full.opens.aircraft': 'Widebodies, jumbo jets and giant freighters',
  'full.opens.city': 'The airport city: a mall, office towers, restaurants',
  'full.opens.military': 'The military zone, fighter jets, a third runway and terminal',
  'full.opens.map': 'The large map (384×384)',
  'full.opens.coop': 'Hosting co-op with your friends',
  'full.once':
    'A one-time purchase: no ads, no subscription. It carries over to your other Android devices with the same Google account.',
  'full.buy': 'Buy',
  'full.buyPrice': 'Buy · {price}',
  'full.restore': 'Restore purchase',
  'full.later': 'Not now',
  'full.thanks': 'Thank you! The Full Version is open.',
  'full.cancelled': 'The purchase was not completed.',
  'full.pending': 'The payment is pending: the Full Version opens by itself once it clears.',
  'full.nothingToRestore': 'No Full Version purchase was found on this Google account.',
  'hud.crews': 'Construction crews',
  'hud.tower': 'Tower',
  'hud.controls': 'WASD pan · Q/E rotate · Wheel zoom · R turn building · Space pause · Esc cancel',
  'hint.start': 'First step: place a Control Tower from the Build menu.',
  'hint.next':
    'Tower ready! Now place a terminal, runway and stands; link them with taxiways and yellow lines.',
  'tool.select': 'Select',
  'tool.land': 'Land',
  'tool.build': 'Build',
  'tool.road': 'Road',
  'tool.taxiway': 'Taxiway',
  'tool.bulldoze': 'Bulldoze',
  'tool.junction': 'Junction',
  'tool.toll': 'Toll plaza',
  'tool.service': 'Service road',
  'news.specialLivery': 'Special liveries',
  'news.specialLivery.text':
    'About one aircraft in thirty comes in its airline’s anniversary colours: gold, retro orange, royal purple or teal. Click it and its flight card says so.',
  'news.vipCarpet': 'A red carpet for VIPs',
  'news.vipCarpet.text':
    'When a VIP’s aircraft is on its stand, a red carpet between brass posts runs out from its front door, with a black limousine waiting at the end.',
  'news.vip': 'VIP passengers',
  'news.vip.text':
    'From tower level 2, now and then someone famous books a flight on the board: a minister, a rock star, a tycoon or a whole football team. You hear an hour ahead; if the flight leaves on time with everyone aboard their office pays a thank-you and the airport is praised. A delay or a cancellation makes the wrong kind of headlines. The flight card carries a VIP stamp.',
  'news.dailyGoals': 'Daily goals',
  'news.dailyGoals.text':
    'Every morning brings three goals sized on your airport: so many departures, passengers, revenue or freight today; on time all day, or no cancellations. They sit a little above yesterday’s figures and grow with the airport; meet one and the reward is paid at once. Follow them in the goals panel.',
  'news.helicopters': 'Helipads and private helicopters',
  'news.helicopters.text':
    'New building: the helipad (tower level 1). Link it to a road and helicopter operators (Boğaz Helikopter, Anadolu Heli VIP, SkyTaxi Rotor) offer contracts of a few flights a day. Helicopters skip the runways and taxiways: straight down onto their pad, a few minutes there, passengers aboard, straight up and away; the passengers come by car to the pad. Click one to open its flight card.',
  'news.flightCard': 'Click an aircraft: its flight card',
  'news.flightCard.text':
    'Click an aircraft and its flight opens on paper: a drawing of the aircraft in its airline’s colours, its status, stand, arrival and departure times, passengers or freight, how far ground handling has got. The card does not cover the game and goes by itself once the aircraft has flown off. To follow it with the camera, use the button on the card.',
  'news.standsEasier': 'Contact stands made easier',
  'news.standsEasier.text':
    'While you place a terminal, the four places its contact stands can go show on the ground, so you can turn it to suit. A contact stand comes with its own service road, laid to the nearest road by itself: you only link the taxiway. A stand or runway in use can no longer be pulled down; it can once the aircraft has gone.',
  'news.smoother': 'Smoother and sturdier',
  'news.smoother.text':
    'A picture layer that fails no longer freezes the game, and if the graphics device is lost the game restarts itself where it was. Busy airports stutter less from aircraft drawing. Drawing a road, the band follows the mouse smoothly instead of square by square. Rain is rarer and shorter; the airport sign stands at the main way in only.',
  'news.worldRanking': 'World ranking: the world score',
  'news.worldRanking.text':
    'The overall ranking now goes by a world score the server works out: your achievement points, your most valuable airport and your best rating added up. Even when everyone has every achievement and five stars it never locks up: the airport’s value decides. Further down the list you also see the players just above and below you, and your world rank is on your profile.',
  'news.winterOps': 'Runways in winter: the plough team',
  'news.winterOps.text':
    'Winter is real now: snow comes and goes (light, moderate, heavy), the ground whitens in patches and then all over, and it lies all winter. Every winter brings a blizzard, forecast six hours ahead. When heavy snow beats the crews a runway closes, and you send the plough team with the button in the alert or over the runway: the trucks drive out from the base, plough the runway in echelon in two passes, throwing the snow off to the sides, and drive home.',
  'news.achievements': 'Achievements with badges',
  'news.achievements.text':
    'When you unlock an achievement its badge bursts onto the screen and fades a few seconds later. There are 11 new achievements: private jet, air base, metro, jet bridges, landmark terminal and a new Infrastructure group. Your profile shows your rank emblem and a showcase of your finest badges.',
  'news.art': 'Billboards, signs and the horizon',
  'news.art.text':
    "Double-sided billboards now line the motorway: lit by their lamps at night, gone when you buy their land. An LED sign over the terminal's entrance changes its message, light-box totems stand on the kerb and the buildings have wayfinding signs; the posters are in the game's language. Far off in the haze lie hills and a city whose lights come on at night. Airlines show their symbols on badges and tail fins, and passengers in the social feed have faces.",
  'news.weather': 'Lightning, snow and winter',
  'news.weather.text':
    'Thunderstorms bring branching lightning that lights up the night for a moment; the thunder follows as late as it takes to arrive. On rainy nights the clouds flicker with distant strikes. In winter snow falls in soft flakes and whitens the grass, roads and treetops, and frost silvers the grass on cold nights. A new season is announced. In photo mode you can try the weathers (storm, snow, snowy winter).',
  'news.lanes': 'Traffic that keeps its lanes',
  'news.lanes.text':
    'Cars and ground vehicles drive in the painted lanes, move over before turning left, and pull up at the kerb with the building on their right, lining up; no U-turns in the middle of the road. Ground vehicles turn in to their stand from the right side and give way to each other.',
  'news.captain': 'The captain and a new tutorial',
  'news.captain.text':
    'The captain welcomes you and takes you through the basics step by step, in a big illustrated card.',
  'toast.season0': 'Spring is here 🌱 The trees green up and demand is back to normal.',
  'toast.season1': 'Summer is here ☀️ Holiday season: full aircraft, and thunderstorms on hot days.',
  'toast.season2': 'Autumn is here 🍂 The leaves turn and demand eases a little.',
  'toast.season3': 'Winter is here ❄️ Expect snow and icing: have de-icing and snow clearing ready.',
  'photo.weather': 'Weather',
  'photo.weather.game': 'The game’s',
  'photo.weather.clear': 'Clear',
  'photo.weather.rain': 'Rain',
  'photo.weather.storm': 'Storm',
  'photo.weather.snow': 'Snow',
  'photo.weather.winter': 'Snowy winter',
  'photo.weather.dust': 'Sandstorm',
  'toast.desertSeason0':
    'Spring is here 🌱 Mild desert days: windy afternoons can bring sandstorms.',
  'toast.desertSeason1':
    'Summer is here 🔥 Scorching heat: afternoons pass 40°C; be ready for sandstorms.',
  'toast.desertSeason2': 'Autumn is here 🍂 The heat starts to ease and demand dips a little.',
  'toast.desertSeason3': 'Winter is here 🌙 Mild days, cold nights: no snow or ice in the desert.',
  'toast.alpineSeason0':
    'Spring is here 🌱 The snow is melting; morning fog often fills the valley.',
  'toast.alpineSeason1':
    'Summer is here ☀️ A cool mountain summer: full aircraft, afternoon thunderstorms.',
  'toast.alpineSeason2':
    'Autumn is here 🍂 The birches turn gold and the first snow settles on the peaks.',
  'toast.alpineSeason3':
    'Winter is here ❄️ A hard mountain winter: deep snow, icing and blizzards. Grow your snow teams and de-icing.',
  'news.graphics': 'Softer light and smart upscaling',
  'news.graphics.text':
    'The lighting is softer: floodlights no longer blow the apron out to white at night, concrete and white paint are their real shades, the sky lights the shade more, shadow edges are soft, and walls darken towards the ground with panel joints. New setting: smart upscaling (like DLSS or FSR 2, on any graphics card): the scene is drawn at a lower resolution and rebuilt into a sharp full image from the frames before; as the scene is now drawn once, frames on High take about 20% less time.',
  'news.contactStands': 'Contact stands and a metro',
  'news.contactStands.text':
    'New building: the contact stand. It sits against a terminal; two fit along its apron face and one at each end, and it snaps to the nearest free place as you put it down. Passengers board by jet bridge, with no bus. A level 2 stand no longer has a bridge: fuel hydrant pits and its own equipment make ground services 25% quicker. Terminal facilities now include a metro station (terminal Lv.3): 20% of passengers come by metro, easing the road, and its entrance appears in front of the terminal.',
  'news.motorwayLink': 'The motorway moves aside, the interchange builds itself',
  'news.motorwayLink.text':
    'The elevated motorway now runs a little south of the road; the road the airport joins stays below as an ordinary road. The first time you connect the airport to it, a link road to the motorway and its exit and entry ramps are built there by themselves; a second way in brings no new ramps. Nothing but roads may go under the viaduct and its ramps.',
  'news.viaduct': 'An elevated motorway',
  'news.viaduct.text':
    'The motorway is now an eight-lane viaduct on piers between two tunnels; through traffic flows on it without stopping. At the airport’s junction, exit and entry ramps each way. Vehicles turn off for the airport because of its flights: about one for every ten passengers; with no flights nobody does. In heavy traffic the processor load is more than halved.',
  'hud.serviceHint':
    'drag: a two-lane service road; ground handling, fire service and airport vehicles use it (quicker), public traffic cannot; across a taxiway or a road it goes under in a tunnel',
  'news.serviceRoads': 'Service roads',
  'news.serviceRoads.text':
    'New tool (9): the service road. Ground vehicles, fuel, catering, the fire service and the airport’s vans prefer it and are quicker on it; public traffic and passengers’ cars never use it. Stands and ground handling bases can be joined by a service road too. The road brush now fills a one-tile strip between a building and the road as well.',
  'hud.junctionHint': 'click a junction: traffic lights, smart lights or a slip road',
  'hud.tollHint':
    'click a road: the plaza spans its whole width; on the way in to a terminal every passenger pays $0.50; click a plaza to remove it',
  'junction.title': 'Junction',
  'junction.kind.0': 'Priority junction',
  'junction.kind.1': 'Traffic lights',
  'junction.kind.2': 'Smart traffic lights',
  'junction.kind.3': 'Slip road',
  'junction.desc.0':
    'First come, first through; turning across the motorway waits for a gap, the longest waiting go first. Enough for light traffic.',
  'junction.desc.1':
    'Each way gets green in turn: turning traffic no longer waits for the motorway. Nearly twice the capacity.',
  'junction.desc.2':
    'Lights with sensors: green goes where the queue is, never to an empty road. Makes the difference at the rush hour.',
  'junction.desc.3':
    'The airport’s traffic leaves the motorway on a lane of its own: nobody waits for anybody, and the motorway’s rush does not touch it. The way in to a big airport.',
  'junction.ways': 'Ways in from the motorway to the terminal: {n}. Each adds its own capacity.',
  'junction.fix.title': 'Ways to ease the way in',
  'junction.fix.slip':
    'Turn this motorway junction into a slip road (tower Lv.{n}): the airport’s traffic leaves on a lane of its own, untouched by the motorway’s rush.',
  'junction.fix.second':
    'Draw a second (or third) road from the motorway to the terminal: every way in is capacity of its own, and the traffic splits.',
  'junction.fix.transit':
    'Build a bus station, a railway station or the metro and link it to the terminal: part of the passengers never use the road.',
  'junction.fix.inner':
    'This junction is inside: if it is the bottleneck, add lights or open a second road that splits the traffic.',
  'junction.cars': '{n} cars/min',
  'junction.here': 'This junction',
  'junction.queue': 'Waiting at its lines now: {n} vehicles',
  'junction.motorway': 'Passing on the motorway: {n} cars/min',
  'junction.rush': 'rush hour',
  'junction.now': 'now {n}',
  'junction.share': 'Capacity left for the airport: {n} cars/min',
  'junction.loadNote':
    'Load: cars of passengers coming for their flights against what the narrowest junction on the way in lets through ({n} cars/min). Motorway traffic cuts that capacity but does not count as load.',
  'junction.current': 'Now',
  'junction.build': 'Build · {cost}',
  'junction.revert': 'Go back to this (free)',
  'junction.tower': 'Needs tower level {n}',
  'junction.road': 'The way in',
  'junction.load': 'Load at the way in: {n}%',
  'junction.waiting': '{n} passengers stuck in traffic',
  'junction.flowing': 'Traffic is flowing',
  'junction.bottleneck': 'This is the narrowest junction on the way to the terminal.',
  'junction.elsewhere': 'Another junction is the bottleneck on the way to the terminal.',
  'junction.none': 'No junction here: click where two roads cross.',
  'toast.roadJam':
    'The way in is jammed: {n} passengers stuck in traffic. Click the junction with the junction tool (8): lights, a slip road, a second way in or public transport.',
  'news.roadJunctions': 'Junctions and traffic lights',
  'news.roadJunctions.text':
    'Passengers now come to the terminal by road: the narrowest junction on the way in sets how many cars a minute get through, and the motorway’s morning and evening rush hours take their share of it. When it jams, passengers are stuck on the road and miss their flight. Set up traffic lights, smart lights or an interchange with the junction tool (8). The road tool joins a building without a road in one click, and ground vehicles no longer lock each other up.',
  'building.tower': 'Control Tower',
  'building.terminal': 'Terminal',
  'building.runway': 'Runway (old)',
  'building.mainRunway': 'Runway',
  'desc.mainRunway':
    'Where the aircraft land and take off; it grows with its levels, so a second runway is only for capacity. Lv.1 a narrow runway: light aircraft, private jets, regional jets (by day). Lv.2 wider: narrow-bodies. Lv.3 runway lights (night flights) and CAT I ILS. Lv.4 approach lights, CAT III ILS (thick fog) and wide-bodies. Lv.5 the widest: every aircraft, jumbos and giant freighters included; can be kept for the big ones. Its ground is 64×6 from the start; join it to a taxiway. It closes while it is upgraded.',
  'building.stand': 'Stand',
  'building.spotterDeck': "Spotters' Deck",
  'desc.spotterDeck':
    'A terrace and café where plane spotters and families watch the departures. In daylight every departure from a runway it can see (within 40 tiles) brings in visitors (a wide-body twice as many, a military jet three times) and gets people talking about the airport. Needs a road.',
  'building.helipad': 'Helipad',
  'desc.helipad':
    'Private helicopters land and take off here; their passengers come by car straight to the pad. Needs a road. Helicopter operators start offering contracts.',
  'building.contactStand': 'Contact Stand',
  'desc.contactStand':
    'A stand set against a terminal: passengers walk on and off by jet bridge, with no bus or stairs; boarding is far quicker and comfort higher. Two fit along a terminal’s apron face and one at each end; never on the road side. Takes up to a narrow-body (wide-bodies go to a large stand). Connect a taxiway, and a road for the ground vehicles. Needs tower Lv.2.',
  'building.parking': 'Car Park',
  'building.fuelDepot': 'Fuel Depot',
  'building.fireStation': 'Fire Station',
  'building.hangar': 'Hangar',
  'building.groundHandling': 'Ground Handling Base',
  'desc.tower':
    "The airport's heart. Its level caps how many buildings you can have, and their levels.",
  'desc.terminal':
    'Passenger capacity and gates. Grows with every level; Lv.2 adds passport control and brings international airlines.',
  'desc.runway':
    'Landings and take-offs. Lv.2 night lighting and CAT I ILS, Lv.3 CAT III ILS for thick fog.',
  'desc.stand':
    'Aircraft parking, passengers by bus and stairs. Lv.2: fuel hydrant pits, fixed ground power and its own equipment; ground services 25% quicker, two sets of stairs board faster. Wide-bodies do not fit: they need a large stand.',
  'desc.parking': 'Landside access and parking income. Adds decks with levels.',
  'desc.fuelDepot': 'Sells fuel to aircraft. One more tank per level.',
  'desc.fireStation': 'Rescue and fire fighting. Required for flights; widebodies need Lv.2.',
  'desc.hangar':
    'Line maintenance: fewer defects, faster repairs and maintenance income from every departure.',
  'desc.groundHandling':
    'Your own ground vehicles: stairs, buses, baggage trains, catering, cleaning and pushback. Each level brings more; Lv.5 and Lv.6 (tower Lv.5) are a hub’s fleet. From tower Lv.4 you may build 3 bases. Without one a contractor works more slowly and charges a fee.',
  'catalog.requires': 'Tower Lv.{level}',
  'catalog.limitReached': 'Limit reached',
  'catalog.hours': '{hours} h',
  'panel.level': 'Level {level} / {max}',
  'panel.constructing': 'Under construction',
  'panel.upgrading': 'Upgrading to Lv.{level}',
  'panel.ready': 'Operational',
  'panel.remaining': '{time} left',
  'panel.next': 'Next level',
  'panel.upgrade': 'Upgrade',
  'panel.demolish': 'Demolish',
  'panel.move': 'Move',
  'panel.moveHint': 'Move the building elsewhere (for 10% of what was spent on it).',
  'panel.confirm': 'Sure? ({amount} refund)',
  'panel.maxLevel': 'Maximum level',
  'time.hm': '{h} h {m} min',
  'plan.cost': 'Cost',
  'hint.service.ok': 'Vehicle access connected',
  'hint.service.warn':
    'Its road leads nowhere: take it to the motorway, a terminal or a service building',
  'hint.service.missing': 'A service road or a road is needed: draw one to the yellow edge',
  'hint.terminal.ok': 'Near a terminal ({n} tiles): passengers come too',
  'hint.terminal.warn':
    'Far from the terminals ({n} tiles): no passengers. Build within {limit} tiles of a terminal',
  'hint.terminal.missing':
    'No terminal: only people from the city shop here. Within {limit} tiles of a terminal it draws passengers too',
  'hint.road.ok': 'Road connected',
  'hint.road.warn': 'The road at its door does not reach the motorway',
  'hint.road.missing': 'Needs a road: draw one to the yellow edge',
  'hint.road.near': 'Nearest linked road {n} tiles {dir}',
  'hint.taxi.ok': 'Taxiway linked to a runway',
  'hint.taxi.warn': 'The taxiway does not reach a runway',
  'hint.taxi.missing': 'Needs a taxiway: aircraft come in over the yellow edge',
  'hint.runway.ok': 'Taxiway links: {n}',
  'hint.runway.warn': 'No taxiway links',
  'hint.runway.missing': 'Join taxiways to the long sides (yellow marks)',
  'compass.n': 'north',
  'compass.e': 'east',
  'compass.s': 'south',
  'compass.w': 'west',
  'plan.refund': 'Refund',
  'reason.invalidCommand': 'Invalid command',
  'reason.outOfBounds': 'Outside the map',
  'reason.tooLarge': 'Too long',
  'reason.invalidLine': 'Draw a straight line',
  'reason.nothingToDo': 'Nothing to do',
  'reason.notJunction': 'There is no junction here',
  'reason.underMotorway': 'Under the motorway viaduct: only roads may go here',
  'reason.needsTerminal':
    'A contact stand must be set against a terminal’s apron face or one of its ends',
  'reason.standsAttached': 'First remove the contact stands set against this terminal',
  'reason.parcelLocked': "You don't own this land yet",
  'reason.alreadyOwned': 'You already own this land',
  'reason.notAdjacent': 'Only parcels next to your land can be bought',
  'reason.occupied': 'Something is in the way',
  'reason.blocked': "These can't cross here",
  'reason.tunnelEnds':
    'A tunnel must come out beyond the taxiway or road: draw the service road on past it',
  'reason.tunnelJunction':
    'A service tunnel cannot pass under a junction: take it under a straight stretch of road',
  'reason.roadTunnelEnds':
    "A road under a taxiway must come out the far side: draw the road on past the taxiway, and the taxiway across the road's whole width",
  'reason.roadTunnelJunction':
    'A road tunnel cannot pass under a junction, nor beside another tunnel or road: take a straight stretch of road under the taxiway on its own',
  'reason.requiresTower': 'Control tower level too low',
  'reason.limitReached': "Can't build more of these (upgrade the tower)",
  'reason.noFreeCrew':
    'All construction crews are busy: try again when one finishes, or add a crew with a Construction Office',
  'reason.maxLevel': 'Already at maximum level',
  'reason.busy': 'Already under construction',
  'reason.unknownBuilding': 'Building not found',
  'reason.unknownOffer': 'The offer is no longer available',
  'reason.insufficientFunds': 'Not enough money',
  'ops.title': 'Airlines and flights',
  'ops.tab.offers': 'Offers',
  'ops.tab.contracts': 'Contracts',
  'ops.tab.flights': 'Flight board',
  'ops.noOffers': 'No offers right now. While the tower operates, a new one may arrive every hour.',
  'ops.poolFull':
    'Every airline that can come here has a deal with you already; new offers only come with:',
  'ops.poolPassports':
    'International airlines: bring the terminal to level {level} (passport control).',
  'ops.poolCargo': 'Freight airlines: build a cargo terminal with a road to it (tower level 2).',
  'ops.poolHelipad': 'Helicopter operators: build a helipad with a road to it.',
  'ops.poolWait': 'When a contract runs out, its airline may make an offer again.',
  'ops.nightNeedsLights':
    'Night flights (22:00–06:00) need runway lights: upgrade the runway to level 3. Until then offers come for 06:00–22:00.',
  'ops.needsTower': 'Build a Control Tower to start receiving offers.',
  'ops.privateOnly':
    'Tower level 1: only private jet operators make offers for now. Passenger airlines come once the tower reaches level 2.',
  'ops.perDay': '{n} flights/day',
  'ops.days': '{n} days',
  'ops.perFlight': '~{amount} per flight',
  'ops.expires': 'expires in {h} h',
  'ops.accept': 'Accept',
  'ops.decline': 'Decline',
  'ops.requires': 'Requires: {what}',
  'ops.noContracts': 'No contracts yet. Accept an airline from the Offers tab.',
  'ops.served': '{n} flights',
  'ops.cancelledCount': '{n} cancelled',
  'ops.daysLeft': '{n} days left',
  'ops.noFlights': 'No flights scheduled.',
  'ops.button': 'Flights',
  'fids.time': 'Time',
  'fids.flight': 'Flight',
  'fids.airline': 'Airline',
  'fids.type': 'Type',
  'fids.status': 'Status',
  'class.1': 'Regional',
  'class.2': 'Narrow-body',
  'class.3': 'Wide-body',
  'class.4': 'Private jet',
  'status.1': 'Scheduled',
  'status.2': 'Holding',
  'status.3': 'Landing',
  'status.4': 'At gate',
  'status.5': 'Departing',
  'status.6': 'Departed',
  'status.7': 'Cancelled',
  'hold.0': '',
  'hold.1': 'No terminal',
  'hold.2': 'No suitable runway',
  'hold.3': 'No free stand',
  'hold.4':
    'No taxiway from the runway to the stand (or no runway exit in this wind direction: connect a taxiway at both ends)',
  'hold.5': 'Runway busy',
  'hold.6': 'Night: runway lights needed (Runway Lv.3)',
  'hold.7': 'Taxiway busy',
  'hold.8': 'Crosswind above limits',
  'wind.title': 'Wind',
  'wind.value': '{deg}° {kt} kt',
  'wind.calm': 'Calm',
  'rwy.inUse': 'Runway in use',
  'rwy.head': 'Headwind {kt} kt',
  'rwy.tail': 'Tailwind {kt} kt',
  'rwy.cross': 'Crosswind {kt} kt',
  'rwy.closedFor': 'Closed by crosswind for: {classes}',
  'rwy.mode': 'Use',
  'rwy.mode.0': 'Mixed',
  'rwy.mode.1': 'Arrivals only',
  'rwy.mode.2': 'Departures only',
  'rwy.movements': 'Aircraft on approach or runway: {n}',
  'rwy.hint':
    'Aircraft land and take off into the wind; once the tailwind exceeds 5 knots the tower turns the runway round. A second runway in another direction keeps the airport open in strong crosswinds.',
  'ops.renewal': 'Renewal',
  'ops.score': 'Airline satisfaction',
  'ops.scoreHint':
    'Delays, missed passengers and cancellations lower it. When a contract ends, an airline at 70% or more offers to renew; above 90% it asks for one more daily flight.',
  'ledger.punctuality': 'On-time departures {pct}% · avg delay {avg} min · {cancelled} cancelled',
  'toast.contractRenewal': '{airline} wants to renew its contract',
  'hold.9': 'No pushback tug free',
  'gse.0': 'Stairs',
  'gse.1': 'Bus',
  'gse.2': 'Baggage train',
  'gse.3': 'Catering truck',
  'gse.4': 'Cleaning van',
  'gse.5': 'Fuel truck',
  'gse.6': 'Pushback tug',
  'gse.7': 'De-icing truck',
  'hold.10':
    'Low visibility (fog or sandstorm): below the runway minimum (CAT III ILS needs Runway Lv.4)',
  'hold.11': 'De-icing',
  'hold.12': 'No fire cover (widebodies need Lv.2)',
  'ready.fire': 'Fire station (required for flights)',
  'sky.0': 'Clear',
  'sky.1': 'Cloudy',
  'sky.2': 'Rain',
  'sky.3': 'Fog',
  'sky.4': 'Snow',
  'wx.title': 'Weather',
  'wx.visibility': 'Visibility {v}',
  'wx.icing': 'Icing: aircraft are de-iced before take-off',
  'rwy.visibility': 'Visibility {v} · runway minimum {min}',
  'rwy.closedFog':
    'Closed by low visibility (fog or sandstorm): a Lv.3 runway has CAT I ILS down to 600 m; worse needs CAT III (Runway Lv.4)',
  'svc.tech': 'Technical repair',
  'svc.deice': 'De-icing',
  'diag.technical': 'Technical defect',
  'ledger.maintenance': 'Maintenance (hangar)',
  'fire.title': 'Rescue and fire fighting',
  'fire.covers': 'Covered aircraft: {classes}',
  'fire.needs': 'Widebodies need fire station Lv.2.',
  'hangar.title': 'Line maintenance',
  'hangar.defects': 'Defect rate {pct}% · repair {m} min',
  'hangar.noHangar': 'Without a hangar, repairs take {m} min with engineers from elsewhere.',
  'hangar.fee': 'Maintenance income per departure: {amount} (narrowbody)',
  'svc.noVehicle': 'waiting for {vehicle}',
  'fleet.busy': 'at work',
  'fleet.idle': 'idle',
  'fleet.title': 'Vehicle fleet',
  'fleet.inUse': '{used} / {total}',
  'fleet.contracted':
    'With no working ground handling base (or hardly any crews), a contractor does baggage, cleaning and catering: 50% slower and paid per aircraft.',
  'fleet.hint':
    'When every vehicle of a kind is busy, the next aircraft waits. Upgrade the base or build a second one.',
  'fleet.fuelHint': 'Fuel trucks belong to the fuel depot; upgrading it adds trucks.',
  'ledger.handling': 'Ground handling contractor',
  'ledger.lost':
    'Minutes lost: inbound {inbound} · arrival {arrival} · vehicles {vehicles} · passengers {passengers} · technical {technical} · departure {departure}',
  'diag.title': 'Delay analysis',
  'diag.delay': '{m} min late',
  'diag.onTime': 'On time',
  'diag.arrival': 'Arrival (holding)',
  'diag.vehicles': 'Waiting for ground vehicles',
  'diag.passengers': 'Late passengers',
  'diag.departure': 'Departure queue (de-icing, runway, taxiway, pushback)',
  'diag.none': 'No time lost.',
  'diag.turnaround': 'Taxiing and turnaround time',
  'diag.minutes': '{m} min',
  'diag.hint': 'Click a flight to see why it was late.',
  'req.runway2': 'Runway Lv.2',
  'req.stand2': 'Stand Lv.2',
  'ledger.today': 'Today',
  'ledger.income': 'Flight income',
  'ledger.upkeep': 'Upkeep',
  'ledger.penalties': 'Penalties',
  'ledger.net': 'Net',
  'ready.title': 'Ready for flights',
  'ready.terminal': 'Terminal',
  'ready.runway': 'Runway',
  'ready.stand': 'Stand',
  'ready.connected': 'Runway and stand linked by a yellow taxi line',
  'ready.standRoad': 'A road to the stand (for ground vehicles)',
  'ready.contract': 'An airline contract (U)',
  'ready.hint':
    "Pave a taxiway (5), then paint its yellow line (6) from the runway's long side to a stand's edge. Aircraft only follow yellow lines.",
  'stand.empty': 'No aircraft on this stand.',
  'stand.departs': 'Departs {time}',
  'svc.deboard': 'Deboarding',
  'svc.unload': 'Baggage unload',
  'svc.fuel': 'Fuelling',
  'svc.clean': 'Cabin cleaning',
  'svc.catering': 'Catering',
  'svc.load': 'Baggage load',
  'svc.board': 'Boarding',
  'svc.waiting': 'queued',
  'svc.minutesLeft': '{m} min',
  'svc.outsideFuel': 'outside supplier (2×)',
  'svc.boarding': '{boarded}/{booked} · ready {ready}',
  'svc.opensAt': 'opens {time}',
  'svc.waitingCabin': 'waiting for cabin',
  'term.capacity': 'Check-in + security',
  'stage.checkIn': 'Check-in and bag drop',
  'stage.security': 'Security',
  'stage.passport': 'Passport (international)',
  'stage.bottleneck': 'Bottleneck',
  'term.perHour': '{n} pax/h',
  'term.queue': 'Passengers queueing',
  'term.wait': 'Average wait',
  'term.minutes': '{n} min',
  'term.los': 'Level of service',
  'term.hint':
    'Passengers pass check-in, security and, on international flights, passports; the slowest stage sets the pace. Add check-in desks or security lanes where the bottleneck is (select the terminal), upgrade it or build a second one. Long queues make passengers miss flights.',
  'los.optimum': 'Optimum',
  'los.suboptimum': 'Sub-optimum',
  'los.under': 'Under-provided',
  'los.closed': 'Closed',
  'hud.rating': 'Airport rating (passenger satisfaction)',
  'fids.pax': 'Pax',
  'ledger.landing': 'Landing fees',
  'ledger.passenger': 'Passenger charges',
  'ledger.retail': 'Shops and food',
  'ledger.fuel': 'Fuel sales',
  'ledger.parking': 'Car park',
  'ledger.stats': '{flights} departures · {pax} passengers · {missed} missed',
  'toast.missed': '{flight}: {n} passengers missed the flight',
  'toast.offer': 'New offer: {airline}',
  'toast.cancelled': '{airline} flight cancelled: {reason}',
  'toast.contractEnded': '{airline} contract ended',
  'sync.overlay': 'A player is joining, sending the map…',
  'toast.desync': '{name} lost sync, resending the map',
  'toast.joined': '{name} joined',
  'toast.left': '{name} left',
  'toast.built': '{building} Lv.{level} complete',
  'error.versionMismatch': 'The server runs a different game version',
  'error.roomNotFound': 'No room with this code',
  'error.roomFull': 'Room is full (max 4 players)',
  'error.badMessage': 'Communication error with the server',
  'error.syncTimeout': 'Timed out loading the map',
  'error.fatal': 'Simulation error: {message}',
  'error.graphicsLost':
    'The graphics device was lost. Join the game again; the world carries on where it was.',
  'toast.graphicsRecovered': 'Graphics restarted; the game carries on where it was.',
  'error.disconnected': 'Disconnected ({reason})',
  'mgmt.button': 'Management',
  'mgmt.title': 'Management',
  'mgmt.subtitle': 'Staff, fees and financing',
  'mgmt.tab.staff': 'Staff',
  'mgmt.tab.finance': 'Finance',
  'staff.lead':
    "Each team's needs come from its buildings. With automatic staffing the airport hires exactly what it needs; cut staff by hand to save on wages, at the cost of service.",
  'staff.role.terminal': 'Terminal staff',
  'staff.role.ground': 'Ground crews',
  'staff.role.fire': 'Firefighters',
  'staff.role.atc': 'Air traffic controllers',
  'staff.desc.terminal': 'Check-in and security',
  'staff.desc.ground': 'Drivers of the ground handling vehicles',
  'staff.desc.fire': 'Rescue and fire fighting',
  'staff.desc.atc': 'Landing and take-off clearances',
  'staff.auto': 'Auto',
  'staff.autoHint': 'Automatic staffing: hires and lets go as needs change',
  'staff.idle': 'No building for this team yet',
  'staff.full': 'Fully staffed',
  'staff.effect.terminal': 'Check-in capacity {pct}%: queues grow',
  'staff.effect.ground': 'Only ~{pct}% of the vehicles have drivers',
  'staff.effect.contractor': 'Too few crews: the contractor takes over (slower, for a fee)',
  'staff.effect.fire': 'Fire category {cat}/{level}',
  'staff.effect.fireNone': 'No fire cover: no flights can operate',
  'staff.effect.atc': 'Runway separation +{s} s',
  'staff.effect.towerClosed': 'Tower closed: no landings or take-offs',
  'staff.wage': '{amount}/day',
  'staff.total': '{n} employees',
  'staff.perDay': 'Wages: {amount}/day',
  'ledger.wages': 'Wages',
  'ledger.loans': 'Loan instalments',
  'hold.13': 'No controllers in the tower',
  'reason.unknownLoan': 'No such loan',
  'finance.statement': 'Income statement',
  'finance.today': 'Today',
  'finance.yesterday': 'Yesterday',
  'finance.income': 'Total income',
  'finance.costs': 'Total costs',
  'finance.fees': 'Airport fees',
  'finance.feesLead':
    'Percent of the standard tariff. Higher fees earn more per flight, but airlines make fewer offers and satisfaction drops.',
  'finance.landingFee': 'Landing fee',
  'finance.paxFee': 'Passenger service charge',
  'finance.effect.offers': 'Airline offer rate ×{x}',
  'finance.effect.airlines': 'Airline satisfaction −{n} points per flight',
  'finance.effect.airlinesOk': 'Airlines are happy with the fees',
  'finance.effect.passengers': 'Passenger satisfaction −{n} points',
  'finance.effect.passengersOk': 'Passengers do not mind the charge',
  'finance.apply': 'Apply',
  'finance.standard': 'Standard tariff',
  'finance.loans': 'Bank loans',
  'finance.loansLead':
    '{pct}% interest, repaid in {days} daily instalments. Paying off early waives the remaining interest.',
  'finance.loanLeft': '{amount} left · {days} days',
  'finance.instalment': 'Instalment {amount}/day',
  'finance.repay': 'Total {amount}',
  'finance.payoff': 'Pay off: {amount}',
  'finance.loansFull': 'At most {n} loans at a time.',
  'load.connecting': 'Connecting to the server',
  'load.starting': 'Starting the simulation',
  'load.stage.1': 'Loading the world',
  'load.stage.2': 'Preparing land, buildings and traffic',
  'load.stage.3': 'Compiling graphics',
  'load.stage.4': 'Ready',
  'load.firstTime': 'The first start can take a little longer.',
  'load.nextTip': 'Next tip',
  'tip.8':
    'In Management (M) you can take teams off automatic staffing to save on wages, at the cost of service.',
  'tip.9':
    'With too few controllers in the tower, movements are spaced further apart and capacity drops.',
  'tip.10': 'Short of cash? Take a bank loan; paying it off early waives the remaining interest.',
  'tip.11': 'Higher fees earn more per flight, but airlines make fewer offers.',
  'tip.12': 'Airlines start with regional jets; narrowbodies need Runway Lv.2, widebodies Lv.4.',
  'tip.13': 'If you take the state grant, put up the grant sign within 3 days.',
  'tip.14':
    'A contact stand sits against the terminal: passengers board by jet bridge, far quicker and more comfortable than by bus.',
  'tip.15':
    'In snow and freezing rain aircraft are de-iced before take-off; your own de-icing truck is faster.',
  'menu.continue': 'Continue',
  'menu.saves': 'Saved games',
  'menu.savesSub': 'Load, back up, import',
  'menu.savesTitle': 'Saved games',
  'save.title': 'Save game',
  'save.subtitle': 'Kept on the server, in your account',
  'save.name': 'Save name',
  'save.defaultName': 'My airport · Day {day}',
  'save.autoName': 'Autosave',
  'save.auto': 'Auto',
  'save.overwriteHint': 'Pick a save to overwrite it:',
  'save.overwrite': 'Overwrite',
  'save.saveNew': 'Save',
  'save.cancel': 'Cancel',
  'save.saved': 'Game saved: {name}',
  'save.failed': 'The game could not be saved',
  'save.saving': 'Saving…',
  'save.leaveHint': 'The game is saved automatically on the way out.',
  'save.lead':
    'Saves are kept on the server, in your account: they are there whichever device you sign in from, and still open after the game is updated. Single-player and co-op games also save themselves every 5 minutes and when you leave.',
  'save.none': 'No saved games yet. Save during a game from the settings menu or with Ctrl+S.',
  'save.load': 'Load',
  'save.host': 'Host co-op',
  'save.hostHint': 'Open a co-op room from this save; friends join with the room code',
  'save.export': 'Download as a file (backup)',
  'save.delete': 'Delete',
  'save.deleteConfirm': 'Delete it?',
  'save.import': 'Import from file',
  'save.backupHint':
    'Download saves as .am27 files to back them up, and import them again from a file.',
  'save.importError': 'This file is not an Airport Manager 2027 save.',
  'save.loadError': 'The save could not be opened.',
  'save.storageError': 'The server cannot be reached; saves cannot be listed right now.',
  'save.olderVersion': 'saved with version {v}',
  'save.newerVersion': 'saved by a newer version of the game',
  'hold.14': 'Runway closed for works',
  'panel.runwayWorks':
    'The upgrade takes {hours} h and closes the runway meanwhile: no landings or take-offs.',
  'panel.standWorks': 'The upgrade takes {hours} h; the stand takes no new aircraft meanwhile.',
  'panel.closureFlights':
    '{n} flights were due to land or take off in those hours: they wait and are cancelled after two hours (penalties and the airlines’ trust). Pick quiet hours.',
  'panel.closureQuiet': 'No flights are due in those hours: a good moment to upgrade.',
  'panel.runwayClosed': 'Runway closed for works: no landings or take-offs, flights are held.',
  'panel.standClosed': 'Stand closed for works: takes no new aircraft.',
  'panel.upgradeConfirm': 'Close and upgrade',
  'toast.runwayClosed': 'Runway closed for works: no landings, flights are held',
  'toast.runwayOpen': 'The runway is open again',
  'tool.taxiLine': 'Taxi line',
  'hud.taxiwayHint':
    'drag: 4×4 blocks, joins the runway or stand by itself · Shift+drag: area (apron)',
  'hud.taxiLineHint':
    'drag: paint the yellow line · Shift+drag: erase · aircraft only follow yellow lines',
  'hold.15': 'No vehicle access to the stand (ground vehicles cannot reach it)',
  'reason.tooLargeArea': 'Area too large',
  'issue.road': 'No road: link this building to a road that leads to the motorway.',
  'issue.highway':
    "Road not linked to the motorway: this building's road never reaches it. Extend it to the motorway.",
  'issue.highwayService':
    "Its road leads nowhere: take this building's road to the motorway, a terminal, or the ground handling, fuel, catering, fire or hangar building.",
  'issue.roadStand':
    'No vehicle access: link a service road (or a road) to this stand. It is enough for it to reach the motorway, a terminal, or the ground handling, fuel, catering, fire or hangar building.',
  'issue.roadService':
    'No vehicle access: link a service road (or a road) to this building. It is enough for it to reach the motorway, a terminal or another airside building.',
  'issue.taxi':
    'No taxi line: paint a yellow line from the runway to here; aircraft only reach a parking place by taxiway.',
  'issue.taxiRunway': "No taxi line: paint a yellow line touching the runway's long side.",
  'issue.title': 'Missing connection',
  'menu.airportName': 'Airport name',
  'menu.airportNameRandom': 'Suggest another name',
  'hud.rename': 'Rename the airport',
  'hud.unnamed': 'Unnamed airport',
  'building.transitHub': 'Taxi & Bus Station',
  'desc.transitHub':
    'Built on a road within 30 tiles of a terminal, passengers arrive by taxi and bus: a concession on every passenger, and happier passengers. Lv.2 adds bays.',
  'ledger.transit': 'Taxi and bus concession',
  'ops.review': 'Review contract',
  'ops.terminate': 'Terminate',
  'toast.contractSuspended': '{airline} suspended its contract',
  'capacity.title': 'Capacity warning',
  'capacity.short': 'May exceed your capacity',
  'capacity.stands':
    'Around {hour}, {need} aircraft will be on the ground at once; you have {have} suitable stands.',
  'capacity.runway':
    'At {hour} there are {need} landings and take-offs; your runways handle about {have} an hour.',
  'capacity.terminal':
    'At {hour}, {need} passengers check in; your terminal handles {have} an hour.',
  'capacity.choice': 'Expect delays, cancellations and unhappy passengers. Your call.',
  'paper.date': 'day {day}',
  'paper.manager': 'Airport Manager',
  'paper.forAirline': 'For the airline',
  'paper.forAirport': 'For the airport',
  'paper.agreement': 'Ground Handling and Slot Agreement',
  'paper.agreementLead':
    '{airline} offers to fly scheduled services at your airport for {days} days on these terms.',
  'paper.aircraft': 'Aircraft',
  'paper.seats': '{n} seats',
  'paper.schedule': 'Schedule',
  'paper.term': 'Term',
  'paper.turnaround': 'Turnaround time',
  'paper.minutes': '{m} minutes',
  'paper.revenue': 'Expected revenue per flight',
  'paper.perWeek': '{amount} a week',
  'paper.perTerm': '{amount} over {days} days',
  'paper.requirements': 'Requirements',
  'paper.fire': 'fire category {level}',
  'paper.termCancel': 'The airport pays {amount} for every flight it cannot handle.',
  'paper.termSuspend':
    'After {n} flights in a row are not handled, the airline suspends the contract.',
  'paper.termExit':
    'If the airport ends the contract early, it pays {pct}% of the remaining flights’ revenue.',
  'paper.termRenew': 'A satisfied airline may offer to renew at the end of the term.',
  'paper.sign': 'Sign',
  'paper.signing': 'Signing…',
  'paper.notNow': 'Not now',
  'paper.stampSigned': 'APPROVED',
  'paper.termination': 'Notice of Termination',
  'paper.terminationLead':
    'The airport ends its contract with {airline} before the end of its term.',
  'paper.served': 'Flights served',
  'paper.fee': 'Termination fee',
  'paper.terminationNote':
    'The fee is {pct}% of the expected revenue of the remaining flights, due at once. Flights not yet landed are cancelled.',
  'paper.terminate': 'Terminate and pay',
  'paper.keep': 'Keep it',
  'paper.stampTerminated': 'TERMINATED',
  'paper.suspension': 'Suspension of Contract',
  'paper.suspensionLead':
    '{airline} has suspended its contract with your airport with immediate effect.',
  'paper.reasonCancellations':
    'Reason: {n} of our flights in a row could not be handled by your airport and were cancelled.',
  'paper.reasonScore':
    'Reason: our satisfaction with punctuality and service has fallen to an unacceptable level.',
  'paper.suspensionNote': 'Our pending flights are cancelled. This harms the airport’s reputation.',
  'paper.stampSuspended': 'SUSPENDED',
  'paper.understood': 'Understood',
  'social.button': 'Social',
  'social.title': 'Kanat',
  'social.subtitle': 'What passengers say about your airport',
  'social.tab.feed': 'Feed',
  'social.tab.ratings': 'Ratings',
  'social.mood.crisis': 'Social media crisis!',
  'social.mood.viral': 'Praise pouring in',
  'social.mood.calm': 'All quiet',
  'social.moodHint': 'In a crisis airlines stay away; praise brings new offers.',
  'social.trending': 'Trending:',
  'social.empty': 'No posts yet. Passengers start posting once flights run.',
  'social.official': 'Verified account',
  'social.overallHint': 'Overall rating: the weighted mean of the categories',
  'rating.punctuality': 'Punctuality',
  'rating.waiting': 'Waiting',
  'rating.comfort': 'Comfort',
  'rating.prices': 'Prices',
  'rating.reliability': 'Reliability',
  'rating.punctuality.tip': 'Lowered by delays',
  'rating.waiting.tip': 'Check-in and security queues',
  'rating.comfort.tip': 'Jet bridges, buses, the taxi rank',
  'rating.prices.tip': 'Passenger service charge',
  'rating.reliability.tip': 'Cancellations and missed flights',
  'toast.buzz.crisis': 'Social media crisis! Passengers are turning on the airport',
  'toast.buzz.viral': 'Your airport is getting praise online',
  'catalog.cat.operations': 'Operations',
  'catalog.cat.airside': 'Airside',
  'catalog.cat.passengers': 'Passengers & landside',
  'catalog.cat.city': 'Airport city',
  'catalog.cat.military': 'Military',
  'catalog.cat.other': 'Other',
  'catalog.level': 'Lv.{level}',
  'catalog.needs.road': 'A road to the motorway',
  'catalog.needs.service':
    'A service road or a road reaching the motorway, a terminal or a service building',
  'catalog.needs.militaryGate': 'Needed for any contract with the ministry (tower level 3)',
  'catalog.needs.fighters':
    'Fighters need all three: a shelter, the operations centre and the munitions store (tower level 4)',
  'catalog.needs.transports': 'Airlifters and drones park here (tower level 4)',
  'catalog.needs.airDefence': 'Not required: raises the ministry’s payments',
  'catalog.needs.terminalFace': 'Against a terminal, on any face but the road side',
  'catalog.needs.taxiLine': 'A yellow taxi line to the runway',
  'catalog.needs.nearTerminal': 'Within 30 tiles of a terminal',
  'catalog.needs.fire': 'A fire station for flights',
  'touch.place': 'Place',
  'touch.rotate': 'Rotate',
  'touch.buy': 'Buy',
  'touch.build': 'Build',
  'touch.remove': 'Remove',
  'touch.catalog': 'Catalogue',
  'touch.checking': 'Checking…',
  'touch.again': 'Tap the map to place another',
  'touch.drawHint': 'draw with one finger · drag its ends to adjust · ✓ to build',
  'touch.tapHint': 'tap the map · ✓ to confirm',
  'touch.bulldozeHint': 'drag over the roads to remove · ✓ to remove them',
  'touch.moveHint': 'carry the building with your finger, ✓ to put it down',
  'touch.junctionHint': 'tap a junction: traffic lights, smart lights or a slip road',
  'touch.area': 'Pave an area',
  'touch.erase': 'Eraser',
  'touch.controls':
    'One finger pans · two fingers zoom and rotate · two fingers up/down tilt · double tap zooms in',
  'touch.info': 'Info',
  'hud.status': 'The airport’s status',
  'phone.airport': 'Airport',
  'legal.title': 'About and legal',
  'legal.about': 'About',
  'legal.privacy': 'Privacy Policy',
  'legal.terms': 'Terms of Use',
  'legal.licences': 'Licences',
  'legal.version': 'Version {version}',
  'legal.publisher': 'Publisher',
  'legal.contact': 'Contact',
  'legal.website': 'Website',
  'legal.updated': 'Last updated: {date}',
  'legal.aboutText':
    'Write for questions, ideas, bug reports and any request about your personal data. The game has no advertising, no tracking and no in-game purchases.',
  'legal.models': 'Third-party 3D models',
  'legal.modelsText':
    'These models are used under their makers’ licences and were changed for the game (scale, parts, paint). No real airline or manufacturer names appear in the game.',
  'legal.software': 'Open-source software',
  'auth.agree': 'I am over {age}; I have read and accept the Terms of Use and the Privacy Policy.',
  'menu.legal': 'About and legal',
  'menu.legalSub': 'Privacy, terms, licences',
  'install.title': 'Play full screen',
  'install.how':
    'In Safari tap Share (the square with an arrow) and choose "Add to Home Screen". From the home screen the game opens with its own icon, full screen, without the address bar.',
  'phone.rating': 'Rating',
  'phone.weather': 'Weather',
  'phone.noiseOn': 'Show the noise map',
  'phone.noiseOff': 'Hide the noise map',
  'phone.camera': 'Camera',
  'phone.watch': 'Watch the aircraft (spectator camera)',
  'phone.roads': 'Roads',
  'phone.edit': 'Edit',
  'issue.connect': 'Connect the road',
  'lesson.waitTower':
    'This building opens once tower Lv.{level} is built: speed the game up and wait for the tower.',
  'issue.connectNone': 'No road near enough to join: draw it yourself.',
  'hud.fullscreen': 'Full screen',
  'hud.fullscreenOff': 'Leave full screen',
  'hud.rotatePhone': 'Turn your device on its side: the game is played in landscape.',
  'hold.16': 'Runway inspection after an emergency',
  'toast.emergency.1': '{airline}: bird strike! Emergency landing, fire crews on the runway',
  'toast.emergency.2': '{airline}: engine failure! Emergency landing, fire crews on their way',
  'toast.emergency.3': '{airline}: medical emergency on board, an ambulance heads to the stand',
  'toast.emergency.cleared': 'The runway has been inspected and is open again',
  'goals.tutorial': 'First steps',
  'goals.title': 'Goals',
  'toast.goal': 'Goal reached: {goal} (+{amount})',
  'toast.goalNoReward': 'Goal reached: {goal}',
  'ledger.rewards': 'Goal rewards',
  'goal.tower': 'Build the control tower',
  'goal.tower.hint': 'Build (3) → Operations → Control Tower. Pick a spot; R rotates.',
  'goal.runway': 'Build the runway',
  'goal.runway.hint': 'Build → Airside → Runway. A long building: fit it across your land.',
  'goal.terminal': 'Build the terminal',
  'goal.terminal.hint':
    'Build → Passengers & landside → Terminal. Close to the motorway keeps the road short.',
  'goal.stand': 'Build a stand',
  'goal.stand.hint': 'Build → Airside → Stand. Aircraft park and get serviced here.',
  'goal.fire': 'Build a fire station',
  'goal.fire.hint': 'Build → Operations → Fire Station. No aircraft lands without one.',
  'goal.roadAccess': 'Link the terminal to the motorway',
  'goal.roadAccess.hint':
    'Draw a Road (4) from the terminal to the motorway at the bottom. Passengers come by road.',
  'goal.standRoad': 'Bring a road to the stand',
  'goal.standRoad.hint':
    'Make a road touch one edge of the stand and join the road network: ground vehicles drive there.',
  'goal.taxiLine': 'Link runway and stand with a yellow line',
  'goal.taxiLine.hint':
    'Pave a Taxiway (5), then paint a yellow line with Taxi line (6) from the runway’s long side to the stand’s edge.',
  'goal.contract': 'Sign the first airline contract',
  'goal.contract.hint': 'Flights (U) → Offers → Review contract → Sign.',
  'goal.firstFlight': 'Handle the first flight',
  'goal.firstFlight.hint':
    'Speed up and watch: it lands, comes to the stand, is serviced and leaves.',
  'goal.flights10': 'Handle 10 flights',
  'goal.flights10.hint': 'Sign more contracts; mind the capacity warnings.',
  'goal.handling': 'Build a Ground Handling Base',
  'goal.handling.hint':
    'Your own fleet is quicker than the contractor and free. Link it to the roads.',
  'goal.rating': 'Reach a 3.5-star rating',
  'goal.rating.hint': 'Social (K) → Ratings: see which category is low.',
  'goal.runway2': 'Upgrade the runway to Lv.3 (lights)',
  'goal.runway2.hint':
    'Runway lights and a CAT I ILS open night flights and landings in thin fog. It closes during the works!',
  'goal.narrowbody': 'Handle the first narrowbody',
  'goal.narrowbody.hint': 'With a Lv.2 runway airlines offer narrowbodies.',
  'goal.flights50': 'Handle 50 flights',
  'goal.flights50.hint': 'Keep growing: balance stands, terminal and staff.',
  'goal.transit': 'Build a taxi and bus station',
  'goal.transit.hint':
    'Within 30 tiles of the terminal, on a road: extra income and happier passengers.',
  'goal.terminal3': 'Upgrade the terminal to Lv.3',
  'goal.terminal3.hint': 'A bigger terminal means faster check-in and more shop income.',
  'goal.widebody': 'Handle the first widebody',
  'goal.widebody.hint': 'Needs a Lv.4 runway and a Lv.2 fire station.',
  'goal.flights200': 'Handle 200 flights',
  'goal.flights200.hint': 'You are now one of the region’s major airports.',
  'goal.millionaire': '$1,000,000 in the bank',
  'goal.millionaire.hint': 'Watch your costs: Management (M) → Finance.',
  'goal.rating5': 'Reach a 4.5-star rating',
  'goal.rating5.hint': 'Punctual, no queues, comfortable and fairly priced.',
  'settings.volume': 'Sound',
  'settings.soundMix': 'Sound channels',
  'settings.mixEngines': 'Aircraft',
  'settings.mixWorld': 'World around',
  'settings.mixInterface': 'Interface',
  'finance.history': 'Recent days',
  'finance.historyEmpty': 'After a few days the income, cost and flight charts appear here.',
  'finance.flights': 'Flights',
  'building.cargoTerminal': 'Cargo Terminal',
  'desc.cargoTerminal':
    'Brings freight airlines: windowless freighters, mostly at night, paying a handling charge per tonne. Higher levels load faster and charge more. Needs a road for the trucks.',
  'cargo.chip': 'Cargo',
  'paper.freight': 'about {t} tonnes of freight',
  'ledger.cargo': 'Cargo handling',
  'goal.freight': 'Handle the first freight flight',
  'goal.freight.hint':
    'With tower Lv.2 build a Cargo Terminal on a road: freight airlines start making offers.',
  'staff.shiftLead':
    'At night (22:00–06:00) each team works a full, half or no shift; night hours pay 25% extra. Your contracts have {n} landings at night.',
  'staff.night': 'Night shift',
  'staff.night.100': 'Full',
  'staff.night.50': 'Half',
  'staff.night.0': 'None',
  'menu.startKind': 'Start with',
  'menu.start.empty': 'Empty land',
  'menu.start.emptySub': 'Build everything from scratch',
  'menu.start.demo': 'Ready-made airport',
  'menu.start.demoSub': 'Runway, terminal, 5 stands and the first contracts in place',
  'diag.inbound': 'Late from origin',
  'board.expected': 'Expected {time}',
  'ledger.noise': 'Noise fines',
  'noise.quota': 'Night noise quota: {used}/{quota} points',
  'noise.title': 'Night noise',
  'noise.parts': 'Quota: base {base} · tower +{tower} · sound insulation +{homes}',
  'noise.insulate': 'Insulate homes {step}/{of} (+{points} points) · {cost}',
  'noise.insulationTower': 'The next insulation step needs tower level {level}.',
  'noise.insulationDone': 'Sound insulation programme complete.',
  'noise.help':
    'Landings and take-offs between 22:00 and 06:00 count points; each point over the quota brings a fine and bad press. A higher tower raises the quota; insulating the homes round the airport raises it for good.',
  'toast.noise': 'Night noise quota exceeded: {amount} fine, residents are complaining',
  'capacity.noise':
    'Night flights add up to ~{need} noise points a night against a quota of {have}: every point over is fined and draws complaints.',
  'building.hotel': 'Hotel',
  'building.cafe': 'Café',
  'desc.cafe':
    'A little café with a parasol terrace. Near a terminal (40 tiles) it sells to passengers, anywhere to people from the city and office workers; the airport takes a cut of every sale. Shops beside it, a park and a mall bring more customers; somewhere to eat near a terminal makes passengers more comfortable. Connect it by road.',
  'building.restaurant': 'Restaurant',
  'desc.restaurant':
    'A restaurant with a pergola terrace: fewer customers, but they spend more. Office workers flock in at lunchtime; near a terminal passengers come too. It does better beside cafés and a mall. Connect it by road. Needs Tower Lv.2.',
  'building.mall': 'Shopping Mall',
  'desc.mall':
    'A big shopping centre with a glass atrium and its car park. It draws the most visitors from the city; passengers come from up to 80 tiles away. It brings customers to the cafés and restaurants around it (24 tiles). Lv.3 adds a cinema and a rooftop food court. Connect it by road. Needs Tower Lv.3.',
  'building.fuelStation': 'Fuel Station',
  'desc.fuelStation':
    'A filling station with its canopy, pumps and shop: the cars bringing passengers to the terminals fill up, and people from the city. Put it on the road to the terminal. Lv.2: a third pump island, a car wash and electric chargers. Connect it by road.',
  'building.officePark': 'Office Tower',
  'desc.officePark':
    'A glass office tower: its tenants pay rent every day, and the better the airport is rated the fuller it is and the more it pays. 120 workers a level; they go to the cafés in the morning and afternoon and to the restaurants at noon. Lv.3 has a helipad on the roof. Connect it by road. Needs Tower Lv.3.',
  'building.cityPark': 'Park',
  'desc.cityPark':
    'A park with a fountain, trees and benches: it earns nothing itself, but makes every business within 20 tiles more attractive (+10% a level). Lv.2: a playground, flower beds and a pond. Needs no road.',
  'city.title': 'Airport city',
  'city.customers': 'This hour {n}/{of} customers',
  'city.attraction': 'Draw {pct}%: park +{park}, shops around +{street}, mall +{mall}',
  'city.nearTerminal': 'Near a terminal: passengers come too.',
  'city.farTerminal':
    'Far from the terminals: no passengers, only people from the city. Build it near a terminal.',
  'city.full': 'Full: upgrade it to serve more customers.',
  'city.closed': 'Not connected to the motorway by road: no customers.',
  'city.office':
    '{workers} workers · rent {rent} a day ({occupancy}% let, more as the rating rises)',
  'city.park': 'Every business within {reach} tiles draws {bonus}% more customers a level.',
  'city.today': 'The whole city today: {sales} in sales, {customers} customers, {rent} rent',
  'desc.hotel':
    'Passengers on early flights and airline crews stay the night: room revenue every night and a better comfort rating. Higher levels have more rooms at higher rates. Needs a road.',
  'ledger.commerce': 'City sales',
  'ledger.rent': 'Office rent',
  'ledger.hotel': 'Hotel',
  'ledger.transfers':
    'Transfers: {n} passengers connected · {missed} missed (compensation under penalties)',
  'goal.hub': '100 transfer passengers in a day',
  'goal.hub.hint':
    'Two or more passenger routes bring connections; more routes, more of them. Bunch arrivals an hour before departures.',
  'weekday.0': 'Mon',
  'weekday.1': 'Tue',
  'weekday.2': 'Wed',
  'weekday.3': 'Thu',
  'weekday.4': 'Fri',
  'weekday.5': 'Sat',
  'weekday.6': 'Sun',
  'weekday.long.0': 'Monday',
  'weekday.long.1': 'Tuesday',
  'weekday.long.2': 'Wednesday',
  'weekday.long.3': 'Thursday',
  'weekday.long.4': 'Friday',
  'weekday.long.5': 'Saturday',
  'weekday.long.6': 'Sunday',
  'season.0': 'Spring: normal demand',
  'season.1': 'Summer: holiday season, full flights and more offers',
  'season.2': 'Autumn: a little quieter',
  'season.3': 'Winter: quiet season, snow and icing',
  'hold.17': 'Runway closed by snow',
  'wx.runwaySnow': 'Snow on the runway {pct}%',
  'wx.snowClosed': 'Snow on the runway {pct}%: a runway is closed by snow',
  'toast.dustStarted':
    'A sandstorm has begun 💨 Visibility is down: more go-arounds, slower apron work.',
  'toast.dustEnded': 'The sandstorm has passed; visibility is clearing.',
  'toast.snowDeep':
    'Snow is piling up on runway {runway} faster than the crews can clear it. You can send the ploughs now.',
  'toast.snowClosed':
    'Runway {runway} is closed by snow! Aircraft cannot land: send the snow ploughs.',
  'toast.snowOverdue':
    'Runway {runway} had been shut for 12 hours: the crews went out on their own.',
  'toast.snowCleared': 'Runway {runway} is clear and open again.',
  'toast.ploughsOut': 'Plough team on its way: {n} vehicles to runway {runway}.',
  'toast.blizzardWarning':
    'Met office warning: a blizzard is expected within 6 hours. Runways may close; have the plough team ready.',
  'toast.blizzardStarted':
    'The blizzard has begun: visibility is very low and snow is piling up fast on the runways.',
  'toast.blizzardEnded': 'The blizzard is over.',
  'snow.closed': 'Runway {runway} closed by snow',
  'snow.holding': '{flight} cannot land · {n} aircraft holding',
  'snow.waiting': 'Flights cannot use this runway',
  'snow.dispatch': 'Send the snow ploughs',
  'snow.dispatchContractor': 'Call the contractor ({cost})',
  'snow.dispatchHint':
    'The team drives out from the ground handling base and clears the runway in two passes. Without a base the contractor comes in from the road, later.',
  'snow.enRoute': 'Plough team on its way · {n} vehicles · ~{min} min',
  'snow.pass': 'Clearing the runway · pass {pass} · {pct}%',
  'snow.returning': 'Runway clear · team driving back',
  'snow.markerDeep': 'Snow piling up {pct}%',
  'snow.markerClosed': 'CLOSED · snow {pct}%',
  'snow.blizzardSoon': 'Blizzard coming (~{h} h): runways may close',
  'snow.blizzardNow': 'Blizzard under way',
  'snowfall.1': 'Light snow',
  'snowfall.2': 'Moderate snow',
  'snowfall.3': 'Heavy snow',
  'snowfall.4': 'Blizzard',
  'rwy.snow': 'Snow on the runway',
  'rwy.snowClear': 'Runway clear',
  'intl.chip': 'International',
  'paper.international':
    'International service: 50% higher passenger charge and 60% more shopping; passport control makes check-in slower.',
  'goal.international': 'Sign the first international contract',
  'goal.international.hint':
    'Upgrade a terminal to Lv.2 (passport control): international airlines start making offers.',
  'ledger.overdraft': 'Overdraft interest',
  'toast.inRed':
    'You are in the red: the overdraft costs 0.6% a day and airlines make fewer offers. Take a loan or cut costs.',
  'mgmt.tab.airlines': 'Airlines',
  'airlines.lead':
    '{n} of {total} airlines fly here. Satisfaction follows punctuality and cancellations; a low score can suspend a contract, a high one adds flights on renewal.',
  'airlines.kind.domestic': 'Domestic',
  'airlines.kind.intl': 'International',
  'airlines.kind.cargo': 'Cargo',
  'airlines.flying':
    '{n} flights a day · {served} flown, {cancelled} cancelled · {revenue} revenue',
  'airlines.offer': 'Has an offer on the table',
  'airlines.none': 'Not interested right now; your rating and fees set how often airlines call',
  'airlines.needs.passports': 'Waiting for passport control (Terminal Lv.2)',
  'airlines.needs.cargo': 'Waiting for a cargo terminal',
  'airlines.score': 'Satisfaction',
  'facility.title': 'Terminal facilities',
  'facility.checkIn': 'Extra check-in desks',
  'facility.security': 'Extra security lane',
  'facility.lounge': 'VIP lounge',
  'facility.shops': 'Duty-free shop',
  'facility.checkIn.effect': 'Check-in and bag drop stage +35%',
  'facility.security.effect': 'Security stage +45%',
  'facility.lounge.effect': 'Better comfort rating, lounge revenue from every passenger',
  'facility.shops.effect': 'Retail revenue +25%',
  'facility.metro': 'Metro station',
  'facility.metro.effect':
    '20% of passengers come by metro (less road and junction load), better comfort and satisfaction, a share of every fare',
  'facility.needsLevel': 'Needs terminal Lv.{level}',
  'reason.requiresLevel': 'Building level too low',
  'chat.placeholder': 'Type a message, Enter to send',
  'chat.open': 'Chat (Enter)',
  'menu.mapTheme': 'Landscape',
  'menu.mapTheme.0': 'Green Valley',
  'menu.mapTheme.0.sub': 'Mild climate, four seasons',
  'menu.mapTheme.1': 'Desert',
  'menu.mapTheme.1.sub': 'Scorching summers, sandstorms, oases',
  'menu.mapTheme.2': 'Snowy Mountains',
  'menu.mapTheme.2.sub': 'Hard winters, deep snow, valley fog',
  'menu.mapSize': 'Map',
  'menu.mapSize.normal': 'Standard (256)',
  'menu.mapSize.large': 'Large (384)',
  'charter.chip': 'Charter',
  'event.cupFinal': 'Cup final',
  'event.festival': 'Summer festival',
  'event.concert': 'Stadium concert',
  'event.fair': 'Trade fair',
  'event.congress': 'Medical congress',
  'event.pilgrimage': 'Pilgrimage season',
  'paper.charter':
    'A short series for an event: nearly full aircraft, 40% higher passenger charge; the contract ends with the event.',
  'building.railStation': 'Railway Station',
  'desc.railStation':
    'Built near a terminal, passengers arrive by train: a concession on every passenger, happier passengers and a better comfort rating. Needs tower Lv.4; Lv.2 adds a second platform and train.',
  'news.title': "What's new",
  'news.ok': "Let's play",
  'news.demo': 'Ready-made airport',
  'news.demo.text':
    'In a new game pick "Start with: Ready-made airport": runway, 5 stands, terminal, cargo, hotel and the first contracts.',
  'news.transfers': 'Transfer passengers',
  'news.transfers.text':
    'With two or more routes some passengers connect here (⇄). Bunch arrivals before departures.',
  'news.international': 'International flights',
  'news.international.text':
    'A level-2 terminal (passport control) brings international airlines: more revenue, slower processing.',
  'news.charter': 'Charter flights',
  'news.charter.text':
    'Two-day, full and lucrative series for events like a cup final or a festival.',
  'news.seasons': 'Weekdays and seasons',
  'news.seasons.text':
    'Busy Fridays and Sundays, busy summers, quiet snowy winters. Day and season in the top bar.',
  'news.snow': 'Snow clearing',
  'news.snow.text':
    'Snow builds up on the runways in winter; crews clear it, too much closes the runway.',
  'news.shifts': 'Night shifts',
  'news.shifts.text':
    'Management → Staff: full, half or no night shift per team. Night hours pay extra.',
  'news.noise': 'Night noise quota',
  'news.noise.text':
    'Night movements add points; every point over the quota is fined and draws complaints.',
  'news.facilities': 'Terminal facilities',
  'news.facilities.text':
    'Select a terminal: extra check-in, security lanes, a VIP lounge and duty free.',
  'news.hotel': 'Hotel',
  'news.hotel.text': 'Passengers and airline crews stay the night: room revenue every night.',
  'news.rail': 'Railway station',
  'news.rail.text':
    'Build it by the terminal: passengers arrive by train, more revenue and comfort.',
  'news.cargo': 'Air freight',
  'news.cargo.text':
    'With a cargo terminal freight airlines fly at night and pay per tonne; lorries come.',
  'news.airlines': 'Airlines tab',
  'news.airlines.text':
    'Management → Airlines: who flies here, how happy they are, who is waiting for what.',
  'news.coop': 'Co-op chat and pings',
  'news.coop.text': 'Enter to chat, Alt+click to show everyone a spot on the map.',
  'news.night': 'Night look',
  'news.night.text': 'Moonlight, taxiway lights, aircraft landing lights and flashing beacons.',
  'news.largeMap': 'Large map',
  'news.largeMap.text': 'Starting on empty land, choose the 384×384 map.',
  'building.constructionOffice': 'Construction Office',
  'desc.constructionOffice':
    'Each level adds one building crew that can work at the same time. Needs tower Lv.2.',
  'news.office': 'Construction Office',
  'news.office.text': 'Each level lets one more building crew work at the same time.',
  'building.cateringKitchen': 'Flight Kitchen',
  'desc.cateringKitchen':
    'Sells the airlines a meal for every passenger and loads catering 30% faster. Needs tower Lv.3 and a road.',
  'ledger.catering': 'Catering sales',
  'news.kitchen': 'Flight Kitchen',
  'news.kitchen.text': 'Sells airlines a meal per passenger and speeds up catering.',
  'hud.noiseMap': 'Noise map (N): noise contours round the runways',
  'news.noiseMap': 'Noise map',
  'news.noiseMap.text': 'Press N or "dB" in the top bar: noise contours round the runways.',
  'tutorial.title': 'Getting started',
  'tutorial.step': 'Step {n} of {of}',
  'tutorial.next': 'Next',
  'tutorial.back': 'Back',
  'tutorial.try': 'Try it',
  'tutorial.done': "Let's go",
  'welcome.kicker': 'Airport Manager 2027',
  'welcome.title': 'Welcome aboard, Captain!',
  'welcome.text':
    "I'm Captain Kanat. Together we'll turn this empty land into an airport with aircraft coming and going. I can guide you step by step if you like; skip any time, the lessons are always in the Academy.",
  'welcome.point1': 'Start with a tower, a runway and a terminal',
  'welcome.point2': 'Sign airlines and welcome your first flight',
  'welcome.point3': 'Complete goals and grow your airport',
  'welcome.start': 'Start the tutorial',
  'welcome.skip': 'Skip the tutorial',
  'lesson.gotIt': 'Got it',
  'lesson.confirmFirst': 'Tick the points first',
  'tutorial.skip': 'Close the guide',
  'tutorial.skipAll': 'Skip the tutorial',
  'tutorial.skipShort': 'Skip',
  'tutorial.restart': 'Show the getting-started guide again',
  'tutorial.0.title': 'Welcome to your airport',
  'tutorial.0.text':
    'You will turn this land into an airport: a runway, a terminal, roads, then airlines and flights. Pan with right drag or WASD, zoom with the wheel, turn with Q/E.',
  'tutorial.1.title': 'Buy land',
  'tutorial.1.text':
    'You start on a small plot. With the land tool (2) buy parcels next to yours; a runway is long and needs room.',
  'tutorial.2.title': 'Tower, runway and stand',
  'tutorial.2.text':
    'Open the build tool (3): the control tower first (it unlocks new buildings), then a runway and at least one stand. R turns a building. Select a building later and use "Move" to put it elsewhere.',
  'tutorial.3.title': 'Taxiway',
  'tutorial.3.text':
    'With the taxiway tool (5) drag a way from the runway to the stand. It is laid in 4×4 blocks; bring its end close to the runway or stand and it joins up by itself.',
  'tutorial.4.title': 'The yellow taxi line',
  'tutorial.4.text':
    'Aircraft follow the yellow line. With the taxi line tool (6) paint it from the edge of the runway to the front of the stand. An orange sign means a line is missing.',
  'tutorial.5.title': 'Terminal and roads',
  'tutorial.5.text':
    'Build a terminal, then link it, the stands and the service buildings to the motorway with the road tool (4). A red sign means no road; a pink one, a road that never reaches the motorway.',
  'tutorial.6.title': 'Take flights',
  'tutorial.6.text':
    'Accept offers in the flights panel (U) and aircraft start coming. A first tower draws private jets; upgrade it to level 2 for passenger airlines. Upgrade the runway to level 3 (runway lights) for night flights. The goals at the top left lead you on step by step.',
  'academy.title': 'Academy',
  'academy.button': 'Academy',
  'academy.sub': 'Manual and lessons',
  'academy.search': 'Search the manual…',
  'academy.lessons': 'Lessons',
  'academy.buildings': 'Buildings',
  'academy.reference': 'Reference',
  'academy.keys': 'Keyboard shortcuts',
  'academy.results': 'Search results',
  'academy.noResults': 'Nothing found. Try another word.',
  'academy.building': 'Building',
  'academy.welcome': 'Welcome to the Academy',
  'academy.intro':
    'Everything about the game is here: step-by-step lessons, every topic explained and every building\'s level table. Open it any time with F1. New? Start with the "Basics" lesson.',
  'academy.topics': 'Topics',
  'academy.steps': '{n} steps',
  'academy.pages': '{n} pages',
  'academy.done': 'Done',
  'academy.show': 'Show me in the game',
  'academy.lesson': 'Lesson: {name}',
  'academy.related': 'Related topics',
  'academy.read': 'Read in the manual',
  'academy.start': 'Start the lesson',
  'academy.replay': 'Do the lesson again',
  'academy.inGameOnly': 'Lessons run in the game: start a game and open the Academy (F1) there.',
  'academy.footprint': '{w}×{h} tiles',
  'academy.levels': 'Levels',
  'academy.level': 'Level',
  'academy.cost': 'Cost',
  'academy.time': 'Time',
  'academy.tower': 'Tower',
  'academy.limits': 'Most you may have, by tower level',
  'academy.count': 'Count',
  'academy.place': 'Place it',
  'academy.aircraft': 'Aircraft',
  'academy.drag': 'Drag: turn · Wheel: zoom',
  'academy.seats': 'Seats',
  'academy.turnaround': 'Turnaround',
  'academy.runwayLevel': 'Runway needed',
  'academy.standLevel': 'Stand needed',
  'academy.towerLevel': 'Tower needed',
  'academy.fireLevel': 'Fire service needed',
  'academy.crosswind': 'Crosswind limit',
  'academy.wake': 'Wake category',
  'academy.wake.0': 'Light',
  'academy.wake.1': 'Medium',
  'academy.wake.2': 'Heavy',
  'academy.landingFee': 'Landing fee',
  'academy.militaryFee': 'Ministry fee (per sortie)',
  'lesson.waiting': 'Moves on once you have done it',
  'lesson.doneNow': 'Done!',
  'lesson.manual': 'Manual',
  'lesson.show': 'Show me',
  'lesson.skipStep': 'Skip',
  'help.title': 'How to play',
  'help.ok': 'Got it',
  'help.credits': 'Credits',
  'help.creditsNote':
    '3D aircraft, vehicle and building models (Sketchfab): rescaled, simplified and repainted for the game.',
  'help.step.1':
    'Build the control tower (Build → Tower). Its level unlocks how many buildings, and which levels, you can have.',
  'help.step.2':
    'Build a runway, a terminal and stands; connect a road to the motorway (stands and bases need roads too).',
  'help.step.3':
    'Pave taxiways and draw the yellow taxi line from the runway to the stands: aircraft only follow the line.',
  'help.step.4': 'Read and sign airline offers in Flights (U); mind the capacity warnings.',
  'help.step.5':
    'Grow ground handling, fire, fuel and staff (M); find bottlenecks with the delay analysis.',
  'help.step.6':
    'Upgrade the tower, buy land and grow with cargo, a hotel, rail, international flights and transfers.',
  'help.key.tools': 'Tools: select, land, build, road, taxiway, taxi line, bulldoze',
  'help.key.pan': 'Pan the camera (or right-drag)',
  'help.key.rotate': 'Rotate the camera',
  'help.key.rotateBuilding': 'Rotate the building being placed',
  'help.key.pause': 'Pause / resume',
  'help.key.flights': 'Flights panel',
  'help.key.management': 'Management: staff, finance, airlines',
  'help.key.social': 'Social media',
  'help.key.noiseMap': 'Noise map',
  'help.key.save': 'Quick save',
  'help.key.chat': 'Co-op chat',
  'help.key.ping': 'Co-op: ping a spot on the map',
  'help.key.cancel': 'Cancel / deselect',
  'help.key.help': 'This help',
  'mgmt.tab.marketing': 'Marketing',
  'marketing.lead':
    'Promote the airport: a social campaign lifts the mood at once, an airline roadshow brings more offers for two days.',
  'marketing.social': 'Social media campaign',
  'marketing.social.text':
    'The online mood rises at once (a good mood brings more offers). Once a day.',
  'marketing.roadshow': 'Airline roadshow',
  'marketing.roadshow.text':
    'The route development team visits airlines: offers come 50% more often for 2 days.',
  'marketing.ready': 'Ready',
  'marketing.again': 'Again in {h} h',
  'marketing.running': 'Running: {h} h left',
  'ledger.marketing': 'Marketing',
  'news.marketing': 'Marketing campaigns',
  'news.marketing.text': 'Management → Marketing: social media campaigns and airline roadshows.',
  'finance.pax': 'Passengers',
  'finance.onTime': 'On-time departures %',
  'sky.5': 'Thunderstorm',
  'diag.weather': 'Weather (lightning alert, sandstorm)',
  'wx.storm': 'Thunderstorm: lightning alert, apron work stopped',
  'news.storm': 'Thunderstorms',
  'news.storm.text':
    'Warm summer rain can turn stormy: lightning flashes and the apron stops for the alert.',
  'ledger.bags':
    'Lost bags: {n} ($60 compensation each). Your own fully crewed handlers lose fewer.',
  'goal.office': 'Build a Construction Office',
  'goal.office.hint': 'With tower Lv.2: one more building crew at work.',
  'goal.hotel': 'Open a hotel',
  'goal.hotel.hint': 'With tower Lv.3, on the landside by a road.',
  'goal.kitchen': 'Build a Flight Kitchen',
  'goal.kitchen.hint': 'With tower Lv.3: sell airlines meals, faster catering.',
  'goal.charter': 'Sign the first charter',
  'goal.charter.hint':
    'With runway Lv.2 events bring charter offers; look for the red "Charter" tag in Flights.',
  'goal.rail': 'Open a railway station',
  'goal.rail.hint': 'With tower Lv.4, by the terminal: passengers arrive by train.',
  'staff.wage.title': 'Wage level',
  'staff.wage.low':
    'Low pay: saves wages, but a {pct}% chance of a strike every morning and a little less work done.',
  'staff.wage.high': 'High pay: everyone {pct}% more productive, the same work with fewer people.',
  'staff.wage.normal': 'Going rate: no strike risk.',
  'staff.strike':
    'STRIKE: half of every team walked out ({h} more hours). Raise wages or wait it out.',
  'toast.strike': 'Strike! Half of every team walked out over low pay.',
  'toast.strikeOver': 'The strike is over, the teams are back at work.',
  'news.wages': 'Pay policy and strikes',
  'news.wages.text':
    'Management → Staff: choose the wage level. Low pay risks strikes, high pay buys productivity.',
  'building.wildlifeControl': 'Wildlife Control',
  'desc.wildlifeControl':
    'Falconers and bird scarers keep birds off the approach: 70% of bird strikes never happen. Needs tower Lv.2.',
  'finance.value': 'Airport value',
  'finance.valueHint': 'Buildings at book value (60% of cost) + cash − loans still owed',
  'goal.value10m': 'Grow the airport to a value of $10 million',
  'goal.value10m.hint': 'Shown in Management → Finance: buildings, cash and debt together.',
  'hold.18': 'Runway closed for resurfacing',
  'pave.title': 'Runway surface',
  'pave.new': 'New',
  'pave.good': 'Good',
  'pave.worn': 'Worn',
  'pave.poor': 'Poor',
  'pave.fod':
    'Rubber build-up and debris: a {pct}% chance of tyre damage on every landing (the airport pays the claim).',
  'pave.fine': 'Clean surface: no debris risk.',
  'pave.planned': 'Works planned: runway closed {from}–{until}.',
  'pave.underway': 'Works under way: runway closed until {until}.',
  'pave.tonight': 'Tonight 01:00 · {cost}',
  'pave.now': 'Start now',
  'pave.hint':
    'Every landing wears the runway, heavy aircraft more. Resurfacing (rubber removal and repairs) closes it for {hours} hours.',
  'toast.runwayWorn': 'The runway is wearing: rubber build-up means debris. Plan the works.',
  'toast.runwayPoor': 'The runway surface is poor! Tyre damage will become frequent.',
  'toast.fod': 'Debris on the runway cut an aircraft tyre: a tyre change and a {amount} claim.',
  'toast.worksStarted': 'Runway works have begun: the runway is closed.',
  'toast.worksDone': 'Runway works are done: the surface is as new.',
  'news.pavement': 'Runway wear and resurfacing',
  'news.pavement.text':
    'Every landing leaves rubber behind. On a worn runway debris cuts tyres; select the runway and plan the works for tonight.',
  'news.value': 'Airport value',
  'news.value.text':
    'Management → Finance: buildings, cash and debt in one number. Goal: $10 million.',
  'sky.6': 'Sandstorm',
  'fc.title': 'Forecast',
  'fc.hint': 'Less sure further out',
  'fc.fog': 'Fog expected around {time}: a Lv.3 runway lands in thin fog, thick fog needs Lv.4.',
  'fc.storm': 'Thunderstorm expected around {time}: apron work stops for lightning.',
  'fc.snow': 'Snow expected around {time}: have snow clearing and de-icing ready.',
  'fc.blizzard': 'Blizzard expected around {time}: runways may close; have the plough team ready.',
  'fc.icing': 'Icing around {time}: departures need de-icing.',
  'fc.dust':
    'Sandstorm expected around {time}: visibility drops, more go-arounds, apron work slows down.',
  'fc.calm': 'No weather expected to trouble operations in the coming hours.',
  'wo.title': 'The next 7 days',
  'wo.hint': 'Further days are less certain',
  'wo.snow': 'Snow {pct}%',
  'wo.rain': 'Rain {pct}%',
  'wo.storm': 'Storm {pct}%',
  'wo.blizzard': 'Blizzard!',
  'wo.untilWinter': 'Winter starts on day {day} (in {n} days); snow mostly falls in winter.',
  'wo.winterNow': 'Winter: {n} more days. It snows on most days; keep the runways clear.',
  'seasonName.0': 'Spring',
  'seasonName.1': 'Summer',
  'seasonName.2': 'Autumn',
  'seasonName.3': 'Winter',
  'news.forecast': 'Weather forecast and CAT I ILS',
  'news.forecast.text':
    'Click the weather chip or open the flight board: the next 6 hours. A runway with a CAT I ILS (Lv.3) lands in thin fog.',
  'market.oil': 'Oil',
  'market.barrel': 'barrel',
  'market.economy': 'Economy',
  'market.recession': 'Recession',
  'market.weak': 'Weak',
  'market.normal': 'Normal',
  'market.strong': 'Strong',
  'market.boom': 'Boom',
  'market.effects':
    'Effect: airline offers {offers}%, load factors {load} pts, fuel sales {fuel}%.',
  'toast.market.oilHigh': 'Oil prices soar: airlines are cautious, but fuel sales pay well.',
  'toast.market.oilNormal': 'Oil prices are back to normal.',
  'toast.market.recession': 'The economy is in recession: fewer passengers, fewer new routes.',
  'toast.market.boom': 'The economy is booming: full aircraft, airlines looking for routes.',
  'toast.market.economyNormal': 'The economy is back to normal.',
  'news.market': 'Oil and the economy',
  'news.market.text':
    'Management → Finance: the oil price and the economy change day by day, moving demand, loads and fuel sales. With a light tailwind aircraft now use the runway the other way round too.',
  'year.title': '{year} annual report',
  'year.passengers': 'Passengers',
  'year.departures': 'Departures',
  'year.onTime': 'On time',
  'year.cancelled': 'Cancelled',
  'year.income': 'Income',
  'year.net': 'Net profit',
  'year.rating': 'Rating',
  'year.bestDay': 'Busiest day: day {day}, {pax} passengers.',
  'year.award.punctual': 'Punctuality Award',
  'year.award.punctual.text': 'At least 80% of departures on time.',
  'year.award.loved': 'Passengers’ Favourite',
  'year.award.loved.text': 'You ended the year on 4 stars or more.',
  'year.award.busy': 'Hundred Thousand',
  'year.award.busy.text': 'Over 100,000 passengers in one year.',
  'year.award.profit': 'Profitable Year',
  'year.award.profit.text': 'Net profit over $1 million for the year.',
  'year.award.reliable': 'Zero Cancellations',
  'year.award.reliable.text': 'Not a single flight cancelled all year.',
  'year.noAward':
    'No awards this year. Set your sights on punctuality, rating and profit, and try again!',
  'year.next': 'Start the new year',
  'news.yearReport': 'Annual report',
  'news.yearReport.text':
    'At the end of each game year (28 days): passengers, income, punctuality and rating, with awards for a good year.',
  'auth.login': 'Sign in',
  'auth.register': 'Sign up',
  'auth.loginLead':
    'Your saved games are kept in your account on the server: carry on from any device.',
  'auth.registerLead':
    'Create an account: your single-player and co-op saves are kept on the server.',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.repeat': 'Password (again)',
  'auth.rules': 'Username 3–20 characters: letters, digits, _ . -  Password at least 6 characters.',
  'auth.wait': 'Wait…',
  'auth.logout': 'Sign out',
  'menu.accountTitle': 'Account',
  'account.cardLocal': 'Playing on this device',
  'account.cardSync': 'Sign up: your game on phone, tablet and computer',
  'account.cardSynced': 'Your games are in your account, on every device',
  'account.local': 'You are playing without an account.',
  'account.why':
    'Your games are kept on this device. With a free account they are kept on the server: carry on with the same airport from your phone, tablet or computer, right where you left it. What you played on this device moves to your account too. Co-op, the world leaderboard and your profile come with an account.',
  'account.needed': 'You need a free account for {what}.',
  'account.signedInAs': 'Signed in as {name}',
  'account.syncOn':
    'Your games are kept in your account: phone, tablet or computer, carry on wherever you sign in.',
  'account.moved': '{n} games from this device moved to your account.',
  'account.delete': 'Delete my account',
  'account.deleteWarn':
    'Your account, all your saves on the server and your profile are deleted for good; this cannot be undone. Saves on this device stay.',
  'account.wrongPassword': 'Wrong password.',
  'account.keep': 'Keep it',
  'account.deleteNow': 'Delete for good',
  'auth.error.badUsername': 'The username must be 3–20 characters (letters, digits, _ . -).',
  'auth.error.rudeUsername': 'This username can’t be used. Pick another one.',
  'auth.error.badPassword': 'The password must be at least 6 characters.',
  'auth.error.taken': 'That username is taken.',
  'auth.error.wrongLogin': 'Wrong username or password.',
  'auth.error.slowDown': 'Too many attempts. Try again in a minute.',
  'auth.error.offline': 'The server cannot be reached. Check your connection.',
  'auth.error.mismatch': 'The passwords do not match.',
  'auth.error.server': 'Something went wrong, please try again.',
  'save.coop': 'Co-op',
  'auth.loginName': 'Username or e-mail',
  'auth.email': 'E-mail',
  'auth.error.badEmail': 'Enter a valid e-mail address.',
  'auth.error.emailTaken': 'There is already an account with this e-mail.',
  'ach.firstFlight': 'First Departure',
  'ach.firstFlight.text': 'See off your first flight.',
  'ach.flights100': 'A Hundred Departures',
  'ach.flights100.text': '100 departures at one airport.',
  'ach.flights1000': 'A Thousand Departures',
  'ach.flights1000.text': '1,000 departures at one airport.',
  'ach.flights5000': 'Busy Skies',
  'ach.flights5000.text': '5,000 departures at one airport.',
  'ach.widebody': 'Widebody',
  'ach.widebody.text': 'See off a widebody aircraft.',
  'ach.threeRunways': 'Three Runways',
  'ach.threeRunways.text': 'Run an airport with three runways.',
  'ach.value1m': 'First Million',
  'ach.value1m.text': 'Airport value of $1 million.',
  'ach.value10m': 'Ten Million',
  'ach.value10m.text': 'Airport value of $10 million.',
  'ach.value50m': 'Fifty Million',
  'ach.value50m.text': 'Airport value of $50 million.',
  'ach.value200m': 'Two Hundred Million',
  'ach.value200m.text': 'Airport value of $200 million.',
  'ach.cash10m': 'Full Coffers',
  'ach.cash10m.text': '$10 million in the bank.',
  'ach.debtFree': 'Debt-free Growth',
  'ach.debtFree.text': 'A $5 million airport without loans.',
  'ach.rating4': 'Four Stars',
  'ach.rating4.text': 'Raise the rating to 4 stars.',
  'ach.rating5': 'Five Stars',
  'ach.rating5.text': 'A near-perfect rating (95%).',
  'ach.fullService': 'Full Service',
  'ach.fullService.text': 'Build a hotel, a rail station and a flight kitchen.',
  'ach.freight': 'Freight Line',
  'ach.freight.text': 'Carry your first freight.',
  'ach.hub': 'Hub',
  'ach.hub.text': '100 connecting passengers in one day.',
  'ach.international': 'International',
  'ach.international.text': 'Sign an international airline.',
  'ach.charter': 'Event Flights',
  'ach.charter.text': 'Sign a charter event series.',
  'ach.allMilestones': 'Complete',
  'ach.allMilestones.text': 'Reach every goal.',
  'ach.yearOne': 'One Year',
  'ach.yearOne.text': 'Run an airport for a year.',
  'ach.veteran': 'Veteran',
  'ach.veteran.text': 'Run an airport for four years.',
  'ach.coop': 'Team Game',
  'ach.coop.text': 'Save a co-op game.',
  'ach.privateJet': 'Private Jet',
  'ach.privateJet.text': 'See off a private jet.',
  'ach.collector': 'Collector',
  'ach.collector.text': 'Collect 20 airlines in the airline album.',
  'ach.redCarpet': 'Red Carpet',
  'ach.redCarpet.text': 'See five VIPs off on time and pleased.',
  'ach.airshow': 'Showtime',
  'ach.airshow.text': 'Host an air show at your airport.',
  'ach.spotters': 'Watchful Eyes',
  'ach.spotters.text': "Open a Spotters' Deck for the plane spotters.",
  'ach.helicopter': 'Rotor Sound',
  'ach.helicopter.text': 'See a private helicopter off its helipad.',
  'ach.military': 'Air Base',
  'ach.military.text': 'Send off your first military sortie.',
  'ach.grant': 'State Grant',
  'ach.grant.text': 'Take the state grant and put its sign up in time.',
  'ach.airlines10': 'Airline Network',
  'ach.airlines10.text': 'Fly with 10 different airlines at once.',
  'ach.comfort': 'VIP Comfort',
  'ach.comfort.text': 'Give a terminal a lounge and two duty-free shops.',
  'ach.towerTop': 'Eye of the Sky',
  'ach.towerTop.text': 'Raise the control tower to its top level.',
  'ach.terminal5': 'Landmark Terminal',
  'ach.terminal5.text': 'Take a terminal to level 5.',
  'ach.jetBridges': 'Jet Bridges',
  'ach.jetBridges.text': 'Build 4 contact stands.',
  'ach.metro': 'Metro Line',
  'ach.metro.text': 'Bring the metro under a terminal.',
  'ach.deicePad': 'De-icing',
  'ach.deicePad.text': 'Build a de-icing pad.',
  'ach.landlord': 'Landowner',
  'ach.landlord.text': 'Own 20 land parcels.',
  'ach.unlocked': 'Achievement unlocked',
  'ach.points': '+{n} points',
  'ach.newTitle': 'New title: {title}',
  'achgroup.traffic': 'Traffic',
  'achgroup.business': 'Business',
  'achgroup.service': 'Service',
  'achgroup.growth': 'Growth',
  'achgroup.build': 'Infrastructure',
  'achgroup.social': 'Social',
  'rank.rookie': 'Rookie',
  'rank.apron': 'Apron Agent',
  'rank.tower': 'Tower Controller',
  'rank.operations': 'Operations Manager',
  'rank.director': 'Airport Director',
  'rank.mogul': 'Aviation Mogul',
  'rank.legend': 'Sky Legend',
  'title.controller': 'Traffic Master',
  'title.tycoon': 'Airport Baron',
  'title.favourite': 'Passengers’ Favourite',
  'title.cargo': 'Cargo King',
  'title.hub': 'Hub Architect',
  'title.perfectionist': 'Perfectionist',
  'title.veteran': 'Veteran Captain',
  'title.teamPlayer': 'Team Player',
  'title.commander': 'Base Commander',
  'title.architect': 'Master Architect',
  'menu.leaderboard': 'World leaderboard',
  'menu.leaderboardSub': 'The most valuable airports',
  'menu.leaderboardTitle': 'World leaderboard',
  'menu.profile': 'Profile & achievements',
  'menu.profileSub': 'Your title, your records',
  'menu.profileTitle': 'Profile',
  'lb.world': 'Overall',
  'lb.value': 'Value',
  'lb.rating': 'Rating',
  'lb.leadWorld':
    'World score = your achievement points + your most valuable airport (+500 for every tenfold: $1M 500, $1B 2000) + your best rating (5★ 1000). Once achievements and stars are full, the airport’s value decides.',
  'lb.lead':
    'Every player’s most valuable airport. When you save, the server reads your airport and updates your record.',
  'lb.leadRating':
    'Best rating of airports with at least 200 departures; at an equal rating the busier airport leads.',
  'lb.empty': 'Nobody on the leaderboard yet. Be the first!',
  'lb.you': 'You: #{rank} of {n} players',
  'lb.notYet': 'You are not on the leaderboard yet: save a game.',
  'lb.loading': 'Loading…',
  'lb.error': 'The leaderboard could not be loaded.',
  'profile.points': '{points} / {max} points',
  'profile.nextRank': 'Next rank: {rank} ({points} points)',
  'profile.maxRank': 'You hold the highest rank!',
  'profile.title': 'Title shown',
  'profile.titleHint': 'Shown on the leaderboard, your profile and in co-op chat.',
  'profile.best': 'Most valuable airport',
  'profile.bestNone': 'No saved airport yet.',
  'profile.bestLine': '{name} · day {day} · {value}',
  'profile.records': 'Records',
  'profile.bestRating': 'Best rating',
  'profile.mostDepartures': 'Most departures',
  'profile.pointsLabel': 'Achievement points',
  'profile.worldScore': 'World score',
  'profile.worldRank': '#{rank} of {n}',
  'profile.worldParts': 'World score = achievements {points} + value {value} + rating {rating}',
  'profile.achievements': 'Achievements ({n}/{total})',
  'profile.joined': 'Joined: {date}',
  'profile.email': 'E-mail: {email}',
  'profile.back': 'Back to the leaderboard',
  'profile.unlocked': 'Unlocked: {date}',
  'profile.locked': 'Locked',
  'profile.showcase': 'Showcase',
  'profile.error': 'The profile could not be loaded.',
  'menu.online': '{online} playing co-op · {rooms} open rooms · {accounts} pilots signed up',
  'coop.openRooms': 'Open rooms',
  'coop.openRoomsSub': 'Co-op games open to everyone: click to join.',
  'coop.noRooms': 'No open rooms right now. Open one!',
  'coop.roomLine': '{host} · {players}/{max} players',
  'coop.public': 'List the room for everyone',
  'coop.publicHint': 'Open rooms show on everyone’s co-op page; they can join without a code.',
  'coop.refresh': 'Refresh',
  'coop.playingAs': 'Your player name: {name}',
  'chat.title': 'Chat',
  'chat.empty': 'No messages yet. Say hello to your team!',
  'chat.send': 'Send',
  'chat.actions': 'Mute or report',
  'chat.mute': 'Mute',
  'chat.unmute': 'Unmute',
  'chat.report': 'Report',
  'chat.mutedCount': '{n} muted',
  'chat.mutedList': 'Players you muted (on this device)',
  'chat.reportSubject': 'Chat report: {name}',
  'chat.reportBody': 'Player: {name}\nRoom: {room}\nMessage: {text}\n\nWhat happened? (optional)\n',
  'news.community': 'World leaderboard, achievements and titles',
  'news.community.text':
    'A leaderboard of the most valuable airports, 23 achievements, 7 ranks and special titles. Pick the title you show on your profile.',
  'news.accounts': 'Accounts and open rooms',
  'news.accounts.text':
    'Your saves live on the server; list co-op rooms for everyone, titles show in chat.',
  'news.liveMenu': 'A live menu and a new look',
  'news.liveMenu.text':
    'The real game behind the menu, an opening screen, a miniature focus effect and flocks of birds.',
  'news.desktop': 'The Windows version',
  'news.desktop.text':
    'The game now comes with its own installer and window: it uses the graphics card directly and runs far smoother than in a browser. It checks for updates every time it starts and installs them itself. The menu now opens at once, too.',
  'news.realPlanes': 'Real aircraft models',
  'news.realPlanes.text':
    'Aircraft are now real 3D models: private jet, regional jet, narrow-body and wide-body. Each airline has its own colours and paint scheme (6 schemes), its name on the fuselage and its code on the fin; every aircraft carries its own registration (TC-…). Cabins light up at night.',
  'news.realVehicles': 'Real vehicles',
  'news.realVehicles.text':
    'Ten kinds of real cars on the roads, city buses, taxis, police, refuse trucks and tow trucks; the fire engine and the ambulance are new too. On the apron a real apron bus and a baggage train of container carts. Head- and taillights glow at night.',
  'news.towns': 'Towns on the horizon',
  'news.towns.text':
    'North and south of the map, beyond the forest, lie towns with streets, houses, flats and shops; their windows light up at night. (Hidden on the low graphics setting.)',
  'news.privateJets': 'Private jets first',
  'news.privateJets.text':
    'A new airport with a first tower draws private jet operators: few passengers, quick turnarounds. Upgrade the tower to level 2 and passenger airlines start making offers.',
  'news.brush': '4×4 road brush',
  'news.brush.text':
    'Roads and taxiways are now drawn in 4×4 blocks that snap to a grid and join a nearby road, the motorway, a runway or a stand by themselves.',
  'news.move': 'Move buildings',
  'news.move.text':
    'Select a building and press "Move" to put it somewhere else, turned if you like. It costs 10% of what was spent on it. Not while an aircraft is at it or it is being built.',
  'news.nightFlights': 'Evening flights',
  'news.nightFlights.text':
    'An unlit runway now takes flights from 06:00 to 22:00. Night flights (22:00–06:00) need a lit runway (Lv.3); the offers tab reminds you.',
  'news.junctions': 'Orderly junctions',
  'news.junctions.text':
    'Cars only enter a junction when there is room on the other side, and turns across others wait their turn: busy junctions no longer lock up, and nobody ends up nose to nose. Corners are rounded and trucks turn smoothly.',
  'news.lights': 'Lifelike street lights',
  'news.lights.text': 'Lamps now cast soft light over the ground instead of round spots.',
  'news.tunnels': 'Motorway tunnels',
  'news.tunnels.text':
    'The motorway runs into tunnels under hills at the map edges; trees are kept off the roads, and the welcome sign is placed clear of the road.',
  'news.tutorial': 'Getting started',
  'news.tutorial.text':
    'A short guide walks you through the first steps of a new game. You can open it again from Help.',
  'news.grass': 'More lifelike grass',
  'news.grass.text':
    'The grass is all new: drifts of colour and clumps from afar, tufts, wind-bent blades and small wild flowers up close. On airport land the mown stripes look light or dark depending on which way you look.',
  'news.traffic': 'Smarter vehicles, no collisions',
  'news.traffic.text':
    'Cars and apron vehicles now look ahead along their own route, bends included: they keep their distance in a queue, wait at junctions, give way to aircraft, and when two meet nose to nose one backs up. They line up around the aircraft one by one without touching, and find a new way round when something blocks the path.',
  'news.fleet': 'A new ground fleet',
  'news.fleet.text':
    'Every apron vehicle remade: the catering box rises to the door, the fuel hose reaches the wing, the belt loader runs, headlights light the way at night. A FOLLOW ME car now leads arrivals to their stand.',
  'class.5': 'Light fighter',
  'class.6': 'Military airlifter',
  'class.7': 'Tactical drone',
  'class.8': 'Helicopter',
  'hold.19': 'Runway closed: fighters scrambling',
  'hold.20': 'Went around, no new slot: diverted to another airport',
  'hold.21': 'No free helipad with a road to it',
  'hold.22': 'Ground vehicles (stairs, bus, baggage, fuel): all busy',
  'hold.23': 'Runways closed: Air Force jets passing over low',
  'delayTip.23':
    'An Air Force flypast is short: the runways open again in a few minutes, just wait.',
  'flypast.kicker': 'Air Force · Urgent NOTAM',
  'flypast.title': 'Fighters are about to pass over the airport',
  'flypast.body':
    '{n} fighters home from a test flight will shortly pass over the runways, low and faster than sound. For safety every take-off and landing is stopped for {minutes} minutes; waiting aircraft have been held.',
  'flypast.closed': 'Runways closed',
  'flypast.closedFor': '{minutes} minutes',
  'flypast.compensation': 'Ministry of Defence compensation',
  'flypast.watch': 'Press OK and watch the runway: brace for sonic booms and flares.',
  'flypast.paused':
    'The game is paused. It runs at normal speed during the flypast, then as fast as before.',
  'flypast.together':
    'In a shared game time does not stop; everyone watches the flypast on their own screen.',
  'flypast.ok': 'OK',
  'toast.flypastOver': 'The Air Force flypast is over: the runways are open again.',
  'toast.balloons': 'A calm morning: hot-air balloons are going up 🎈',
  'news.roadsLight': 'Realistic asphalt, junction markings and daylight',
  'news.roadsLight.text':
    'Roads and the motorway are textured dark grey asphalt now, not navy (aggregate grain, older and newer stretches, mended patches). Junctions have zebra crossings and stop lines, the centre line ends at the stop line, and their corners curve round with the kerb and pavement. Daylight is more natural: the blue of the sky no longer tints every surface, white buildings are white and grass is green.',
  'news.motorwayOut': 'The motorway now leads far away',
  'news.motorwayOut.text':
    "The motorway and the viaduct no longer go into their tunnels at the map's edge: they run on across the countryside, barriers, lights, traffic and all, and only far off, out of the camera's reach, go into a tunnel under a hill. At night their lights run on to the horizon.",
  'news.trees': 'New trees: broadleaf trees, spruces and palms',
  'news.trees.text':
    "The trees are redrawn. Broadleaf crowns are full of leaf clusters, on trunks with roots and branches; spruces stand in tiers with twig tips hanging from their edges; the desert palms' feathery fronds arch and droop over clusters of dates. The seasons show on them too: bushes blossom pink, white and yellow in spring, berries and apples ripen in late summer, leaves turn and fall one by one in autumn, and bare branches remain in winter.",
  'news.maps': 'New maps: the Desert and the Snowy Mountains',
  'news.maps.text':
    'Pick your landscape when you start a new game: the Green Valley, the Desert or the Snowy Mountains. The desert has dunes, banded red mesas, palm oases, towns of domes and minarets and a skyline on the horizon; scorching summers, cool nights, dust devils whirling on hot afternoons and sandstorms that cut visibility (more go-arounds, slower apron work). The mountains have snowy peaks, spruce forests and chalets; hard winters, deep snow, valley fog and blizzards. The maps work in co-op too, and saves remember their map.',
  'news.airportCity': 'The airport city',
  'news.airportCity.text':
    'Build your own town on the landside: cafés, restaurants, a mall, a fuel station, office towers and parks. Passengers, people from the city and office workers spend money; the airport takes a cut of every sale and the offices pay rent. The layout matters: shops side by side feed each other, parks make a neighbourhood pleasant, a mall brings people around it, and somewhere to eat near a terminal makes passengers comfortable. See the new Airport city section of the catalogue.',
  'news.playtestNotes': 'Delay advisor, report book and new buildings',
  'news.playtestNotes.text':
    'Delays now say why: the advisor in the flights list shows how many minutes each cause cost, what to do and where; the staff card estimates the base levels and crews your schedule needs. Ground handling bases go up to Lv.6, and tower Lv.4 allows 3 of them. Click a contract to see how pleased the airline is, and why. New: the Airport Directorate with a live report book, and a large de-icing pad for widebodies and giants. Widebodies now need a large stand. A slip road replaces the interchange; every new way in from the motorway adds capacity. Roads pass under taxiways in tunnels. Double the noise quota, cheaper land, landing gear on the An-124, and fewer, quieter jet flybys.',
  'news.languages': 'German, French and Russian',
  'news.languages.text':
    'The game now speaks five languages: German, French and Russian besides Turkish and English. Everything is translated, from the menus, lessons and Academy to the news, the social feed and the legal texts. Change the language in the main menu’s corner or in the settings. Keyboard shortcuts are now named as printed on your keyboard, too (ZQSD instead of WASD on AZERTY).',
  'news.menuFilms': 'The main menu, shot anew',
  'news.menuFilms.text':
    'Eleven new films behind the main menu, in Full HD and mostly at night: F-22s low down the runway, F-35s at sunset, an An-124’s and an A350’s night landings, an A380 taking off in the dark, the lit apron, an A220 gliding over the motorway and more. All shot in the game’s own engine.',
  'news.stealthJets': 'F-35s and F-22s',
  'news.stealthJets.text':
    'Half the fighter flights crossing the sky are now F-35s or F-22s: they pour out a thick, long-lasting trail and every pass ends in a sonic boom. Squadrons landing at a military airport fly F-35s and F-22s beside their F-16s, gear down on the ground and coming in to land.',
  'news.jetSound': 'Real sound and sonic booms for fighters',
  'news.jetSound.text':
    'Every fighter pass is now heard through a real recording of a jet going by: its loudest moment comes as the jet is nearest, the sound moves across with it, and a far pass is softer. A fighter coming in to land swells as it nears the runway and fades away as it touches down. Most passes end in a real sonic boom, never one right after another. Airliners sound as before.',
  'news.legal': 'Privacy, terms and a safer chat',
  'news.legal.text':
    '“About and legal” in the main menu and the settings: the privacy policy (what data we keep and why, and how to have it deleted), the terms of use and the open-source licences. Signing up asks you to accept the terms. Co-op chat masks swear words; tap a player’s name to mute them or report their message to us.',
  'news.playtest': 'Fixes from a playtest',
  'news.playtest.text':
    'Offers no longer dry up once every airline that can come has a deal: airlines flying here offer more flights and new routes (up to 3 contracts each). Goal rewards are halved; the money comes from the flights now. The only runway’s upgrade warning says how many flights are due while it is shut. A terminal turned away from the roads joins one from another side in one tap, and a new terminal starts with its kerb toward the motorway. A lesson is kept with its save, and the radio names the runway in use and calls a visual approach on a runway without an ILS.',
  'news.phoneHud': 'An interface made for phones',
  'news.phoneHud.text':
    'On a phone the game has an interface of its own. Up top: money, day, time and weather; a tap there opens the airport page with the rating, the tower, the forecast, the wind, the noise map and the spectator camera. Under it, the next goal; a tap opens every goal and today’s tasks. At the bottom left, five named tools: Select, Land, Build, Roads and Edit. Roads and Edit open their own tools in a small tray. The building catalogue, the settings and the goals open as pages from the right, and a tap on the map closes them. On an iPhone, "Add to Home Screen" in Safari opens the game full screen.',
  'news.mobile': 'Play with your finger on a phone or a tablet',
  'news.mobile.text':
    'The game now plays comfortably on phones and tablets, on their side. A building picked from the catalogue lands on free ground on the map: carry it with your finger, turn it with ↻, place it with ✓; ⓘ says what it is for. Draw roads and taxiways with one finger and drag the handles at their ends to adjust them; near the edge the map moves along by itself. "Connect the road" on a building without one joins it to the nearest road. Camera: one finger pans, two fingers zoom and turn, two fingers pushed up or down together tilt, a double tap zooms in. Windows take the whole screen on a phone, the building panel a full-height sheet at the side. In a browser the game goes full screen; added to the home screen it opens like an app.',
  'news.guestPlay': 'Play without an account, carry on on every device with one',
  'news.guestPlay.text':
    'The game plays without an account now: your games are kept on this device. With a free account they are kept on the server, and you carry on with the same airport from your phone, tablet or computer, right where you left it; what you played on this device moves to your account too. Co-op, the world leaderboard and your profile come with an account. The title screen is laid out for phone screens, and the Account page lets you sign out or delete your account for good.',
  'news.oneRunway': 'One runway, five levels',
  'news.oneRunway.text':
    'Instead of small, normal and large runways there is one runway now, and it grows with its levels: Lv.1 a narrow runway (light aircraft, private and regional jets), Lv.2 wider (narrow-bodies), Lv.3 runway lights and CAT I ILS, Lv.4 approach lights, CAT III ILS and wide-bodies, Lv.5 the widest (every aircraft, jumbos and giant freighters included). No need for a runway per aircraft; a second runway is for capacity only. Runways in older saves go on working as they are. Also, sonic booms no longer shake the camera, and during the Air Force flypast the camera stays where you left it.',
  'news.realHelicopters': 'Real helicopters',
  'news.realHelicopters.text':
    'The private helicopters coming to the helipads are real models now: two mid-size types on skids with their tail rotors spinning inside the fin, and a small, nimble egg-shaped one. Each operator flies one, in its own colours; the main and tail rotors turn, blur into a faint disc as they speed up, and a red beacon flashes on top of the tail.',
  'news.roadTunnels': 'Service tunnels under roads, real cuttings',
  'news.roadTunnels.text':
    'Draw a service road across a road and it now goes under it in a tunnel: the cars keep flowing on top, the ground vehicles pass below, and nobody waits for anybody (a service road ending on a road joins it as before). The tunnels are rebuilt too: the ramp goes deeper, down a real cutting in the ground, with retaining walls, a yellow-topped parapet, a drain at its foot, a portal with a striped lintel and a dark tube lit by a line of lamps.',
  'news.motorwayKit': 'A proper dual carriageway',
  'news.motorwayKit.text':
    'The motorway past the airport has a concrete barrier down its middle now, steel guard rails on posts along its edges and a gravel verge. The barriers open at junctions and the rails end sloping into the ground; twin-armed lamp columns on the median light both carriageways at night. Roads joining it have a stop line and a zebra crossing, and every lane coming up to a junction has its arrow painted on: straight on, left or right, by where that junction really leads.',
  'news.moreTypes': 'A double-decker giant and three more types',
  'news.moreTypes.text':
    'The jumbo class has a second type: a four-engined double-deck giant (with two rows of windows and four-wheel bogies). The narrowbody class gets a new-generation jet with big engines, the widebody class a new-generation twin with curved wingtips and the regional class a long T-tailed turboprop with six-bladed propellers, so those classes come in three types now. Cargo airlines fly no passenger windows, and no double-decker.',
  'news.aircraftTypes': 'New aircraft types',
  'news.aircraftTypes.text':
    'Every class has a second type now: a new-generation narrowbody with winglets, a long widebody twin with huge engines, a high-wing turboprop regional and a T-tailed business jet. Each airline flies one of them, so the apron and the sky look far more varied.',
  'news.balloons': 'Hot-air balloons',
  'news.balloons.text':
    'Some fair, still mornings outside winter, hot-air balloons are blown up on a field upwind of the airport, rise and drift past it, and come down beyond it an hour and a half later. The burners roar now and then, and at first light the envelopes glow from inside. Click the notice and the camera goes to them.',
  'news.flypast': 'Air Force flypasts',
  'news.flypast.text':
    'Now and then five fighters home from a test flight pass over the airport: the game stops, a NOTAM comes in and the runways close for a while (the ministry pays). Press OK and the camera turns to the runway; the jets go over low on afterburner, each with its own sonic boom, firing flares, and draw an "angel" as they pull straight up.',
  'toast.goAround': '{airline} went around: flying the circuit to land again',
  'toast.diverted': '{airline} went around and found no slot: diverted',
  'ledger.military': 'Military contracts',
  'rwy.usage': 'Runway use',
  'rwy.usage.0': 'Joint',
  'rwy.usage.1': 'Civil only',
  'rwy.usage.2': 'Military only',
  'rwy.usageHint':
    'On a joint runway civil traffic waits while fighters scramble. Civil-only runways stay open.',
  'toast.scramble': 'Scramble! Fighters are taking off, runways closed. The ministry pays {bonus}',
  'building.militaryGate': 'Military Zone Gate',
  'desc.militaryGate':
    'Opens the military zone: the ministry starts offering drone and airlifter contracts. Military aircraft use no terminal and carry no passengers; the ministry pays a fixed fee per flight. Needs tower Lv.3.',
  'building.shelter': 'Hardened Shelter',
  'desc.shelter':
    'A concrete shelter for one fighter (works like a stand). A fighter squadron needs shelters, an operations building and a munitions store. Needs tower Lv.4.',
  'building.militaryApron': 'Military Apron',
  'desc.militaryApron':
    'Parking for an airlifter or a drone (works like a stand); connect it to a taxiway and a road. Needs tower Lv.4.',
  'building.opsCenter': 'Operations Building',
  'desc.opsCenter':
    'Home of the fighter squadron. Once it is based here, fighters now and then scramble: the runways close for a few minutes and the ministry pays extra.',
  'building.munitions': 'Munitions Store',
  'desc.munitions': 'An earth-covered, fenced store. A fighter squadron needs one.',
  'building.airDefence': 'Air Defence Site',
  'desc.airDefence':
    'A turning search radar and missile launchers. The ministry pays 15% more (30% at Lv.2) for every military sortie and scramble. Lv.2 adds a long-range launcher and a fire-control radar truck. Needs tower Lv.4.',
  'news.cinema': 'Cinematic main menu',
  'news.cinema.text':
    'Behind the main menu, films shot in the game’s own engine at ultra settings: an airliner low over the motorway, a wide-body escorted by two fighters, a drone patrol, fighters on afterburner and a night landing.',
  'news.settings': 'Detailed settings',
  'news.settings.text':
    'Five graphics profiles (Potato included, for weak computers); shadows, trees, effects and resolution one by one; an FPS meter, a frame rate limit, camera and autosave settings.',
  'news.academy': 'Academy: manual and lessons',
  'news.academy.text':
    'F1 or Academy on the top bar: every topic of the game as a searchable wiki, each building’s level and limit table, and step-by-step lessons (Basics, Flights, Passengers, Management, Weather, Military) that light up the right part of the screen and move on once you have done it. Buildings (at every level) and aircraft in live, turning 3D. A new cockpit look for the interface. A new "Military" tab in the catalogue.',
  'news.hints': 'Connection hints',
  'news.hints.text':
    'While building, the edges of a building show where roads and taxiways must meet it: green connected, amber leads nowhere, yellow draw here. An arrow marks where aircraft come in; drawing a road or taxiway lights up every open connection point.',
  'news.atc': 'Realistic tower',
  'news.atc.text':
    'Wake-turbulence separation (longer gaps behind heavies), departures in the order they are due, go-arounds in bad weather, jet bridges first for passengers and knock-on delays: an aircraft that leaves late comes back late for its next flight. In the terminal passengers pass check-in, security and passports; the panel shows the bottleneck.',
  'news.military': 'Military zone',
  'news.military.text':
    'Tower Lv.3 unlocks the military zone gate; Lv.4 the shelter, military apron, operations building and munitions store. The ministry offers drone, fighter and airlifter contracts, and every runway can be joint, civil only or military only. Fighters now and then scramble. An air defence site (turning radar, missile launchers) raises what the ministry pays.',
  'graphics.potato': 'Potato',
  'graphics.potato.desc':
    'Half resolution, no effects, no trees, 30 FPS. For the weakest computers.',
  'graphics.low.desc': 'Low resolution, no effects, near trees, 60 FPS. For older computers.',
  'graphics.medium.desc':
    'Full resolution, 2× edge smoothing, light bloom, towns. For most computers.',
  'graphics.high.desc': 'Full resolution, 4× edge smoothing, far trees. For strong computers.',
  'graphics.ultra': 'Ultra',
  'graphics.ultra.desc': 'High, with the farthest tree detail.',
  'settings.all': 'All settings',
  'settings.game': 'Game',
  'settings.soundLang': 'Sound and language',
  'settings.custom': 'Custom settings: choosing a profile sets them all to it.',
  'settings.image': 'Image',
  'settings.renderScale': 'Render scale',
  'settings.renderScale.hint':
    'How much of the screen’s resolution is drawn. Lowering it gains the most.',
  'settings.autoResolution': 'Automatic smoothness',
  'settings.autoResolution.hint':
    'When the frames fall behind, draws at a slightly lower resolution for a while (down to 60% of the setting) and back up once there is room: smooth on modest devices too.',
  'settings.hiDpi': 'High DPI',
  'settings.hiDpi.hint': 'Full density on Retina / 4K screens. Much faster off.',
  'settings.msaa': 'Anti-aliasing',
  'settings.upscale': 'Smart upscaling',
  'settings.upscale.hint':
    'Like DLSS or FSR 2: the scene is drawn at a lower resolution and rebuilt into a sharp full image from the frames before. Works on any graphics card and gives the biggest frame-rate gain; it smooths edges itself.',
  'settings.upscale.native': 'Native (DLAA)',
  'settings.upscale.quality': 'Quality',
  'settings.upscale.balanced': 'Balanced',
  'settings.upscale.performance': 'Performance',
  'settings.fpsCap': 'Frame rate limit',
  'settings.fpsCap.hint': '30 or 60 on a laptop for battery and heat.',
  'settings.unlimited': 'None',
  'settings.off': 'Off',
  'settings.lighting': 'Light and effects',
  'settings.shadows': 'Shadows',
  'settings.shadows.hint': 'One of the most expensive settings.',
  'settings.ao': 'Ambient occlusion',
  'settings.ao.hint': 'Soft shading in corners and at the foot of buildings (heavy).',
  'settings.bloom': 'Light bloom',
  'settings.bloom.hint': 'The glow of lights at night.',
  'settings.tiltShift': 'Miniature focus',
  'settings.tiltShift.hint': 'Top and bottom blurred when looking close.',
  'settings.world': 'World',
  'settings.vegetation': 'Trees',
  'settings.vegetation.hint': 'How far forests keep their detail; off removes the trees.',
  'settings.towns': 'Towns',
  'settings.towns.hint': 'The towns around the airport (many triangles).',
  'settings.weatherFx': 'Weather effects',
  'settings.weatherFx.hint': 'Rain, snow, lightning and sandstorms on screen.',
  'settings.birds': 'Flocks of birds',
  'quality.off': 'Off',
  'quality.low': 'Low',
  'quality.medium': 'Medium',
  'quality.high': 'High',
  'quality.ultra': 'Ultra',
  'settings.interface': 'Interface',
  'settings.fpsMeter': 'FPS meter',
  'settings.fpsMeter.hint':
    'Frame rate in a corner of the screen (detailed: draw calls and triangles).',
  'settings.detailed': 'Detailed',
  'settings.reports': 'Crash and stall reports',
  'settings.reports.hint':
    'If the game crashes, freezes or stalls, sends what happened (version, graphics card, the moment in the game and its save) to the developers, so the problem can be found and fixed.',
  'advice.title': 'The airport is not ready for this contract',
  'advice.sub': 'Signed as it is, its flights cannot land or will wait; first:',
  'advice.note':
    'You can sign it anyway; once what is missing is built during the contract, the flights start.',
  'advice.ok': 'OK',
  'advice.missing': 'Missing',
  'advice.noHelipad': 'No helipad',
  'advice.buildHelipad': 'Build a helipad with a road to it',
  'advice.noLargeRunway': 'No large runway for this giant',
  'advice.buildLargeRunway': 'Upgrade the runway to level 5 (tower level 3)',
  'advice.noRunway': 'No runway',
  'advice.buildRunway': 'Build a runway and join it to a taxiway',
  'advice.shortRunway': 'Your runway is not enough for this aircraft',
  'advice.upgradeRunway': 'Upgrade a runway to level {level}',
  'advice.noLargeStand': 'No large stand for this aircraft',
  'advice.buildLargeStand':
    'Build a large stand (tower level 3) with a service road and a taxi line',
  'advice.noStand': 'No stand',
  'advice.buildStand': 'Build a stand with a service road and a taxi line',
  'advice.smallStand': 'Your stands are not enough for this aircraft',
  'advice.upgradeStand': 'Upgrade a stand to level 2, or build a large one',
  'advice.noFire': 'The fire station does not cover this aircraft’s category',
  'advice.upgradeFire': 'Build the fire station or bring it to level {level} (with its crew)',
  'advice.noCargo': 'No cargo terminal',
  'advice.buildCargo': 'Build a cargo terminal with a road to it',
  'advice.noTerminal': 'No terminal',
  'advice.buildTerminal': 'Build a terminal and join it to the motorway by road',
  'advice.noPassports': 'No passport control for international passengers',
  'advice.upgradeTerminal': 'Upgrade the terminal to level {level}',
  'advice.night': 'Night slots, but no runway lights',
  'advice.lightRunway': 'Upgrade a runway to level 3 (lights)',
  'delayAlert.departure': 'A departure delayed out of all proportion',
  'delayAlert.arrival': 'An arrival held out of all proportion',
  'delayAlert.lateOut': '{late} past its departure time, the aircraft is still on the ground.',
  'delayAlert.lateIn': '{late} past its arrival time, the aircraft still cannot land.',
  'delayAlert.days': '{d} d {h} h',
  'delayAlert.hours': '{h} h {m} min',
  'delayAlert.minutes': '{m} min',
  'delayAlert.why': 'Why',
  'delayAlert.tip': 'What to do',
  'delayAlert.turnaround': 'Ground services and boarding are not done',
  'delayAlert.paused': 'The game is paused; closing this carries on at the speed it ran at.',
  'delayAlert.show': 'Show the flight',
  'delayAlert.mute': "Don't show this cause again",
  'delayAlert.ok': 'Got it',
  'settings.delayAlerts': 'Alerts for extreme delays',
  'settings.delayAlerts.hint':
    'A departure over 3 hours late or an arrival held over 45 minutes stops the game and says why. Turning this off and on brings back muted causes.',
  'advice.delay.title': 'Delay advisor',
  'advice.delay.summary':
    'Yesterday and today: {pct}% of departures on time, {avg} min late on average',
  'advice.delay.minutes': '{m} min',
  'advice.cause.vehicles': 'Ground vehicles',
  'advice.cause.passengers': 'Late passengers',
  'advice.cause.departure': 'Queue for take-off',
  'advice.cause.arrival': 'Waiting to land or for a stand',
  'advice.cause.technical': 'Technical faults',
  'advice.cause.weather': 'Lightning, storms and sandstorms',
  'advice.delay.estimate':
    'Estimate: your schedule needs ground handling for up to {need} aircraft at once (around {hour}); your bases’ vehicles serve {have}. To run without delays that takes about {levels} base levels and {staff} ground crew.',
  'advice.delay.noBase':
    'A contractor does your ground handling: 50% slower and paid per aircraft. Build a Ground Handling Base (Catalogue → Operations) and connect it to the stands by service road.',
  'advice.delay.crews':
    'Your ground crews are short ({hired}/{needed}): part of the fleet stands without drivers. Hire in Management → Staff, or switch it to Automatic.',
  'advice.delay.crewsAuto':
    'Ground crews are short right now ({hired}/{needed}): with a thin night shift or a strike the vehicles stand without drivers. Check the night shift and wages in Management → Staff.',
  'advice.delay.fuel':
    'Not enough fuel trucks: they come from the fuel depot. Upgrade the depot or build a second one.',
  'advice.delay.upgradeBase':
    'Not enough ground vehicles: upgrade the base to Lv.{level} (click the base → Upgrade). Each level brings more stairs, buses, baggage, catering and cleaning vehicles.',
  'advice.delay.moreBases':
    'Your bases are at the top level the tower allows, and still short: build ground handling base no. {n} (your tower allows {max}), near the stands with a service road.',
  'advice.delay.towerUp':
    'Everything the tower allows is built and vehicles are still short: upgrade the tower to Lv.{level} (more bases and base levels) or spread contracts over other hours.',
  'advice.delay.spread':
    'Ground handling is at full stretch: spread contracts bunched at the same hour, or sign no more at the peak.',
  'advice.delay.passengers':
    'Passengers reach their aircraft late: the check-in and security queues are long. Add facilities (check-in, security) or upgrade the terminal; contact stands and a bus station help too.',
  'advice.delay.passengersStaff':
    'Passengers reach their aircraft late: the terminal is short-staffed, check-in and security are slow. Fill the terminal team in Management → Staff.',
  'advice.delay.departure':
    'Ready aircraft queue for take-off: the runway or the taxiways are busy. Add a second runway, a parallel taxiway, or spread contracts over other hours.',
  'advice.delay.arrival':
    'Aircraft wait to land or for a free stand: add stands (a large one for widebodies), remote parking for long stays, and runway capacity.',
  'advice.delay.technical':
    'Technical faults hold aircraft up: build or upgrade a hangar; its crews shorten repairs.',
  'advice.delay.weather':
    'Lightning, storms or a sandstorm stopped or slowed the ground work: it recovers once the weather passes; there is little to do.',
  'advice.go.staff': 'Go to Staff',
  'advice.go.build': 'Build {building}',
  'advice.go.select': 'Show the building',
  'advice.toast.vehicles':
    '{pct}% of departures are late, mostly for want of ground vehicles. Click to see what to do.',
  'advice.toast.passengers':
    '{pct}% of departures are late, mostly waiting for late passengers. Click to see what to do.',
  'advice.toast.departure':
    '{pct}% of departures are late, mostly queueing for take-off. Click to see what to do.',
  'advice.toast.arrival':
    '{pct}% of departures are late, mostly from waiting to land or for a stand. Click to see what to do.',
  'advice.toast.technical':
    '{pct}% of departures are late, mostly through technical faults. Click to see what to do.',
  'advice.toast.weather':
    '{pct}% of departures are late, mostly through storms. Click for the details.',
  'toast.open': 'Click to open',
  'delayAlert.turnaroundBy': 'Its turnaround is not done, mostly because of: {cause}',
  'delayAlert.fix': 'Go and fix it',
  'staff.estimate':
    'Estimate: your schedule needs ground handling for up to {need} aircraft at once (around {hour}); your bases serve {have}. That takes about {levels} base levels and {staff} crew. Bases built: {bases}/{max}.',
  'capacity.handling':
    'Around {hour}, {need} aircraft will need ground handling at once and your bases serve {have}: expect delays. Upgrade a base or build another, and fill the ground crews in Management → Staff.',
  'capacity.largeStands':
    'Around {hour}, {need} big aircraft (widebodies, jumbos, giant freighters) will be on the ground at once; you have {have} large stands.',
  'req.largeStand': 'Large stand',
  'ops.report': 'Satisfaction',
  'report.title': 'Airline Assessment',
  'report.lead':
    '{airline} rates its satisfaction with your airport at {score}%. Below: what its flights went through here, and what displeases it.',
  'report.verdict.bonus':
    'Delighted: it will renew when the term ends and add flights ({bonus}% or more).',
  'report.verdict.renew':
    'Pleased: it will renew when the term ends ({renew}% or more). At {bonus}% it adds flights too.',
  'report.verdict.noRenew':
    'Not pleased: below {renew}% it will not renew when the term ends. Below {suspend}% it suspends its flights.',
  'report.verdict.suspend':
    'Furious: below {suspend}%, about to suspend its flights. Fix the reasons below at once.',
  'report.none': 'No departures under this contract yet.',
  'report.punctuality': 'Punctuality',
  'report.punctualityValue': '{onTime} on time · {late} late ({pct}% on time)',
  'report.avgDelay': 'Average delay',
  'report.lostBy': 'Minutes lost to',
  'report.causeValue': '{cause}: {m} min',
  'report.missed': 'Passengers left behind',
  'report.missedValue': '{n} of {of} ({pct}%)',
  'report.bags': 'Bags that missed the flight',
  'report.fees': 'Fees',
  'report.feesValue': 'Above the tariff: {pts} points off every departure',
  'report.feesOk': 'At or below the tariff: no complaint',
  'report.why': 'What displeases it',
  'report.why.late':
    '{pct}% of its departures leave more than {m} minutes late; most minutes go to "{cause}". Every minute over {m} costs 2 points.',
  'report.why.missed':
    '{pct}% of its passengers missed the flight: traffic on the way in, check-in and security queues. Check the junctions, the terminal and its staff.',
  'report.why.bags':
    '{n} bags missed their flight (each one compensated): baggage vehicles and ground handling may be short.',
  'report.why.fees':
    'Your landing and passenger fees are above the tariff: {pts} points every departure. Lower them in Management → Finance.',
  'report.why.cancelled':
    '{n} of its flights were cancelled: cancellations hurt reliability, and a run of them suspends the contract.',
  'report.why.happy': 'No complaints: keep it up.',
  'report.why.none': 'Nothing stands out; the score rises slowly with new departures.',
  'report.fix': 'What to do:',
  'report.how':
    'The score is reassessed at every departure: each minute of delay over {m} takes 2 points, half the percentage of passengers left behind and fees above the tariff take more; each time it moves a quarter of the way to the new value.',
  'book.open': 'Open the report book',
  'book.title': 'Directorate Report Book',
  'book.page.now': 'Right Now',
  'book.page.allTime': 'All Time',
  'book.page.satisfaction': 'Satisfaction',
  'book.page.delays': 'Delays',
  'book.page.money': 'Accounts',
  'book.cutOff':
    'The directorate has no service road: its staff cannot get in and nobody keeps the book. Connect it by service road.',
  'book.prev': 'Previous page',
  'book.next': 'Next page',
  'book.pageOf': 'Page {n} of {of}',
  'book.money': 'Cash',
  'book.rating': 'Airport rating',
  'book.contracts': 'Contracts running',
  'book.offers': 'Offers waiting',
  'book.aircraftNow': 'Aircraft at the airport now',
  'book.departuresToday': 'Departures today',
  'book.passengersToday': 'Passengers today',
  'book.onTimeToday': 'On time today',
  'book.cancelledToday': 'Cancelled today',
  'book.staff': 'Staff (hired / needed)',
  'book.buildings': 'Buildings',
  'book.profitToday': 'Profit today',
  'book.cityCustomers': 'City customers',
  'book.citySales': 'City income (sales and rent)',
  'book.departures': 'Departures',
  'book.passengers': 'Passengers',
  'book.days': 'Days open',
  'book.transfers': 'Connecting passengers',
  'book.tonnes': 'Freight handled',
  'book.tonnesValue': '{t} t',
  'book.onTime': 'On time',
  'book.avgDelay': 'Average delay',
  'book.cancelled': 'Flights cancelled',
  'book.missed': 'Passengers left behind',
  'book.bags': 'Bags that missed the flight',
  'book.hotelGuests': 'Hotel guests',
  'book.income': 'Income',
  'book.costs': 'Costs',
  'book.profit': 'Profit',
  'book.olderSave':
    'This save began before the book: passenger and money totals are kept from this version on, departures from the start.',
  'book.passengersSay': 'What passengers say',
  'book.airlinesSay': 'What the airlines say',
  'book.airlinesAverage': 'The airlines’ average satisfaction: {pct}%',
  'book.airlinesHint': 'Click an airline for the details and the reasons.',
  'book.inbound': 'Arriving late from origin (not your doing)',
  'book.delaysLead': 'Minutes departures have lost so far, by cause:',
  'book.today': 'Yesterday and today',
  'book.delaysHint': 'An empty advisor means flights leave on time.',
  'book.col.today': 'Today',
  'book.col.yesterday': 'Yesterday',
  'book.col.average': 'Average day',
  'delayTip.0':
    'Ground services and boarding are not done yet: see on the flight card what it waits for; add ground handling, stairs and buses, and check-in capacity.',
  'delayTip.1': 'Build a terminal and join it to the motorway by road.',
  'delayTip.2':
    'No runway long enough for this aircraft: upgrade the runway (regional level 1, narrowbody 2, widebody 4, jumbo and giant freighter 5).',
  'delayTip.3':
    'No suitable stand free: add stands or upgrade them; build remote parking for long stays.',
  'delayTip.4':
    'No yellow taxi line between the runway and the stand, or it is broken: check the taxi lines end to end.',
  'delayTip.5':
    'The runway is too busy: build a second runway or spread contracts over other hours.',
  'delayTip.5.single':
    'The runway is too busy: spread the contracts over other hours. A second runway comes with tower Lv.{level}.',
  'delayTip.8.single':
    'The crosswind is over the limit: wait for the wind to turn. A second runway in another direction comes with tower Lv.{level}.',
  'delayTip.14.single':
    'The runway is shut for its upgrade: wait for it to finish. A second runway comes with tower Lv.{level}.',
  'delayTip.18.single':
    'The runway is being resurfaced: wait for it to finish. A second runway comes with tower Lv.{level}.',
  'delayTip.6': 'Night movements need runway lights: upgrade the runway to level 3.',
  'delayTip.7': 'The taxiway is blocked: add a parallel taxiway or a second link.',
  'delayTip.8': 'Crosswind above the limit: build a second runway facing another way.',
  'delayTip.9':
    'Not enough pushback tugs: upgrade the ground handling base and fill its crews; build another if the tower allows.',
  'delayTip.10':
    'Fog or sandstorms: upgrade the runway to level 3 (CAT I ILS), level 4 for the worst visibility (CAT III).',
  'delayTip.11': 'De-icing takes long: build a de-icing pad.',
  'delayTip.12': 'No fire station, or not of the level needed: build or upgrade one.',
  'delayTip.13': 'No controllers in the tower: hire controllers under Management → Staff.',
  'delayTip.14': 'The runway is closed for an upgrade: wait for it, or build a second runway.',
  'delayTip.15':
    'No service road or road reaches the stands: give the ground vehicles a way there.',
  'delayTip.16': 'The runway is under an emergency inspection: it reopens shortly.',
  'delayTip.17': 'The runway is closed for snow: strengthen the snow teams and their base.',
  'delayTip.18': 'The runway is being resurfaced: wait for it, or build a second runway.',
  'delayTip.19': 'Fighters are scrambling: a runway kept for the military protects civil traffic.',
  'delayTip.20': 'Diverted to another airport: add runway and stand capacity.',
  'delayTip.21': 'No free helipad with a road to it: add a helipad or join it to a road.',
  'delayTip.22':
    'Not enough ground vehicles: upgrade the ground handling base and fill its crews; build another if the tower allows.',
  'settings.quietToasts': 'Important notifications only',
  'settings.quietToasts.hint': 'Warnings and achievements stay; routine notifications are hidden.',
  'settings.camera': 'Camera',
  'settings.panSpeed': 'Pan speed',
  'settings.edgePan': 'Pan at the edge',
  'settings.edgePan.hint': 'The map moves when the mouse touches the edge of the screen.',
  'settings.invertZoom': 'Invert zoom',
  'settings.saving': 'Saving',
  'settings.autosave': 'Autosave',
  'settings.autosave.hint': 'The game saves by itself this often.',
  'settings.minutes': '{n} min',
  'spectate.title': 'Spectator camera',
  'spectate.chip': 'Spectator camera: watch the aircraft (C)',
  'spectate.searching': 'Looking for an aircraft to watch…',
  'spectate.follow': 'Follow',
  'spectate.cockpit': 'Cockpit',
  'spectate.tower': 'Tower',
  'spectate.trackside': 'Trackside',
  'spectate.tour': 'Tour',
  'spectate.tour.hint':
    'The camera cuts between the most interesting aircraft and angles by itself',
  'spectate.prev': 'Previous aircraft ([)',
  'spectate.next': 'Next aircraft (])',
  'spectate.exit': 'Back to the map (Esc)',
  'admin.title': 'Admin mode (temporary)',
  'admin.on': 'Turn on unlimited money',
  'admin.off': 'Turn off unlimited money',
  'admin.hint':
    'For trying things out: money never runs out. Once on, this game counts for no achievement or world ranking.',
  'admin.used': 'Admin mode was used in this game: it counts for no achievement or ranking.',
  'dgoal.title': "Today's goals",
  'dgoal.0': '{n} departures today',
  'dgoal.1': '{n} passengers today',
  'dgoal.2': '{money} revenue today',
  'dgoal.3': '{n} t of freight today',
  'dgoal.4': '{n}% of departures on time all day',
  'dgoal.5': 'No cancellations all day',
  'toast.dailyMet': 'Daily goal met: {goal} (+{reward})',
  'toast.dailyNew': "The new day's goals are in.",
  'fcard.title': 'Flight card',
  'fcard.status': 'Status',
  'fcard.aircraft': 'Aircraft',
  'fcard.stand': 'Stand',
  'fcard.contact': 'Contact stand {n}',
  'fcard.remote': 'Apron stand {n}',
  'fcard.arrival': 'Arrival',
  'fcard.departure': 'Departure',
  'fcard.late': '{time} (+{min} min late)',
  'fcard.onDay': 'day {day}, {time}',
  'fcard.reason': 'Waiting for',
  'fcard.paxIn': 'Passengers in',
  'fcard.paxOut': 'Boarded',
  'fcard.cargo': 'Freight',
  'fcard.tonnes': '{n} t',
  'fcard.service': 'Ground handling',
  'fcard.bye': 'Have a good flight! This card closes once the aircraft has gone.',
  'fcard.vip': 'VIP',
  'fcard.livery': 'Livery',
  'fcard.special': 'Special (anniversary)',
  'vip.1': 'Foreign Minister Selin Aksoy',
  'vip.2': 'Rock star Kaan Ateş',
  'vip.3': 'Tycoon Cem Taşkıran',
  'vip.4': 'Black Sea Stars FC',
  'news.spotterDeck': "New building: Spotters' Deck",
  'news.spotterDeck.text':
    'A small building from tower level 1. Put it near a runway on a road and in daylight visitors pay to watch every departure; wide-bodies and military jets draw bigger crowds. It keeps people talking well of the airport, too. Level 2 adds an upper tier.',
  'toast.goSee': 'Click to take the camera there',
  'toast.rainbow': 'The rain has stopped and there is a rainbow! Click to see it.',
  'toast.firstSnow':
    'The first snow is falling ❄️ Once it settles, people will build snowmen round the terminal ⛄ Click to see.',
  'toast.celebration':
    'Departure number {n}! The airport celebrates, and the owners send +{reward}',
  'news.terminalSound': 'The sound of the terminal',
  'news.terminalSound.text':
    'Bring the camera near a terminal and you hear the murmur of the crowd inside, louder as the queues grow; now and then its announcement chime rings.',
  'news.engineSound': 'Realistic engine sounds',
  'news.engineSound.text':
    'Aircraft sound has been rebuilt: each nearby aircraft has a voice of its own, heard left or right of the camera. The roar of full power on take-off, the fan whine of an approach, reverse thrust on landing, taxi idle, a helicopter’s blade slap; higher as they come and lower as they go (Doppler), duller far away, echoing round the airfield. Fireworks and thunder echo too.',
  'news.rainbow': 'A rainbow after the rain',
  'news.rainbow.text':
    'When the rain stops in daytime with the sun low (morning or late afternoon), a rainbow shows for a while opposite the sun, with a fainter second bow above it. Lower the camera, or watch from the spectator camera, to see it.',
  'news.celebrations': 'Departure celebrations',
  'news.celebrations.text':
    'When your airport reaches its 100th, 500th, 1000th, 2500th, 5000th… departure, fireworks go up over the terminal, social media talks about it and the owners send their congratulations (from $10,000 to $1 million).',
  'toast.airshowAnnounced':
    'An aerobatic team flies a display at 15:00 today! The spotters’ decks will be full.',
  'toast.airshow': 'The air show is on! From the decks: +{income}',
  'news.airshow': 'Air shows',
  'news.airshow.text':
    'With the tower at level 3 and at least one Spotters’ Deck, now and then (about one day in eight) an aerobatic team comes: the news in the morning, then at 15:00 four jets trailing red and white smoke fly low down the runway, loop, and finish with a bomb burst. The decks take money by their level and the airport is the talk of the town.',
  'toast.newYear': 'Happy new year! The airport sees it in with fireworks.',
  'news.fireworks': 'Fireworks',
  'news.fireworks.text':
    'A fireworks show lights up the sky over the terminal as the new year comes in, and every time the tower goes up a level. It goes on even with the game paused, and looks best at night.',
  'toast.waterSalute': "{airline}'s first flight on its new route gets a water salute!",
  'news.waterSalute': 'A water salute for first flights',
  'news.waterSalute.text':
    'When a new route’s first aircraft lands, the fire station welcomes it the way real airports do: two crash tenders line up either side of the taxiway and it taxis to its stand under an arch of water. A fire station is all it takes.',
  'toast.vipAnnounced': 'VIP coming: {who}, on {flight} departing {time}. See them off on time!',
  'toast.vipPleased': '{who} left delighted: a thank-you of +{reward}',
  'toast.vipLetDown': '{who} left disappointed, and the press has heard.',
  'fcard.follow': 'Follow with the camera',
  'fcard.close': 'Close',
  'phase.1': 'On approach',
  'phase.2': 'Landing',
  'phase.3': 'Taxiing in',
  'phase.4': 'At the stand',
  'phase.5': 'Ready for departure',
  'phase.6': 'Taxiing out',
  'phase.7': 'Taking off',
  'phase.8': 'Climbing',
  'phase.9': 'Going around',
  'photo.title': 'Photo mode',
  'photo.exit': 'Leave photo mode (Esc)',
  'photo.hour': 'Light',
  'photo.gameTime': 'game time',
  'photo.reset': 'Back to game time',
  'photo.freeze': 'Freeze',
  'photo.resume': 'Resume',
  'photo.take': 'Take photo',
  'photo.hint':
    'The interface is hidden. Set the camera with the mouse and WASD; while watching an aircraft, drag to swing round and scroll to come closer.',
  'help.key.spectate':
    'Spectator camera: an automatic tour watching the aircraft (clicking an aircraft watches it too)',
  'help.key.spectateView': 'Spectator view: follow, cockpit, tower, trackside',
  'help.key.spectateCycle': 'Watch the previous / next aircraft',
  'help.key.photo': 'Photo mode: no interface, pick the hour of the light, take a picture',
  'radio.station.tower': '{airport} Tower',
  'radio.station.ground': '{airport} Ground',
  'radio.approach.1': '{airport} Tower, {cs}, established ILS runway {rwy}.',
  'radio.approach.visual': '{airport} Tower, {cs}, visual approach runway {rwy}.',
  'radio.approach.2':
    '{cs}, {airport} Tower, wind {wdir} degrees {wspd} knots, runway {rwy} cleared to land.',
  'radio.landed.1':
    '{cs}, vacate at the first available exit, contact Ground one two one decimal seven.',
  'radio.landed.2': 'Vacating, Ground one two one decimal seven, {cs}.',
  'radio.taxiIn.1': '{airport} Ground, {cs}, on stand {stand}.',
  'radio.taxiIn.2': '{cs}, roger, good day.',
  'radio.ready.1': '{airport} Ground, {cs}, stand {stand}, ready for push and start.',
  'radio.ready.2': '{cs}, push and start approved, runway {rwy} for departure.',
  'radio.taxiOut.1': '{cs}, taxi to holding point runway {rwy}.',
  'radio.taxiOut.2': 'Taxi to holding point runway {rwy}, {cs}.',
  'radio.takeoff.1': '{airport} Tower, {cs}, holding point runway {rwy}, ready for departure.',
  'radio.takeoff.2': '{cs}, wind {wdir} degrees {wspd} knots, runway {rwy} cleared for take-off.',
  'radio.climb.1': '{cs}, contact Approach, good flight.',
  'radio.climb.2': 'Contact Approach, good day, {cs}.',
  'radio.goAround.1': '{airport} Tower, {cs}, going around.',
  'radio.goAround.2':
    '{cs}, roger, climb runway heading three thousand feet, expect vectors for another approach.',
  'radio.mayday.1':
    'Mayday, mayday, mayday, {cs}, declaring an emergency, request priority landing.',
  'radio.mayday.2': '{cs}, roger mayday, runway {rwy} is yours, emergency services standing by.',
  'settings.radio': 'Tower radio',
  'settings.radio.hint': 'The calls between the aircraft and the tower, written in a log.',
  'settings.radio.text': 'Written',
  'radio.title': 'Tower frequency',
  'ops.tab.apron': 'Apron plan',
  'ops.tab.album': 'Album',
  'album.collected': 'Airline album {pct}% complete',
  'album.kind.domestic': 'Domestic',
  'album.kind.international': 'International',
  'album.kind.cargo': 'Cargo',
  'album.kind.private': 'Private jets',
  'album.kind.heli': 'Helicopters',
  'album.kind.military': 'Military',
  'album.need.domestic': 'Sign a contract and see its first flight off',
  'album.need.international': 'Needs passport control (terminal level 2)',
  'album.need.cargo': 'Needs a cargo terminal',
  'album.need.private': 'Comes with the first tower',
  'album.need.heli': 'Needs a helipad',
  'album.need.military': 'Needs the military zone (tower level 3)',
  'toast.albumNew': 'New airline in the album: {airline} ({n}/{total})',
  'news.advice': 'What an offer needs',
  'news.advice.text':
    'Open an offer the airport cannot fly as written and a window says what is missing and what to do (runway, stand, fire cover, terminal, cargo terminal, night lights).',
  'news.sizes': 'Runways, stands and positions in three sizes',
  'news.sizes.text':
    'Small stands for small single-engine aircraft; the existing ones carry on as the medium size; tower level 3 opens large stands and parking positions. The large ones can be open to all or kept for the big ones. Widebodies take a large stand first. (The runway has since become one runway with five levels.)',
  'news.giants': 'The giants: a 747 type and an Antonov type',
  'news.giants.text':
    'The jumbo (tower level 4) and the giant freighter carrying 150 tonnes (tower level 3) land on a level 5 runway and park on a large stand only. Flying clubs and flight schools bring small single-engine aircraft too.',
  'news.militaryTower': 'Military tower',
  'news.militaryTower.text':
    "The military zone's own tower: each level brings the ministry's offers more often and allows more military offers and contracts at once.",
  'news.delayAlerts': 'Alerts for extreme delays',
  'news.delayAlerts.text':
    'A departure over 3 hours late or an arrival unable to land for over 45 minutes stops the game and tells you why and what to do. "Don’t show this cause again" mutes it. Also fixed: aircraft standing on remote positions for days.',
  'news.boom': 'A sonic boom to make you jump',
  'news.boom.text':
    'Jets passing over now crack a real double sonic boom, with a thump you feel and a roll of thunder going away. Fighter engines sound harder too.',
  'news.tollIncome': 'Toll income',
  'news.tollIncome.text':
    'When the way in from the motorway to a terminal passes a toll plaza, every departing passenger pays a $0.50 toll (once, however many plazas are on the way). A "Tolls" line in the accounts.',
  'news.serviceTunnels': 'Service tunnels under taxiways',
  'news.serviceTunnels.text':
    'Draw a service road across a taxiway and it now goes under it in a tunnel: the taxiway stays, ground vehicles go down a ramp and under it to the other side, without waiting for aircraft passing above. A service road ending on a taxiway is carried on to the far side.',
  'news.tolls': 'Toll plazas on their own',
  'news.tolls.text':
    'A new Toll plaza tool (0): click a road and the plaza spans its whole width; click a plaza to take it off. Joining the motorway no longer puts one there by itself. The barriers stay up and cars pass without stopping; with several ways in, each driver takes the one nearest the way they come.',
  'news.insulation': 'A bigger noise quota',
  'news.insulation.text':
    "The night noise quota grows by 4 points with each tower level. From the dB button's card you can insulate the homes round the airport to raise it for good (3 steps, +12 points each). Tower level 4 allows 4 runways.",
  'news.militaryRoads': 'Military zone: service roads and hints',
  'news.militaryRoads.text':
    "The military gate can be joined by a service road too; shelters and military aprons want a service road rather than a road. The military buildings' cards say what goes where, as the civil ones do. The air force's posts read like the real thing now.",
  'news.look': 'Balanced light',
  'news.look.text':
    'Daytime is less glaring (the H on the helipad reads again), the moonlight lights the airport at night, and the stand floor is a greyer concrete without joints.',
  'news.flyby': 'Jets passing over',
  'news.flyby.text':
    'From the third day, now and then fighters (grey, dark or desert) or the red and white display jet cross the whole map high over the woods beyond the airport; some leave a thin smoke trail. As they pass closest to the camera you hear a boom close to a sonic one.',
  'news.sharp': 'A sharper picture, three times the frame rate',
  'news.sharp.text':
    "Shadows, smart upscaling, ambient occlusion, the miniature focus, high-DPI and automatic smoothness are gone: in the players' own trial the picture was sharper with them off, and the frame rate three times higher (50 → 150). The game is drawn at the screen's resolution with edge smoothing.",
  'news.onTime': 'Aircraft leave at the time on the card',
  'news.onTime.text':
    'Night stops and parking rentals are now really towed to a remote position and, while they wait, hold no stand, stairs, baggage train or tug, so other aircraft are served and leave on time. A late flight shows its delay and why on its flight card (night lighting, wind, vehicles busy…).',
  'news.apron': 'Stands side by side share an apron',
  'news.apron.text':
    'Stands that touch edge to edge (contact and remote ones too) now make one apron: if one has a service road, the ones beside it need none of their own; the vehicles drive across. A contact stand placed beside a linked one lays no road of its own.',
  'news.snowmen': 'Snowmen',
  'news.snowmen.text':
    "Once the snow settles, snowmen are built one by one on the grass round the terminal, hotel, station and car parks (hat, scarf, carrot nose); when it thaws they slump and melt. Each winter's first snow brings a notice that takes the camera there.",
  'news.weatherOutlook': 'Weather outlook and snowy winters',
  'news.weatherOutlook.text':
    'Click the weather in the top bar: beside the coming hours there is a 7-day outlook (lows and highs, the chance of snow, rain or storms, the blizzard day) and a strip of the seasons showing how far off winter is. Winter (days 22–28 of every year) is now properly snowy: it snows on most days.',
  'news.freeBrush': 'Free road drawing',
  'news.freeBrush.text':
    'Roads and taxiways no longer snap to a 4-tile grid: they are drawn tile by tile from wherever the cursor starts to wherever it ends. Start on or at the end of a road and the new one carries on in line with it; turn off the side of a road and the corner closes edge to edge. Click in (or drag across) a narrow gap between a building and a runway, or two buildings, and the road is cut to fit it exactly.',
  'news.buildSites': 'Living building sites',
  'news.buildSites.text':
    'Cranes, excavators, dump trucks and hard-hatted workers on every site; dust rises, welding sparks fly, floodlights come on at night and you hear the hammering up close. A finished building settles into place in four steps: tak, tak, tak.',
  'news.album': 'The airline album',
  'news.album.text':
    'A new tab in the flights panel: every airline that flies from your airport goes into the album with its card; those still to come wait locked, saying what they need (a cargo terminal, a helipad, the military zone…). You see how many you have and the percentage; 20 airlines earn the Collector achievement.',
  'apron.stand': 'Stand {n}',
  'apron.unassigned': 'Unassigned',
  'apron.busy': 'Stands in use',
  'apron.late': 'Running late',
  'apron.clashes': 'Clashes',
  'apron.none': 'No stands yet.',
  'apron.hint':
    'Each row is a stand; bars run from an aircraft’s arrival to its departure. Orange: past its departure time; red: two flights on one stand. A vehicle shown in red above is all out: buy another. Click a stand to select it on the map.',
  'apron.tone.planned': 'planned',
  'apron.tone.on': 'on stand',
  'apron.tone.late': 'running late',
  'apron.tone.clash': 'clash',
  'building.largeDeicePad': 'Large De-icing Pad',
  'desc.largeDeicePad':
    'A de-icing pad for widebodies, jumbos and giant freighters: a spray gantry spanning the wings and four trucks. They do not fit the smaller pad; without this one they are de-iced by truck on their stands in icing weather, more slowly. Smaller aircraft may use it too. Connect it to a taxiway. Needs Tower Lv.4, at most 2.',
  'building.directorate': 'Airport Directorate',
  'desc.directorate':
    "The management's four-storey office plaza with the staff car park. Click it to open the report book: how the airport stands now, every departure and passenger so far and what pleases or displeases people, page by page and live. It must be connected by a service road: the staff drive in on it. Needs Tower Lv.3.",
  'building.deicePad': 'De-icing Pad',
  'desc.deicePad':
    'In icing weather aircraft are de-iced here on their way to the runway rather than on their stand: the stand is free at once, the fixed spray towers are faster than a truck and there is no fee per aircraft. Widebodies, jumbos and giant freighters do not fit: build a Large De-icing Pad for them. Connect it to a taxiway. Needs Tower Lv.3.',
  'phase.10': 'De-icing',
  'radio.taxiPad.1': '{cs}, push complete, taxi to the de-icing pad.',
  'radio.taxiPad.2': 'Taxi to the de-icing pad, {cs}.',
  'radio.deice.1': '{airport} Ground, {cs}, on the de-icing pad, engines at idle.',
  'radio.deice.2':
    '{cs}, de-icing commencing, type four fluid; contact Tower for departure when complete.',
  'radio.lvp.on':
    'All stations, {airport} Tower: low visibility procedures in force, visibility {vis} metres. ILS approaches only.',
  'radio.lvp.off': 'All stations, {airport} Tower: low visibility procedures cancelled.',
  'building.remoteParking': 'Remote Parking Position',
  'desc.remoteParking':
    'A plain apron where aircraft wait between flights: night stops and parking rentals stand here and pay by the hour. A tug tows the aircraft here from its stand, freeing it, and back before departure. No services, no road needed; connect it to a taxiway. Needs Tower Lv.2.',
  'building.smallRunway': 'Small Runway (old)',
  'desc.smallRunway':
    'A short, narrow strip for small single-engine aircraft: flying clubs, flight schools and air taxis. No lights (day flying only). Cheap and quick to build; connect it to a taxiway. Needs Tower Lv.1.',
  'building.largeRunway': 'Large Runway (old)',
  'desc.largeRunway':
    'A long, wide runway: jumbos and giant freighters land on nothing else; lights and ILS from the start. Open to all or kept for the big aircraft. Needs Tower Lv.3.',
  'building.smallStand': 'Small Stand',
  'desc.smallStand':
    'A stand for small single-engine aircraft: tie-down rings and chocks. Small aircraft take one first. Connect a service road and a taxiway. Needs Tower Lv.1.',
  'building.largeStand': 'Large Stand',
  'desc.largeStand':
    'A stand for widebodies, jumbos and giant freighters: widebodies fit no other stand. Open to all or kept for the big aircraft. Connect a service road and a taxiway. Needs Tower Lv.3.',
  'building.smallParking': 'Small Parking Position',
  'desc.smallParking':
    'Where small aircraft wait for long. No services; connect it to a taxiway. Needs Tower Lv.1.',
  'building.largeParking': 'Large Parking Position',
  'desc.largeParking':
    'A wide position where the giants stay the night or park for rent. Can be kept for the big aircraft. No services; connect it to a taxiway. Needs Tower Lv.3.',
  'building.militaryTower': 'Military Tower',
  'desc.militaryTower':
    "The military zone's control tower: each level brings the ministry's offers more often, and more military offers open at once and contracts per unit. Needs the military gate. Needs Tower Lv.3.",
  'class.9': 'Small single-engine',
  'class.10': 'Jumbo',
  'class.11': 'Giant freighter',
  'bigOnly.title': 'Who uses it',
  'bigOnly.all': 'Open to all',
  'bigOnly.big': 'Big ones only',
  'bigOnly.allHint': 'Aircraft of every size may use it; the big ones still come here first.',
  'bigOnly.bigHint':
    'Only the big aircraft (widebodies, jumbos, giant freighters) come here; the smaller ones keep away.',
  'phase.11': 'Under tow',
  'phase.12': 'Parked',
  'rental.chip': 'Parking rental',
  'rental.days': '{n} days parked',
  'rental.total': '≈ {amount} in parking charges',
  'rental.paper':
    'Arrives at {time} and stands on a remote position for {n} days; charged by the hour, about {amount} in all. Then towed to a stand, prepared and away.',
  'ledger.aircraftParking': 'Aircraft parking charges',
  'ledger.tolls': 'Tolls',
  'apron.remote': 'Remote {n}',
  'radio.towOut.1': '{airport} Ground, {cs}, passengers off, ready to be towed to remote parking.',
  'radio.towOut.2': '{cs}, tow approved, to the remote position.',
  'radio.towIn.1':
    '{airport} Ground, {cs}, on remote parking, request tow to a stand for departure.',
  'radio.towIn.2': '{cs}, tow approved, stand {stand}.',
  'news.parking': 'Aircraft parking and rentals',
  'news.parking.text':
    'New Remote Parking Position: some late-evening arrivals stay the night and leave in the morning. Once the passengers are off a tug tows the aircraft to remote parking, freeing its stand, and back before departure. Airlines also offer parking rentals for a few days. Parked aircraft pay by the hour.',
  'news.deicePad': 'De-icing pad',
  'news.deicePad.text':
    'In icing weather aircraft are de-iced on a pad on the way to the runway rather than on their stand: the stand is free at once, it is faster and costs no fee. In fog the tower announces low visibility procedures.',
  'news.spectator': 'Spectator camera and photo mode',
  'news.spectator.text':
    'Click an aircraft: follow, cockpit, tower and trackside views. C for an automatic tour, P for photo mode (hour of the light, freeze, save a PNG).',
  'news.radio': 'Tower radio',
  'news.radio.text':
    'Calls between the pilots and tower and ground control, made from what really happens, shown in a written log. Can be turned off in the settings.',
  'news.apronPlan': 'Apron plan',
  'news.apronPlan.text':
    'A new tab in the flights window: stands on a timeline, delays and clashes in colour, the ground fleet’s use on top.',
  'news.trafficAi': 'Smarter traffic',
  'news.trafficAi.text':
    'Vehicles pull away and brake smoothly, slow for bends and overtake on the motorway. The ground vehicles now keep the rules of the road too: the right-hand lane both ways, the same turn at junctions as the cars, never stopping inside one. The game menu also opens much faster.',
};
